var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24, _clipPath25, _clipPath26, _clipPath27, _clipPath28, _clipPath29, _clipPath30, _clipPath31, _clipPath32, _clipPath33, _clipPath34, _clipPath35, _clipPath36, _clipPath37, _clipPath38, _clipPath39, _clipPath40, _clipPath41, _clipPath42, _clipPath43, _clipPath44, _clipPath45, _clipPath46, _clipPath47, _clipPath48, _clipPath49, _clipPath50, _clipPath51, _clipPath52, _clipPath53, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMosheRemovebgPreviewMin32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(71.372549%,69.803922%,69.019608%)",
      fillOpacity: 1
    },
    d: "M 17.914062 3.09375 L 17.425781 3.09375 L 17.425781 3.304688 L 17.078125 3.304688 L 17.078125 3.234375 C 17.257812 3.148438 17.441406 3.078125 17.636719 3.027344 C 17.742188 3.027344 17.835938 3.050781 17.914062 3.09375 Z M 17.914062 3.09375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.694118,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(41.176471%,39.607843%,38.431373%)",
      fillOpacity: 1
    },
    d: "M 17.078125 3.234375 L 17.078125 3.304688 L 13.878906 3.304688 L 13.878906 3.234375 C 14.941406 3.152344 16.011719 3.152344 17.078125 3.234375 Z M 17.078125 3.234375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.176471,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface11",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(58.431373%,56.862745%,55.686275%)",
      fillOpacity: 1
    },
    d: "M 17.984375 3.09375 C 18.511719 3.160156 19.023438 3.277344 19.511719 3.445312 C 18.984375 3.378906 18.472656 3.261719 17.984375 3.09375 Z M 17.984375 3.09375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.176471,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface14",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(63.921569%,62.745098%,61.568627%)",
      fillOpacity: 1
    },
    d: "M 19.582031 3.445312 C 19.699219 3.453125 19.789062 3.5 19.859375 3.582031 L 19.652344 3.582031 Z M 19.582031 3.445312 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.462745,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface17",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(54.509804%,52.54902%,51.764706%)",
      fillOpacity: 1
    },
    d: "M 13.878906 3.234375 L 13.878906 3.304688 C 13.890625 3.394531 13.867188 3.476562 13.808594 3.546875 C 13.210938 3.71875 12.609375 3.871094 12 4 C 12.570312 3.792969 13.148438 3.617188 13.738281 3.476562 C 13.777344 3.390625 13.824219 3.3125 13.878906 3.234375 Z M 13.878906 3.234375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface20",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(75.686275%,74.901961%,74.117647%)",
      fillOpacity: 1
    },
    d: "M 20.695312 3.792969 C 20.808594 3.695312 20.902344 3.71875 20.972656 3.859375 Z M 20.695312 3.792969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.611765,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface23",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(52.54902%,50.980392%,49.803922%)",
      fillOpacity: 1
    },
    d: "M 20.972656 3.859375 C 21.09375 3.898438 21.1875 3.96875 21.253906 4.070312 C 21.105469 4.066406 21.011719 3.996094 20.972656 3.859375 Z M 20.972656 3.859375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.713725,
      stroke: "none"
    }
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface26",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(56.470588%,54.117647%,52.941176%)",
      fillOpacity: 1
    },
    d: "M 11.929688 4 C 11.84375 4.125 11.800781 4.261719 11.792969 4.417969 C 11.714844 4.316406 11.703125 4.199219 11.757812 4.070312 C 11.804688 4.015625 11.859375 3.992188 11.929688 4 Z M 11.929688 4 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.611765,
      stroke: "none"
    }
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface29",
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(49.411765%,47.843137%,46.666667%)",
      fillOpacity: 1
    },
    d: "M 11.859375 4.417969 C 12.003906 4.394531 12.148438 4.421875 12.277344 4.488281 C 12.121094 4.632812 11.9375 4.703125 11.722656 4.695312 C 11.816406 4.605469 11.929688 4.546875 12.070312 4.523438 C 11.984375 4.503906 11.914062 4.472656 11.859375 4.417969 Z M 11.859375 4.417969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.407843,
      stroke: "none"
    }
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface32",
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(53.72549%,51.764706%,50.196078%)",
      fillOpacity: 1
    },
    d: "M 11.304688 4.90625 C 11.140625 5.035156 10.957031 5.128906 10.746094 5.183594 C 10.894531 5.023438 11.082031 4.933594 11.304688 4.90625 Z M 11.304688 4.90625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.929412,
      stroke: "none"
    }
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface35",
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(16.470588%,13.333333%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 19.652344 3.582031 L 19.859375 3.582031 C 20.066406 3.617188 20.25 3.6875 20.417969 3.792969 C 20.441406 3.859375 20.488281 3.90625 20.554688 3.929688 C 20.609375 4.066406 20.703125 4.125 20.835938 4.105469 C 20.726562 4.027344 20.679688 3.921875 20.695312 3.792969 L 20.972656 3.859375 C 21.011719 3.996094 21.105469 4.066406 21.253906 4.070312 C 21.570312 4.285156 21.863281 4.539062 22.121094 4.835938 C 22.632812 5.671875 23.109375 6.53125 23.546875 7.410156 C 23.609375 7.730469 23.703125 7.753906 23.824219 7.476562 C 23.910156 7.425781 24.003906 7.402344 24.105469 7.410156 C 24.203125 7.671875 24.179688 7.925781 24.035156 8.175781 C 23.917969 8.074219 23.859375 7.933594 23.859375 7.757812 C 23.710938 7.839844 23.570312 7.816406 23.445312 7.6875 C 22.980469 6.863281 22.542969 6.027344 22.121094 5.183594 C 21.945312 5.03125 21.792969 4.855469 21.667969 4.660156 C 21.535156 4.554688 21.382812 4.46875 21.21875 4.417969 C 21.164062 4.421875 21.128906 4.445312 21.113281 4.488281 C 20.964844 4.496094 20.820312 4.460938 20.695312 4.382812 C 20.382812 4.035156 20.011719 3.789062 19.582031 3.652344 C 19.582031 3.605469 19.605469 3.582031 19.652344 3.582031 Z M 19.652344 3.582031 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.784314,
      stroke: "none"
    }
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface38",
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(47.058824%,44.705882%,43.137255%)",
      fillOpacity: 1
    },
    d: "M 20.695312 3.792969 C 20.679688 3.921875 20.726562 4.027344 20.835938 4.105469 C 20.703125 4.125 20.609375 4.066406 20.554688 3.929688 Z M 20.695312 3.792969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface41",
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(81.176471%,80%,78.823529%)",
      fillOpacity: 1
    },
    d: "M 20.417969 3.792969 C 20.511719 3.792969 20.554688 3.835938 20.554688 3.929688 C 20.488281 3.90625 20.441406 3.859375 20.417969 3.792969 Z M 20.417969 3.792969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.576471,
      stroke: "none"
    }
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface44",
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(54.901961%,52.54902%,50.980392%)",
      fillOpacity: 1
    },
    d: "M 10.746094 5.390625 C 11.023438 5.449219 11.300781 5.472656 11.582031 5.460938 C 11.542969 5.640625 11.472656 5.800781 11.375 5.949219 C 11.144531 5.925781 10.9375 5.972656 10.746094 6.085938 C 10.902344 5.882812 11.109375 5.765625 11.375 5.738281 L 11.445312 5.601562 C 11.238281 5.542969 11.027344 5.507812 10.816406 5.496094 C 10.777344 5.46875 10.753906 5.433594 10.746094 5.390625 Z M 10.746094 5.390625 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.611765,
      stroke: "none"
    }
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface47",
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(46.666667%,44.705882%,43.529412%)",
      fillOpacity: 1
    },
    d: "M 10.746094 6.085938 C 10.671875 6.230469 10.554688 6.324219 10.398438 6.363281 C 10.476562 6.21875 10.589844 6.128906 10.746094 6.085938 Z M 10.746094 6.085938 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface50",
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(57.254902%,54.901961%,53.333333%)",
      fillOpacity: 1
    },
    d: "M 9.984375 6.851562 C 10.085938 7.003906 10.039062 7.097656 9.84375 7.128906 C 9.921875 7.054688 9.964844 6.960938 9.984375 6.851562 Z M 9.984375 6.851562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.407843,
      stroke: "none"
    }
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface53",
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(55.294118%,53.333333%,52.54902%)",
      fillOpacity: 1
    },
    d: "M 9.84375 7.128906 C 9.753906 7.292969 9.613281 7.382812 9.425781 7.410156 C 9.539062 7.28125 9.679688 7.1875 9.84375 7.128906 Z M 9.84375 7.128906 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.407843,
      stroke: "none"
    }
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface56",
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(56.078431%,54.509804%,53.72549%)",
      fillOpacity: 1
    },
    d: "M 24.105469 7.410156 C 24.003906 7.402344 23.910156 7.425781 23.824219 7.476562 C 23.902344 7.277344 23.992188 7.253906 24.105469 7.410156 Z M 24.105469 7.410156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.568627,
      stroke: "none"
    }
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface59",
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(49.803922%,47.843137%,47.058824%)",
      fillOpacity: 1
    },
    d: "M 9.425781 7.410156 C 9.394531 7.507812 9.324219 7.554688 9.21875 7.546875 C 9.25 7.449219 9.320312 7.402344 9.425781 7.410156 Z M 9.425781 7.410156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.407843,
      stroke: "none"
    }
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface62",
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(50.980392%,49.019608%,47.843137%)",
      fillOpacity: 1
    },
    d: "M 9.21875 7.546875 C 9.164062 7.671875 9.070312 7.738281 8.9375 7.757812 C 8.992188 7.632812 9.085938 7.5625 9.21875 7.546875 Z M 9.21875 7.546875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.788235,
      stroke: "none"
    }
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface65",
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(47.843137%,44.705882%,42.745098%)",
      fillOpacity: 1
    },
    d: "M 23.546875 7.410156 C 23.632812 7.523438 23.722656 7.546875 23.824219 7.476562 C 23.703125 7.753906 23.609375 7.730469 23.546875 7.410156 Z M 23.546875 7.410156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface68",
    clipPath: "url(#clip22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(72.54902%,70.588235%,69.411765%)",
      fillOpacity: 1
    },
    d: "M 23.894531 8.3125 L 23.894531 8.523438 C 23.984375 8.503906 24.054688 8.527344 24.105469 8.589844 C 23.988281 8.605469 23.886719 8.582031 23.792969 8.523438 C 23.75 8.417969 23.785156 8.347656 23.894531 8.3125 Z M 23.894531 8.3125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.101961,
      stroke: "none"
    }
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface71",
    clipPath: "url(#clip23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(62.745098%,61.176471%,60%)",
      fillOpacity: 1
    },
    d: "M 24.453125 8.730469 C 24.558594 8.726562 24.628906 8.773438 24.660156 8.871094 C 24.554688 8.875 24.484375 8.828125 24.453125 8.730469 Z M 24.453125 8.730469 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.611765,
      stroke: "none"
    }
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface74",
    clipPath: "url(#clip24)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(51.372549%,49.411765%,48.627451%)",
      fillOpacity: 1
    },
    d: "M 8.660156 9.285156 L 8.660156 9.355469 C 8.472656 10.019531 8.238281 10.671875 7.964844 11.304688 C 8.140625 10.613281 8.375 9.9375 8.660156 9.285156 Z M 8.660156 9.285156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.870588,
      stroke: "none"
    }
  }))), _clipPath25 || (_clipPath25 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface77",
    clipPath: "url(#clip25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(16.078431%,12.941176%,11.372549%)",
      fillOpacity: 1
    },
    d: "M 8.660156 9.355469 C 8.824219 9.433594 8.847656 9.550781 8.730469 9.703125 C 8.578125 10.117188 8.4375 10.535156 8.3125 10.957031 C 8.25 11.03125 8.226562 11.125 8.242188 11.234375 C 8.09375 11.566406 8 11.917969 7.964844 12.277344 C 7.902344 12.742188 7.832031 13.207031 7.757812 13.667969 C 7.742188 13.859375 7.789062 14.019531 7.894531 14.15625 C 8.046875 14.113281 8.1875 14.160156 8.3125 14.296875 C 8.351562 14.398438 8.351562 14.515625 8.3125 14.644531 C 8.175781 14.625 8.074219 14.671875 8 14.78125 L 7.929688 14.714844 C 7.824219 14.835938 7.765625 14.949219 7.757812 15.0625 C 7.59375 14.949219 7.59375 14.820312 7.757812 14.679688 C 7.71875 14.652344 7.695312 14.617188 7.6875 14.574219 C 7.589844 13.640625 7.636719 12.714844 7.824219 11.792969 C 7.925781 11.652344 7.972656 11.488281 7.964844 11.304688 C 8.238281 10.671875 8.472656 10.019531 8.660156 9.355469 Z M 8.660156 9.355469 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.164706,
      stroke: "none"
    }
  }))), _clipPath26 || (_clipPath26 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface80",
    clipPath: "url(#clip26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(35.294118%,34.117647%,33.72549%)",
      fillOpacity: 1
    },
    d: "M 7.964844 11.304688 C 7.972656 11.488281 7.925781 11.652344 7.824219 11.792969 C 7.796875 11.796875 7.773438 11.785156 7.757812 11.757812 C 7.816406 11.601562 7.886719 11.453125 7.964844 11.304688 Z M 7.964844 11.304688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.243137,
      stroke: "none"
    }
  }))), _clipPath27 || (_clipPath27 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface83",
    clipPath: "url(#clip27)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(71.372549%,69.411765%,68.235294%)",
      fillOpacity: 1
    },
    d: "M 7.128906 14.503906 C 6.898438 14.421875 6.664062 14.421875 6.433594 14.503906 C 6.503906 14.398438 6.609375 14.351562 6.746094 14.363281 C 6.902344 14.359375 7.03125 14.402344 7.128906 14.503906 Z M 7.128906 14.503906 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask27"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath28 || (_clipPath28 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface86",
    clipPath: "url(#clip28)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(65.490196%,63.137255%,61.568627%)",
      fillOpacity: 1
    },
    d: "M 6.433594 14.503906 C 6.441406 14.609375 6.394531 14.679688 6.296875 14.714844 C 6.289062 14.605469 6.335938 14.539062 6.433594 14.503906 Z M 6.433594 14.503906 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath29 || (_clipPath29 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface89",
    clipPath: "url(#clip29)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(61.176471%,58.431373%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 7.269531 14.574219 C 7.347656 14.652344 7.4375 14.695312 7.546875 14.714844 C 7.546875 14.820312 7.5 14.855469 7.410156 14.816406 C 7.316406 14.761719 7.269531 14.679688 7.269531 14.574219 Z M 7.269531 14.574219 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.156863,
      stroke: "none"
    }
  }))), _clipPath30 || (_clipPath30 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface92",
    clipPath: "url(#clip30)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(72.54902%,70.980392%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 6.296875 14.714844 C 6.238281 15.152344 6.214844 15.59375 6.226562 16.035156 L 6.226562 16.242188 C 6.171875 16.140625 6.125 16.039062 6.085938 15.929688 C 6.117188 15.511719 6.1875 15.105469 6.296875 14.714844 Z M 6.296875 14.714844 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath31 || (_clipPath31 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface95",
    clipPath: "url(#clip31)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(60.784314%,58.039216%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 24.382812 16.3125 C 24.390625 16.429688 24.414062 16.546875 24.453125 16.660156 C 24.304688 16.566406 24.28125 16.449219 24.382812 16.3125 Z M 24.382812 16.3125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.462745,
      stroke: "none"
    }
  }))), _clipPath32 || (_clipPath32 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface98",
    clipPath: "url(#clip32)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(52.54902%,50.980392%,49.411765%)",
      fillOpacity: 1
    },
    d: "M 24.453125 16.660156 C 24.542969 16.8125 24.519531 16.953125 24.382812 17.078125 C 24.382812 16.9375 24.40625 16.796875 24.453125 16.660156 Z M 24.453125 16.660156 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.956863,
      stroke: "none"
    }
  }))), _clipPath33 || (_clipPath33 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface101",
    clipPath: "url(#clip33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(31.764706%,28.627451%,26.666667%)",
      fillOpacity: 1
    },
    d: "M 25.285156 17.984375 C 25.171875 18.03125 25.125 18.121094 25.148438 18.261719 C 24.929688 17.960938 24.628906 17.824219 24.242188 17.84375 L 24.242188 17.703125 C 24.4375 17.625 24.648438 17.613281 24.871094 17.667969 C 25.0625 17.714844 25.203125 17.816406 25.285156 17.984375 Z M 25.285156 17.984375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.87451,
      stroke: "none"
    }
  }))), _clipPath34 || (_clipPath34 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface104",
    clipPath: "url(#clip34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(15.686275%,12.156863%,10.196078%)",
      fillOpacity: 1
    },
    d: "M 6.78125 19.09375 C 6.78125 19.1875 6.734375 19.234375 6.644531 19.234375 C 6.546875 19.136719 6.472656 19.019531 6.433594 18.886719 C 6.339844 18.058594 6.503906 17.292969 6.921875 16.589844 C 6.96875 16.546875 7.015625 16.5 7.0625 16.453125 L 7.128906 16.523438 C 6.941406 16.851562 6.789062 17.203125 6.679688 17.566406 C 6.507812 18.097656 6.542969 18.609375 6.78125 19.09375 Z M 6.78125 19.09375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.921569,
      stroke: "none"
    }
  }))), _clipPath35 || (_clipPath35 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface107",
    clipPath: "url(#clip35)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(19.607843%,17.254902%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 25.285156 17.984375 C 25.4375 18.269531 25.460938 18.570312 25.355469 18.886719 C 25.3125 18.894531 25.277344 18.917969 25.253906 18.957031 C 25.238281 18.757812 25.203125 18.570312 25.148438 18.398438 L 25.148438 18.261719 C 25.125 18.121094 25.171875 18.03125 25.285156 17.984375 Z M 25.285156 17.984375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.85098,
      stroke: "none"
    }
  }))), _clipPath36 || (_clipPath36 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface110",
    clipPath: "url(#clip36)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(33.333333%,29.411765%,27.058824%)",
      fillOpacity: 1
    },
    d: "M 25.148438 18.398438 C 25.203125 18.570312 25.238281 18.757812 25.253906 18.957031 C 25.277344 18.917969 25.3125 18.894531 25.355469 18.886719 C 25.316406 19.042969 25.222656 19.160156 25.078125 19.234375 C 25.03125 19.234375 25.007812 19.210938 25.007812 19.164062 C 25.128906 18.925781 25.175781 18.671875 25.148438 18.398438 Z M 25.148438 18.398438 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.901961,
      stroke: "none"
    }
  }))), _clipPath37 || (_clipPath37 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface113",
    clipPath: "url(#clip37)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(47.843137%,41.960784%,38.039216%)",
      fillOpacity: 1
    },
    d: "M 6.78125 19.09375 C 6.835938 19.179688 6.90625 19.25 6.992188 19.304688 C 7.019531 19.390625 7.066406 19.472656 7.128906 19.546875 C 6.996094 19.695312 6.972656 19.847656 7.0625 20 C 7.039062 20.070312 6.992188 20.117188 6.921875 20.140625 C 6.941406 20.007812 6.917969 19.890625 6.851562 19.792969 C 6.859375 19.574219 6.789062 19.390625 6.644531 19.234375 C 6.734375 19.234375 6.78125 19.1875 6.78125 19.09375 Z M 6.78125 19.09375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask37"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.4,
      stroke: "none"
    }
  }))), _clipPath38 || (_clipPath38 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface116",
    clipPath: "url(#clip38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(55.294118%,51.764706%,49.411765%)",
      fillOpacity: 1
    },
    d: "M 25.007812 19.164062 C 25.007812 19.210938 25.03125 19.234375 25.078125 19.234375 C 24.96875 19.382812 24.824219 19.5 24.660156 19.582031 C 24.652344 19.378906 24.769531 19.238281 25.007812 19.164062 Z M 25.007812 19.164062 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0509804,
      stroke: "none"
    }
  }))), _clipPath39 || (_clipPath39 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface119",
    clipPath: "url(#clip39)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(75.686275%,74.509804%,74.117647%)",
      fillOpacity: 1
    },
    d: "M 6.851562 19.792969 C 6.917969 19.890625 6.941406 20.007812 6.921875 20.140625 C 6.925781 20.246094 6.878906 20.316406 6.78125 20.347656 C 6.835938 20.167969 6.859375 19.980469 6.851562 19.792969 Z M 6.851562 19.792969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask39"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.901961,
      stroke: "none"
    }
  }))), _clipPath40 || (_clipPath40 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface122",
    clipPath: "url(#clip40)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(20.392157%,16.862745%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 7.0625 20 C 7.105469 20 7.128906 20.023438 7.128906 20.070312 C 7.113281 20.179688 7.066406 20.269531 6.992188 20.347656 C 6.769531 20.597656 6.734375 20.875 6.886719 21.183594 C 7.105469 21.273438 7.328125 21.273438 7.546875 21.183594 C 7.605469 21.207031 7.628906 21.253906 7.617188 21.320312 C 7.242188 21.613281 6.917969 21.566406 6.644531 21.183594 L 6.644531 20.554688 C 6.636719 20.449219 6.683594 20.378906 6.78125 20.347656 C 6.878906 20.316406 6.925781 20.246094 6.921875 20.140625 C 6.992188 20.117188 7.039062 20.070312 7.0625 20 Z M 7.0625 20 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.941176,
      stroke: "none"
    }
  }))), _clipPath41 || (_clipPath41 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface125",
    clipPath: "url(#clip41)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(26.27451%,23.529412%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 24.382812 19.929688 C 24.382812 19.976562 24.40625 20 24.453125 20 C 24.527344 20.25 24.539062 20.503906 24.488281 20.765625 C 24.308594 20.980469 24.101562 21.167969 23.859375 21.320312 L 23.6875 21.667969 C 23.574219 21.722656 23.527344 21.816406 23.546875 21.949219 L 23.546875 22.15625 C 23.425781 22.082031 23.378906 21.96875 23.410156 21.808594 C 23.503906 21.671875 23.59375 21.53125 23.6875 21.390625 C 23.652344 21.34375 23.601562 21.308594 23.546875 21.285156 C 23.648438 21.261719 23.71875 21.203125 23.757812 21.113281 C 23.960938 21.035156 24.101562 20.894531 24.175781 20.695312 C 24.230469 20.359375 24.265625 20.011719 24.277344 19.652344 C 24.292969 19.761719 24.328125 19.851562 24.382812 19.929688 Z M 24.382812 19.929688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.254902,
      stroke: "none"
    }
  }))), _clipPath42 || (_clipPath42 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface128",
    clipPath: "url(#clip42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(43.921569%,42.352941%,41.568627%)",
      fillOpacity: 1
    },
    d: "M 6.644531 20.554688 L 6.644531 21.183594 C 6.507812 20.960938 6.507812 20.753906 6.644531 20.554688 Z M 6.644531 20.554688 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath43 || (_clipPath43 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface131",
    clipPath: "url(#clip43)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(79.607843%,71.372549%,65.882353%)",
      fillOpacity: 1
    },
    d: "M 23.339844 19.859375 C 23.363281 19.917969 23.410156 19.941406 23.476562 19.929688 L 23.476562 20 C 23.378906 20.371094 23.289062 20.742188 23.199219 21.113281 C 23.140625 21.179688 23.082031 21.25 23.027344 21.320312 C 22.996094 21.28125 22.980469 21.230469 22.992188 21.183594 C 23.074219 20.734375 23.191406 20.292969 23.339844 19.859375 Z M 23.339844 19.859375 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.878431,
      stroke: "none"
    }
  }))), _clipPath44 || (_clipPath44 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface134",
    clipPath: "url(#clip44)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(33.72549%,29.411765%,26.666667%)",
      fillOpacity: 1
    },
    d: "M 7.824219 20.972656 C 7.878906 21.15625 7.902344 21.34375 7.894531 21.53125 C 7.847656 21.4375 7.800781 21.347656 7.757812 21.253906 C 7.710938 21.277344 7.664062 21.300781 7.617188 21.320312 C 7.628906 21.253906 7.605469 21.207031 7.546875 21.183594 C 7.613281 21.078125 7.707031 21.011719 7.824219 20.972656 Z M 7.824219 20.972656 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0431373,
      stroke: "none"
    }
  }))), _clipPath45 || (_clipPath45 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface137",
    clipPath: "url(#clip45)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(56.470588%,55.294118%,54.509804%)",
      fillOpacity: 1
    },
    d: "M 23.6875 21.667969 C 23.675781 21.785156 23.628906 21.878906 23.546875 21.949219 C 23.527344 21.816406 23.574219 21.722656 23.6875 21.667969 Z M 23.6875 21.667969 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.917647,
      stroke: "none"
    }
  }))), _clipPath46 || (_clipPath46 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface140",
    clipPath: "url(#clip46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(21.176471%,18.039216%,16.470588%)",
      fillOpacity: 1
    },
    d: "M 23.6875 22.433594 C 23.785156 22.523438 23.832031 22.640625 23.824219 22.78125 C 23.839844 22.957031 23.804688 23.117188 23.722656 23.269531 C 23.707031 23.09375 23.675781 22.929688 23.617188 22.78125 C 23.59375 22.597656 23.5 22.457031 23.339844 22.363281 L 23.445312 22.296875 C 23.519531 22.359375 23.597656 22.40625 23.6875 22.433594 Z M 23.6875 22.433594 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.309804,
      stroke: "none"
    }
  }))), _clipPath47 || (_clipPath47 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface143",
    clipPath: "url(#clip47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(49.019608%,45.098039%,42.352941%)",
      fillOpacity: 1
    },
    d: "M 23.410156 23.476562 C 23.308594 23.535156 23.191406 23.570312 23.0625 23.582031 C 23.097656 23.609375 23.121094 23.644531 23.128906 23.6875 C 22.859375 23.621094 22.671875 23.457031 22.574219 23.199219 C 22.570312 23.167969 22.582031 23.144531 22.609375 23.128906 C 22.8125 23.386719 23.078125 23.503906 23.410156 23.476562 Z M 23.410156 23.476562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.8,
      stroke: "none"
    }
  }))), _clipPath48 || (_clipPath48 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface146",
    clipPath: "url(#clip48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(36.470588%,31.764706%,29.019608%)",
      fillOpacity: 1
    },
    d: "M 23.617188 22.78125 C 23.675781 22.929688 23.707031 23.09375 23.722656 23.269531 C 23.804688 23.117188 23.839844 22.957031 23.824219 22.78125 C 23.96875 23.132812 23.875 23.410156 23.546875 23.617188 C 23.546875 23.523438 23.5 23.476562 23.410156 23.476562 C 23.582031 23.28125 23.652344 23.050781 23.617188 22.78125 Z M 23.617188 22.78125 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.956863,
      stroke: "none"
    }
  }))), _clipPath49 || (_clipPath49 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface149",
    clipPath: "url(#clip49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(10.588235%,8.235294%,7.058824%)",
      fillOpacity: 1
    },
    d: "M 23.410156 23.476562 C 23.5 23.476562 23.546875 23.523438 23.546875 23.617188 C 23.445312 23.613281 23.355469 23.636719 23.269531 23.6875 L 23.128906 23.6875 C 23.121094 23.644531 23.097656 23.609375 23.0625 23.582031 C 23.191406 23.570312 23.308594 23.535156 23.410156 23.476562 Z M 23.410156 23.476562 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask49"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.0431373,
      stroke: "none"
    }
  }))), _clipPath50 || (_clipPath50 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface152",
    clipPath: "url(#clip50)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(51.764706%,50.980392%,50.196078%)",
      fillOpacity: 1
    },
    d: "M 23.546875 23.617188 C 23.464844 23.730469 23.371094 23.753906 23.269531 23.6875 C 23.355469 23.636719 23.445312 23.613281 23.546875 23.617188 Z M 23.546875 23.617188 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.552941,
      stroke: "none"
    }
  }))), _clipPath51 || (_clipPath51 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface155",
    clipPath: "url(#clip51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(20%,17.647059%,16.470588%)",
      fillOpacity: 1
    },
    d: "M 21.878906 24.382812 C 21.421875 25.617188 20.726562 26.695312 19.792969 27.617188 C 19.402344 27.90625 18.980469 28.148438 18.539062 28.347656 C 18.488281 28.359375 18.4375 28.34375 18.398438 28.3125 C 18.679688 28.1875 18.910156 28.011719 19.09375 27.792969 L 19.164062 27.792969 C 19.59375 27.605469 19.953125 27.328125 20.242188 26.957031 C 20.605469 26.273438 21.023438 25.621094 21.496094 25.007812 C 21.527344 24.945312 21.542969 24.871094 21.53125 24.800781 C 21.652344 24.632812 21.757812 24.449219 21.84375 24.242188 C 21.875 24.285156 21.886719 24.332031 21.878906 24.382812 Z M 21.878906 24.382812 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask51"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.956863,
      stroke: "none"
    }
  }))), _clipPath52 || (_clipPath52 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip52"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface158",
    clipPath: "url(#clip52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(11.764706%,9.803922%,8.627451%)",
      fillOpacity: 1
    },
    d: "M 8.3125 22.085938 C 8.601562 23.105469 8.890625 24.125 9.183594 25.148438 C 9.359375 25.527344 9.558594 25.898438 9.773438 26.261719 C 9.890625 26.355469 10.007812 26.449219 10.121094 26.539062 C 10.179688 26.703125 10.273438 26.84375 10.398438 26.957031 C 10.613281 27.242188 10.878906 27.476562 11.199219 27.652344 C 11.152344 27.335938 11.074219 27.023438 10.957031 26.714844 C 10.960938 26.660156 10.984375 26.625 11.027344 26.609375 C 11.109375 26.640625 11.179688 26.683594 11.234375 26.746094 C 11.472656 27.292969 11.796875 27.78125 12.207031 28.207031 C 12.347656 28.394531 12.511719 28.554688 12.695312 28.695312 C 13.28125 29.199219 13.976562 29.40625 14.78125 29.320312 C 15.050781 29.320312 15.304688 29.296875 15.546875 29.253906 C 15.710938 29.261719 15.875 29.253906 16.035156 29.21875 C 16.296875 29.140625 16.554688 29.058594 16.800781 28.972656 C 16.871094 28.984375 16.945312 28.972656 17.007812 28.9375 C 17.410156 28.449219 17.859375 28.019531 18.363281 27.652344 L 18.46875 27.445312 C 18.574219 27.445312 18.609375 27.492188 18.574219 27.582031 C 18.246094 27.988281 17.933594 28.40625 17.636719 28.835938 C 17.261719 29.230469 16.796875 29.4375 16.242188 29.460938 C 15.726562 29.476562 15.21875 29.523438 14.714844 29.601562 C 13.558594 29.742188 12.605469 29.335938 11.859375 28.382812 C 10.433594 27.722656 9.472656 26.644531 8.972656 25.148438 C 8.683594 24.203125 8.441406 23.277344 8.242188 22.363281 C 8.21875 22.207031 8.242188 22.113281 8.3125 22.085938 Z M 8.3125 22.085938 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.164706,
      stroke: "none"
    }
  }))), _clipPath53 || (_clipPath53 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface161",
    clipPath: "url(#clip53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(27.058824%,25.882353%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 16.242188 29.460938 C 15.761719 29.554688 15.273438 29.625 14.78125 29.667969 C 14.742188 29.660156 14.71875 29.636719 14.714844 29.601562 C 15.21875 29.523438 15.730469 29.476562 16.242188 29.460938 Z M 16.242188 29.460938 "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface11",
    mask: "url(#mask2)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface14",
    mask: "url(#mask3)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface17",
    mask: "url(#mask4)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(41.176471%,27.843137%,12.941176%)",
      fillOpacity: 1
    },
    d: "M 17.148438 3.582031 L 18.121094 3.582031 C 18.339844 3.605469 18.570312 3.664062 18.816406 3.757812 C 18.597656 4.003906 18.355469 4.039062 18.085938 3.859375 L 17.878906 3.929688 C 17.707031 3.78125 17.558594 3.78125 17.425781 3.929688 C 17.351562 3.855469 17.28125 3.855469 17.21875 3.929688 C 17.261719 3.992188 17.285156 4.0625 17.285156 4.140625 C 17.027344 4.152344 16.796875 4.082031 16.589844 3.929688 C 16.53125 3.972656 16.457031 3.996094 16.382812 4 C 16.214844 3.917969 16.078125 3.964844 15.964844 4.140625 C 15.988281 4.222656 16.023438 4.222656 16.070312 4.140625 C 16.378906 4.566406 16.273438 4.75 15.757812 4.695312 C 15.757812 4.53125 15.679688 4.441406 15.511719 4.417969 C 15.40625 4.453125 15.300781 4.476562 15.199219 4.488281 C 15.226562 4.558594 15.269531 4.605469 15.339844 4.625 C 15.429688 4.671875 15.503906 4.742188 15.546875 4.835938 C 15.566406 4.96875 15.53125 5.085938 15.445312 5.183594 C 15.074219 4.878906 14.644531 4.761719 14.15625 4.835938 C 13.964844 4.832031 13.773438 4.78125 13.601562 4.695312 C 13.535156 4.699219 13.488281 4.722656 13.460938 4.765625 C 13.367188 4.753906 13.289062 4.777344 13.21875 4.835938 C 13.039062 4.6875 12.84375 4.59375 12.625 4.554688 C 12.648438 4.488281 12.695312 4.441406 12.765625 4.417969 C 12.976562 4.050781 13.265625 3.933594 13.636719 4.070312 C 13.765625 4.023438 13.871094 3.941406 13.949219 3.824219 C 14.15625 3.8125 14.339844 3.742188 14.503906 3.617188 C 15.382812 3.527344 16.265625 3.515625 17.148438 3.582031 Z M 17.148438 3.582031 "
  }), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface20",
    mask: "url(#mask5)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(39.607843%,27.058824%,13.72549%)",
      fillOpacity: 1
    },
    d: "M 21.113281 4.488281 C 21.265625 4.648438 21.453125 4.777344 21.667969 4.871094 C 21.839844 5.007812 21.894531 5.183594 21.84375 5.390625 L 21.773438 5.253906 C 21.613281 5.34375 21.449219 5.34375 21.285156 5.253906 L 21.21875 6.015625 L 20.9375 5.667969 C 20.90625 5.707031 20.894531 5.757812 20.90625 5.808594 C 20.652344 5.523438 20.421875 5.21875 20.207031 4.90625 C 20.152344 4.84375 20.082031 4.820312 20 4.835938 C 20.144531 5.542969 20.328125 6.238281 20.554688 6.921875 L 20.347656 6.921875 C 20.226562 6.613281 20.089844 6.308594 19.929688 6.015625 C 19.660156 5.730469 19.4375 5.402344 19.269531 5.042969 C 19.09375 4.917969 18.941406 4.765625 18.816406 4.589844 C 18.75 4.550781 18.703125 4.574219 18.679688 4.660156 C 18.804688 5.0625 18.980469 5.449219 19.199219 5.808594 C 19.253906 5.910156 19.242188 6 19.164062 6.085938 C 18.679688 5.453125 18.160156 4.847656 17.601562 4.277344 L 17.425781 3.929688 C 17.558594 3.78125 17.707031 3.78125 17.878906 3.929688 L 18.085938 3.859375 C 18.355469 4.039062 18.597656 4.003906 18.816406 3.757812 C 18.570312 3.664062 18.339844 3.605469 18.121094 3.582031 C 18.199219 3.527344 18.28125 3.480469 18.363281 3.445312 C 18.859375 3.652344 19.371094 3.8125 19.894531 3.929688 C 20.246094 4.199219 20.605469 4.453125 20.972656 4.695312 C 21.140625 4.667969 21.183594 4.597656 21.113281 4.488281 Z M 21.113281 4.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(36.470588%,26.666667%,17.254902%)",
      fillOpacity: 1
    },
    d: "M 14.433594 3.445312 C 15.175781 3.433594 15.917969 3.445312 16.660156 3.476562 C 16.835938 3.492188 17 3.527344 17.148438 3.582031 C 16.265625 3.515625 15.382812 3.527344 14.503906 3.617188 C 14.339844 3.742188 14.15625 3.8125 13.949219 3.824219 C 13.871094 3.941406 13.765625 4.023438 13.636719 4.070312 C 13.265625 3.933594 12.976562 4.050781 12.765625 4.417969 L 12.765625 4.207031 C 12.625 4.21875 12.484375 4.207031 12.347656 4.175781 C 12.824219 3.996094 13.3125 3.859375 13.808594 3.757812 C 14.035156 3.664062 14.246094 3.5625 14.433594 3.445312 Z M 14.433594 3.445312 "
  }), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface23",
    mask: "url(#mask6)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface26",
    mask: "url(#mask7)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(37.254902%,26.666667%,17.254902%)",
      fillOpacity: 1
    },
    d: "M 19.582031 3.652344 C 20.011719 3.789062 20.382812 4.035156 20.695312 4.382812 C 20.820312 4.460938 20.964844 4.496094 21.113281 4.488281 C 21.183594 4.597656 21.140625 4.667969 20.972656 4.695312 C 20.605469 4.453125 20.246094 4.199219 19.894531 3.929688 C 19.371094 3.8125 18.859375 3.652344 18.363281 3.445312 C 18.28125 3.480469 18.199219 3.527344 18.121094 3.582031 L 17.773438 3.582031 L 17.773438 3.511719 C 17.824219 3.378906 17.929688 3.308594 18.085938 3.304688 C 18.59375 3.378906 19.09375 3.496094 19.582031 3.652344 Z M 19.582031 3.652344 "
  }), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface29",
    mask: "url(#mask8)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(18.039216%,14.901961%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 11.722656 4.695312 C 11.710938 4.765625 11.734375 4.8125 11.792969 4.835938 C 11.527344 4.929688 11.273438 5.058594 11.027344 5.21875 C 11.25 5.320312 11.4375 5.402344 11.582031 5.460938 C 11.300781 5.472656 11.023438 5.449219 10.746094 5.390625 C 10.65625 5.320312 10.65625 5.253906 10.746094 5.183594 C 10.957031 5.128906 11.140625 5.035156 11.304688 4.90625 C 11.421875 4.800781 11.558594 4.730469 11.722656 4.695312 Z M 11.722656 4.695312 "
  }), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface32",
    mask: "url(#mask9)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(36.470588%,25.490196%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 11.792969 4.835938 C 12.375 4.921875 12.882812 5.152344 13.320312 5.53125 L 13.113281 5.601562 C 12.742188 5.460938 12.359375 5.367188 11.964844 5.320312 L 11.792969 5.390625 C 11.933594 5.582031 12.097656 5.742188 12.277344 5.878906 L 12.277344 6.085938 L 11.722656 6.085938 C 11.722656 6.3125 11.632812 6.335938 11.445312 6.15625 C 11.402344 6.09375 11.375 6.023438 11.375 5.949219 C 11.472656 5.800781 11.542969 5.640625 11.582031 5.460938 C 11.4375 5.402344 11.25 5.320312 11.027344 5.21875 C 11.273438 5.058594 11.527344 4.929688 11.792969 4.835938 Z M 11.792969 4.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(9.411765%,3.921569%,1.568627%)",
      fillOpacity: 1
    },
    d: "M 17.914062 3.09375 L 17.984375 3.09375 C 18.472656 3.261719 18.984375 3.378906 19.511719 3.445312 L 19.582031 3.445312 L 19.652344 3.582031 C 19.605469 3.582031 19.582031 3.605469 19.582031 3.652344 C 19.09375 3.496094 18.59375 3.378906 18.085938 3.304688 C 17.929688 3.308594 17.824219 3.378906 17.773438 3.511719 C 16.652344 3.371094 15.539062 3.347656 14.433594 3.445312 C 14.246094 3.5625 14.035156 3.664062 13.808594 3.757812 C 13.3125 3.859375 12.824219 3.996094 12.347656 4.175781 C 12.484375 4.207031 12.625 4.21875 12.765625 4.207031 L 12.765625 4.417969 C 12.695312 4.441406 12.648438 4.488281 12.625 4.554688 C 12.527344 4.570312 12.433594 4.605469 12.347656 4.660156 C 12.984375 4.828125 13.609375 5.023438 14.226562 5.253906 L 14.433594 5.183594 L 14.363281 5.113281 C 14.074219 4.972656 13.773438 4.855469 13.460938 4.765625 C 13.488281 4.722656 13.535156 4.699219 13.601562 4.695312 C 13.773438 4.78125 13.964844 4.832031 14.15625 4.835938 C 14.757812 5.066406 15.359375 5.296875 15.964844 5.53125 L 16.175781 5.496094 C 15.996094 5.238281 15.789062 5.015625 15.546875 4.835938 C 15.503906 4.742188 15.429688 4.671875 15.339844 4.625 C 15.367188 4.554688 15.414062 4.542969 15.476562 4.589844 C 16.066406 4.949219 16.597656 5.363281 17.078125 5.84375 C 17.144531 5.878906 17.214844 5.890625 17.285156 5.878906 C 17.246094 5.472656 17.058594 5.148438 16.730469 4.90625 C 16.601562 4.609375 16.4375 4.328125 16.242188 4.070312 C 16.273438 4.015625 16.320312 3.992188 16.382812 4 C 16.832031 4.34375 17.25 4.730469 17.636719 5.148438 C 17.742188 5.21875 17.855469 5.253906 17.984375 5.253906 C 17.890625 4.792969 17.660156 4.421875 17.285156 4.140625 C 17.285156 4.0625 17.261719 3.992188 17.21875 3.929688 C 17.28125 3.855469 17.351562 3.855469 17.425781 3.929688 L 17.601562 4.277344 C 18.160156 4.847656 18.679688 5.453125 19.164062 6.085938 C 19.242188 6 19.253906 5.910156 19.199219 5.808594 C 18.980469 5.449219 18.804688 5.0625 18.679688 4.660156 C 18.703125 4.574219 18.75 4.550781 18.816406 4.589844 C 18.941406 4.765625 19.09375 4.917969 19.269531 5.042969 C 19.4375 5.402344 19.660156 5.730469 19.929688 6.015625 C 20.089844 6.308594 20.226562 6.613281 20.347656 6.921875 L 20.554688 6.921875 C 20.699219 7.023438 20.851562 7.117188 21.007812 7.199219 L 21.21875 6.992188 C 21.234375 7.144531 21.269531 7.296875 21.320312 7.445312 C 21.160156 7.476562 21 7.488281 20.835938 7.476562 L 20.625 7.476562 C 20.246094 7.136719 19.808594 6.894531 19.304688 6.746094 C 18.753906 6.597656 18.195312 6.46875 17.636719 6.363281 C 17.136719 6.285156 16.625 6.285156 16.105469 6.363281 C 15.925781 6.375 15.75 6.351562 15.582031 6.296875 C 15.210938 6.433594 14.828125 6.46875 14.433594 6.398438 C 14.195312 6.390625 13.988281 6.3125 13.808594 6.15625 C 13.371094 6.242188 12.929688 6.300781 12.488281 6.332031 C 12.582031 6.113281 12.511719 5.960938 12.277344 5.878906 C 12.097656 5.742188 11.933594 5.582031 11.792969 5.390625 L 11.964844 5.320312 C 12.359375 5.367188 12.742188 5.460938 13.113281 5.601562 L 13.320312 5.53125 C 12.882812 5.152344 12.375 4.921875 11.792969 4.835938 C 11.734375 4.8125 11.710938 4.765625 11.722656 4.695312 C 11.9375 4.703125 12.121094 4.632812 12.277344 4.488281 C 12.148438 4.421875 12.003906 4.394531 11.859375 4.417969 L 11.792969 4.417969 C 11.800781 4.261719 11.84375 4.125 11.929688 4 L 12 4 C 12.609375 3.871094 13.210938 3.71875 13.808594 3.546875 C 13.867188 3.476562 13.890625 3.394531 13.878906 3.304688 L 17.425781 3.304688 L 17.425781 3.09375 Z M 17.914062 3.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(36.078431%,25.098039%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 14.15625 4.835938 C 14.644531 4.761719 15.074219 4.878906 15.445312 5.183594 C 15.53125 5.085938 15.566406 4.96875 15.546875 4.835938 C 15.789062 5.015625 15.996094 5.238281 16.175781 5.496094 L 15.964844 5.53125 C 15.359375 5.296875 14.757812 5.066406 14.15625 4.835938 Z M 14.15625 4.835938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(34.117647%,24.313725%,16.078431%)",
      fillOpacity: 1
    },
    d: "M 12.625 4.554688 C 12.84375 4.59375 13.039062 4.6875 13.21875 4.835938 C 13.289062 4.777344 13.367188 4.753906 13.460938 4.765625 C 13.773438 4.855469 14.074219 4.972656 14.363281 5.113281 L 14.433594 5.183594 L 14.226562 5.253906 C 13.609375 5.023438 12.984375 4.828125 12.347656 4.660156 C 12.433594 4.605469 12.527344 4.570312 12.625 4.554688 Z M 12.625 4.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(36.862745%,25.490196%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 17.285156 4.140625 C 17.660156 4.421875 17.890625 4.792969 17.984375 5.253906 C 17.855469 5.253906 17.742188 5.21875 17.636719 5.148438 C 17.25 4.730469 16.832031 4.34375 16.382812 4 C 16.457031 3.996094 16.53125 3.972656 16.589844 3.929688 C 16.796875 4.082031 17.027344 4.152344 17.285156 4.140625 Z M 17.285156 4.140625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(21.568627%,14.901961%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 14.433594 3.445312 C 15.539062 3.347656 16.652344 3.371094 17.773438 3.511719 L 17.773438 3.582031 L 17.148438 3.582031 C 17 3.527344 16.835938 3.492188 16.660156 3.476562 C 15.917969 3.445312 15.175781 3.433594 14.433594 3.445312 Z M 14.433594 3.445312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(38.039216%,26.27451%,14.901961%)",
      fillOpacity: 1
    },
    d: "M 16.382812 4 C 16.320312 3.992188 16.273438 4.015625 16.242188 4.070312 C 16.4375 4.328125 16.601562 4.609375 16.730469 4.90625 C 17.058594 5.148438 17.246094 5.472656 17.285156 5.878906 C 17.214844 5.890625 17.140625 5.875 17.078125 5.84375 C 16.597656 5.363281 16.066406 4.949219 15.476562 4.589844 C 15.414062 4.542969 15.367188 4.554688 15.339844 4.625 C 15.269531 4.605469 15.226562 4.558594 15.199219 4.488281 C 15.300781 4.476562 15.40625 4.453125 15.511719 4.417969 C 15.679688 4.441406 15.757812 4.53125 15.757812 4.695312 C 16.273438 4.75 16.378906 4.566406 16.070312 4.140625 C 16.023438 4.222656 15.988281 4.222656 15.964844 4.140625 C 16.078125 3.964844 16.214844 3.917969 16.382812 4 Z M 16.382812 4 "
  }), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface35",
    mask: "url(#mask10)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface38",
    mask: "url(#mask11)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface41",
    mask: "url(#mask12)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface44",
    mask: "url(#mask13)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(11.372549%,3.921569%,1.176471%)",
      fillOpacity: 1
    },
    d: "M 20.90625 5.808594 C 21.058594 6.234375 21.234375 6.652344 21.425781 7.0625 C 21.46875 7.21875 21.5625 7.332031 21.703125 7.410156 C 21.75 7.226562 21.75 7.035156 21.703125 6.851562 C 21.519531 6.421875 21.441406 5.980469 21.460938 5.53125 C 21.726562 6.125 21.96875 6.726562 22.191406 7.339844 C 22.246094 6.722656 22.1875 6.121094 22.015625 5.53125 C 22.078125 5.476562 22.136719 5.5 22.191406 5.601562 C 22.421875 6.300781 22.574219 7.023438 22.644531 7.757812 C 22.808594 7.746094 22.96875 7.757812 23.128906 7.792969 L 22.921875 7.964844 L 22.992188 8.035156 C 23.101562 7.957031 23.21875 7.921875 23.339844 7.929688 C 23.210938 8.007812 23.09375 8.101562 22.992188 8.207031 L 23.617188 8.277344 C 23.519531 8.375 23.402344 8.433594 23.269531 8.453125 C 23.140625 8.4375 23.082031 8.484375 23.09375 8.589844 C 23.160156 8.679688 23.21875 8.773438 23.269531 8.871094 C 23.4375 8.917969 23.578125 9.011719 23.6875 9.148438 C 23.628906 9.199219 23.554688 9.234375 23.476562 9.253906 C 23.601562 9.328125 23.636719 9.429688 23.582031 9.566406 C 23.554688 9.429688 23.472656 9.363281 23.339844 9.355469 C 23.121094 9.027344 22.863281 8.722656 22.574219 8.453125 C 22.511719 8.253906 22.398438 8.089844 22.226562 7.964844 C 21.835938 7.855469 21.441406 7.761719 21.042969 7.6875 C 20.960938 7.632812 20.890625 7.5625 20.835938 7.476562 C 21 7.488281 21.160156 7.476562 21.320312 7.445312 C 21.269531 7.296875 21.234375 7.144531 21.21875 6.992188 L 21.007812 7.199219 C 20.851562 7.117188 20.699219 7.023438 20.554688 6.921875 C 20.328125 6.238281 20.144531 5.542969 20 4.835938 C 20.082031 4.820312 20.152344 4.84375 20.207031 4.90625 C 20.421875 5.21875 20.652344 5.523438 20.90625 5.808594 Z M 20.90625 5.808594 "
  }), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface47",
    mask: "url(#mask14)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(49.803922%,39.215686%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 17.636719 6.363281 C 16.820312 6.40625 16.007812 6.476562 15.199219 6.574219 L 15.199219 6.503906 C 15.519531 6.519531 15.820312 6.472656 16.105469 6.363281 C 16.625 6.285156 17.136719 6.285156 17.636719 6.363281 Z M 17.636719 6.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(86.666667%,67.45098%,55.294118%)",
      fillOpacity: 1
    },
    d: "M 12.765625 6.433594 C 13.171875 6.347656 13.589844 6.347656 14.015625 6.433594 C 14.070312 6.488281 14.140625 6.523438 14.226562 6.539062 C 14.550781 6.574219 14.875 6.585938 15.199219 6.574219 C 16.007812 6.476562 16.820312 6.40625 17.636719 6.363281 C 18.195312 6.46875 18.753906 6.597656 19.304688 6.746094 C 19.808594 6.894531 20.246094 7.136719 20.625 7.476562 C 20.519531 7.402344 20.414062 7.402344 20.3125 7.476562 C 20.179688 7.460938 20.089844 7.390625 20.035156 7.269531 C 19.996094 7.304688 19.949219 7.328125 19.894531 7.339844 C 19.292969 7.132812 18.675781 6.957031 18.050781 6.816406 C 17.054688 6.847656 16.058594 6.894531 15.0625 6.957031 C 14.589844 6.941406 14.171875 6.789062 13.808594 6.503906 C 13.609375 6.4375 13.394531 6.414062 13.183594 6.433594 Z M 12.765625 6.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(28.627451%,20%,13.72549%)",
      fillOpacity: 1
    },
    d: "M 14.015625 6.433594 C 14.410156 6.488281 14.804688 6.511719 15.199219 6.503906 L 15.199219 6.574219 C 14.875 6.585938 14.550781 6.574219 14.226562 6.539062 C 14.140625 6.523438 14.070312 6.488281 14.015625 6.433594 Z M 14.015625 6.433594 "
  }), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface50",
    mask: "url(#mask15)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(95.294118%,81.960784%,72.156863%)",
      fillOpacity: 1
    },
    d: "M 13.183594 6.433594 C 13.394531 6.414062 13.609375 6.4375 13.808594 6.503906 C 14.171875 6.789062 14.589844 6.941406 15.0625 6.957031 C 16.058594 6.894531 17.054688 6.847656 18.050781 6.816406 C 18.675781 6.957031 19.292969 7.132812 19.894531 7.339844 C 19.949219 7.328125 19.996094 7.304688 20.035156 7.269531 C 20.089844 7.390625 20.179688 7.460938 20.3125 7.476562 C 20.414062 7.402344 20.519531 7.402344 20.625 7.476562 L 20.835938 7.476562 C 20.890625 7.5625 20.960938 7.632812 21.042969 7.6875 C 21.457031 7.933594 21.875 8.179688 22.296875 8.417969 C 22.382812 8.453125 22.480469 8.464844 22.574219 8.453125 C 22.59375 8.589844 22.546875 8.691406 22.433594 8.765625 C 22.589844 8.773438 22.71875 8.832031 22.816406 8.9375 L 22.886719 8.871094 L 22.957031 10.816406 C 22.972656 10.949219 23.007812 11.078125 23.0625 11.199219 C 22.984375 11.484375 22.9375 11.777344 22.921875 12.070312 L 22.921875 12.207031 C 22.71875 12.53125 22.542969 12.878906 22.398438 13.253906 C 22.355469 13.460938 22.355469 13.667969 22.398438 13.878906 C 22.523438 14.121094 22.570312 14.375 22.539062 14.644531 C 22.511719 14.554688 22.453125 14.507812 22.363281 14.503906 C 22.175781 14.316406 22.011719 14.105469 21.878906 13.878906 C 21.65625 13.539062 21.355469 13.308594 20.972656 13.183594 C 20.71875 13.0625 20.4375 13.015625 20.140625 13.042969 C 19.71875 12.933594 19.285156 12.863281 18.851562 12.835938 C 18.554688 12.824219 18.289062 12.894531 18.050781 13.042969 L 17.84375 13.183594 C 17.773438 13.175781 17.714844 13.199219 17.667969 13.253906 C 17.679688 13.554688 17.585938 13.601562 17.390625 13.390625 C 17.425781 13.507812 17.414062 13.625 17.355469 13.738281 L 17.496094 13.878906 C 17.410156 13.984375 17.339844 14.101562 17.285156 14.226562 L 17.148438 14.296875 C 17.0625 14.171875 17.011719 14.027344 17.007812 13.878906 C 16.730469 13.832031 16.613281 13.949219 16.660156 14.226562 C 16.199219 14.1875 15.734375 14.164062 15.269531 14.15625 C 15.179688 14.078125 15.144531 13.988281 15.164062 13.878906 C 15.289062 13.945312 15.40625 13.921875 15.511719 13.808594 C 15.535156 13.472656 15.570312 13.132812 15.617188 12.800781 C 15.570312 12.640625 15.464844 12.539062 15.304688 12.488281 C 15.027344 12.5 14.738281 12.5 14.433594 12.488281 L 13.738281 12.488281 C 12.957031 12.367188 12.164062 12.335938 11.375 12.382812 C 11.042969 12.683594 10.667969 12.929688 10.261719 13.113281 C 10.214844 13.113281 10.191406 13.089844 10.191406 13.042969 C 10.242188 12.75 10.390625 12.519531 10.644531 12.347656 C 10.828125 12.003906 10.980469 11.640625 11.09375 11.269531 C 10.984375 10.753906 10.949219 10.226562 10.992188 9.703125 C 11.300781 9.070312 11.625 8.445312 11.964844 7.824219 C 12.332031 7.332031 12.742188 6.867188 13.183594 6.433594 Z M 13.183594 6.433594 "
  }), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface53",
    mask: "url(#mask16)"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface56",
    mask: "url(#mask17)"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface59",
    mask: "url(#mask18)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(36.862745%,25.882353%,15.294118%)",
      fillOpacity: 1
    },
    d: "M 21.113281 4.488281 C 21.128906 4.445312 21.164062 4.421875 21.21875 4.417969 C 21.382812 4.46875 21.535156 4.554688 21.667969 4.660156 C 21.792969 4.855469 21.945312 5.03125 22.121094 5.183594 C 22.542969 6.027344 22.980469 6.863281 23.445312 7.6875 C 23.570312 7.816406 23.710938 7.839844 23.859375 7.757812 C 23.859375 7.933594 23.917969 8.074219 24.035156 8.175781 C 24.011719 8.242188 23.964844 8.289062 23.894531 8.3125 C 23.785156 8.347656 23.75 8.417969 23.792969 8.523438 C 23.886719 8.582031 23.988281 8.605469 24.105469 8.589844 C 24.246094 8.585938 24.363281 8.632812 24.453125 8.730469 C 24.359375 8.71875 24.261719 8.730469 24.175781 8.765625 C 24.324219 8.835938 24.441406 8.9375 24.523438 9.078125 L 24.523438 9.496094 C 24.289062 9.519531 24.050781 9.496094 23.824219 9.425781 C 24.265625 9.269531 24.265625 9.175781 23.824219 9.148438 L 23.824219 8.9375 C 23.921875 8.949219 24.015625 8.9375 24.105469 8.90625 C 23.914062 8.875 23.726562 8.828125 23.546875 8.765625 C 23.601562 8.746094 23.652344 8.707031 23.6875 8.660156 C 23.515625 8.628906 23.375 8.558594 23.269531 8.453125 C 23.402344 8.433594 23.519531 8.375 23.617188 8.277344 L 22.992188 8.207031 C 23.09375 8.101562 23.210938 8.007812 23.339844 7.929688 C 23.21875 7.921875 23.101562 7.957031 22.992188 8.035156 L 22.921875 7.964844 L 23.128906 7.792969 C 22.96875 7.757812 22.804688 7.746094 22.644531 7.757812 C 22.574219 7.023438 22.421875 6.300781 22.191406 5.601562 C 22.136719 5.5 22.078125 5.476562 22.015625 5.53125 C 22.1875 6.121094 22.246094 6.722656 22.191406 7.339844 C 21.96875 6.726562 21.726562 6.125 21.460938 5.53125 C 21.441406 5.980469 21.519531 6.421875 21.703125 6.851562 C 21.75 7.035156 21.75 7.226562 21.703125 7.410156 C 21.5625 7.332031 21.46875 7.21875 21.425781 7.0625 C 21.234375 6.652344 21.058594 6.234375 20.90625 5.808594 C 20.894531 5.757812 20.90625 5.707031 20.9375 5.667969 L 21.21875 6.015625 L 21.285156 5.253906 C 21.449219 5.34375 21.613281 5.34375 21.773438 5.253906 L 21.84375 5.390625 C 21.894531 5.183594 21.839844 5.007812 21.667969 4.871094 C 21.453125 4.777344 21.265625 4.648438 21.113281 4.488281 Z M 21.113281 4.488281 "
  }), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface62",
    mask: "url(#mask19)"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface65",
    mask: "url(#mask20)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(83.137255%,66.666667%,56.078431%)",
      fillOpacity: 1
    },
    d: "M 21.042969 7.6875 C 21.441406 7.761719 21.835938 7.855469 22.226562 7.964844 C 22.398438 8.089844 22.511719 8.253906 22.574219 8.453125 C 22.480469 8.464844 22.382812 8.453125 22.296875 8.417969 C 21.875 8.179688 21.457031 7.933594 21.042969 7.6875 Z M 21.042969 7.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(89.411765%,67.843137%,53.72549%)",
      fillOpacity: 1
    },
    d: "M 12.765625 6.433594 L 13.183594 6.433594 C 12.742188 6.867188 12.332031 7.332031 11.964844 7.824219 C 11.625 8.445312 11.300781 9.070312 10.992188 9.703125 C 10.949219 10.226562 10.984375 10.753906 11.09375 11.269531 C 10.980469 11.640625 10.828125 12.003906 10.644531 12.347656 C 10.390625 12.519531 10.242188 12.75 10.191406 13.042969 C 10.074219 13.089844 10.027344 13.183594 10.050781 13.320312 C 9.90625 13.320312 9.8125 13.390625 9.773438 13.53125 L 9.773438 13.808594 L 9.636719 13.667969 L 9.285156 13.667969 C 9.152344 13.652344 9.046875 13.695312 8.972656 13.808594 C 8.960938 13.597656 8.984375 13.390625 9.042969 13.183594 C 9.226562 12.898438 9.375 12.59375 9.496094 12.277344 C 9.804688 12.027344 10.023438 11.699219 10.15625 11.304688 C 10.253906 11.058594 10.324219 10.800781 10.363281 10.539062 C 10.367188 9.976562 10.433594 9.414062 10.574219 8.871094 C 10.78125 8.355469 11 7.84375 11.234375 7.339844 C 11.578125 7.035156 11.949219 6.765625 12.347656 6.539062 C 12.472656 6.460938 12.617188 6.425781 12.765625 6.433594 Z M 12.765625 6.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(40.784314%,28.627451%,18.039216%)",
      fillOpacity: 1
    },
    d: "M 9.496094 8.730469 C 9.339844 8.792969 9.199219 8.886719 9.078125 9.007812 C 9.175781 9.082031 9.28125 9.082031 9.390625 9.007812 C 9.511719 9.015625 9.523438 9.050781 9.425781 9.113281 C 9.25 9.21875 9.085938 9.347656 8.9375 9.496094 C 8.878906 9.4375 8.855469 9.367188 8.871094 9.285156 C 8.863281 8.84375 8.898438 8.402344 8.972656 7.964844 C 9.105469 7.824219 9.257812 7.707031 9.425781 7.617188 C 9.574219 7.691406 9.714844 7.691406 9.84375 7.617188 C 9.984375 7.546875 10.125 7.546875 10.261719 7.617188 C 9.941406 7.761719 9.640625 7.9375 9.355469 8.140625 C 9.5625 8.128906 9.773438 8.128906 9.984375 8.140625 C 9.800781 8.210938 9.636719 8.316406 9.496094 8.453125 C 9.675781 8.550781 9.675781 8.644531 9.496094 8.730469 Z M 9.496094 8.730469 "
  }), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface68",
    mask: "url(#mask21)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.333333%,6.666667%,3.529412%)",
      fillOpacity: 1
    },
    d: "M 12.277344 5.878906 C 12.511719 5.960938 12.582031 6.113281 12.488281 6.332031 C 12.929688 6.300781 13.367188 6.246094 13.808594 6.15625 C 13.988281 6.3125 14.195312 6.390625 14.433594 6.398438 C 14.828125 6.46875 15.210938 6.433594 15.582031 6.296875 C 15.75 6.351562 15.925781 6.375 16.105469 6.363281 C 15.820312 6.472656 15.519531 6.519531 15.199219 6.503906 C 14.804688 6.511719 14.410156 6.488281 14.015625 6.433594 C 13.589844 6.347656 13.171875 6.347656 12.765625 6.433594 C 12.617188 6.425781 12.472656 6.460938 12.347656 6.539062 C 11.949219 6.765625 11.578125 7.035156 11.234375 7.339844 C 10.96875 7.390625 10.761719 7.53125 10.609375 7.757812 C 10.382812 7.875 10.1875 8.039062 10.015625 8.242188 C 10.019531 9.199219 9.949219 10.152344 9.808594 11.09375 C 9.652344 11.378906 9.453125 11.636719 9.21875 11.859375 C 8.605469 12.300781 8.351562 12.902344 8.453125 13.667969 C 8.40625 13.355469 8.359375 13.03125 8.3125 12.695312 L 8.242188 12.730469 C 8.230469 12.941406 8.136719 13.136719 7.964844 13.320312 C 8.027344 13.332031 8.097656 13.355469 8.175781 13.390625 L 7.964844 13.667969 L 8.105469 13.808594 C 7.980469 13.894531 7.910156 14.011719 7.894531 14.15625 C 7.789062 14.019531 7.742188 13.859375 7.757812 13.667969 C 7.832031 13.207031 7.902344 12.742188 7.964844 12.277344 L 7.964844 12.625 C 8.460938 12.574219 8.550781 12.367188 8.242188 12 C 8.292969 11.90625 8.359375 11.835938 8.453125 11.792969 C 8.539062 11.796875 8.597656 11.84375 8.625 11.929688 C 8.726562 11.757812 8.796875 11.570312 8.835938 11.375 C 9.125 11.453125 9.242188 11.339844 9.183594 11.027344 C 8.996094 11.09375 8.972656 11.046875 9.113281 10.886719 L 9.183594 10.957031 L 9.425781 10.574219 C 9.257812 10.5 9.28125 10.464844 9.496094 10.46875 C 9.511719 10.304688 9.464844 10.164062 9.355469 10.050781 C 9.359375 9.914062 9.359375 9.773438 9.355469 9.636719 C 9.378906 9.550781 9.414062 9.550781 9.460938 9.636719 C 9.480469 9.507812 9.539062 9.402344 9.636719 9.320312 C 9.460938 9.222656 9.460938 9.121094 9.636719 9.007812 C 9.574219 8.957031 9.503906 8.921875 9.425781 8.90625 C 9.476562 8.859375 9.5 8.800781 9.496094 8.730469 C 9.675781 8.644531 9.675781 8.550781 9.496094 8.453125 C 9.636719 8.316406 9.800781 8.210938 9.984375 8.140625 C 9.773438 8.128906 9.566406 8.128906 9.355469 8.140625 C 9.640625 7.9375 9.941406 7.761719 10.261719 7.617188 C 10.125 7.546875 9.984375 7.546875 9.84375 7.617188 C 9.710938 7.625 9.691406 7.589844 9.773438 7.511719 C 10.070312 7.433594 10.351562 7.304688 10.609375 7.128906 C 10.691406 7.078125 10.691406 7.019531 10.609375 6.957031 C 10.859375 6.851562 11.113281 6.761719 11.375 6.679688 L 11.027344 6.609375 C 11.789062 6.5 11.8125 6.382812 11.09375 6.261719 C 11.238281 6.179688 11.25 6.097656 11.128906 6.015625 C 10.835938 6.269531 10.519531 6.503906 10.191406 6.714844 C 10.175781 6.84375 10.222656 6.949219 10.332031 7.027344 C 10.027344 7.222656 9.726562 7.417969 9.425781 7.617188 C 9.257812 7.707031 9.105469 7.824219 8.972656 7.964844 C 8.898438 8.402344 8.863281 8.84375 8.871094 9.285156 C 8.746094 9.214844 8.699219 9.097656 8.730469 8.9375 C 8.65625 8.714844 8.644531 8.480469 8.695312 8.242188 C 8.707031 8.039062 8.785156 7.875 8.9375 7.757812 C 9.070312 7.738281 9.164062 7.671875 9.21875 7.546875 C 9.324219 7.554688 9.394531 7.507812 9.425781 7.410156 C 9.613281 7.382812 9.753906 7.292969 9.84375 7.128906 C 10.039062 7.097656 10.085938 7.003906 9.984375 6.851562 C 9.972656 6.78125 9.984375 6.707031 10.015625 6.644531 C 10.152344 6.5625 10.28125 6.46875 10.398438 6.363281 C 10.554688 6.324219 10.671875 6.230469 10.746094 6.085938 C 10.9375 5.972656 11.144531 5.925781 11.375 5.949219 C 11.375 6.023438 11.402344 6.09375 11.445312 6.15625 C 11.632812 6.335938 11.722656 6.3125 11.722656 6.085938 L 12.277344 6.085938 Z M 12.277344 5.878906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,22.745098%,14.509804%)",
      fillOpacity: 1
    },
    d: "M 9.84375 7.617188 C 9.714844 7.691406 9.574219 7.691406 9.425781 7.617188 C 9.71875 7.421875 10.023438 7.226562 10.332031 7.027344 C 10.222656 6.949219 10.175781 6.84375 10.191406 6.714844 C 10.519531 6.503906 10.835938 6.269531 11.128906 6.015625 C 11.25 6.097656 11.238281 6.179688 11.09375 6.261719 C 11.8125 6.382812 11.789062 6.5 11.027344 6.609375 L 11.375 6.679688 C 11.113281 6.761719 10.859375 6.851562 10.609375 6.957031 C 10.691406 7.019531 10.691406 7.078125 10.609375 7.128906 C 10.351562 7.304688 10.070312 7.433594 9.773438 7.511719 C 9.691406 7.589844 9.710938 7.625 9.84375 7.617188 Z M 9.84375 7.617188 "
  }), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface71",
    mask: "url(#mask22)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(16.470588%,7.45098%,2.745098%)",
      fillOpacity: 1
    },
    d: "M 23.269531 8.453125 C 23.375 8.558594 23.515625 8.628906 23.6875 8.660156 C 23.652344 8.707031 23.601562 8.746094 23.546875 8.765625 C 23.726562 8.828125 23.914062 8.875 24.105469 8.90625 C 24.015625 8.9375 23.921875 8.949219 23.824219 8.9375 L 23.824219 9.148438 C 24.265625 9.175781 24.265625 9.269531 23.824219 9.425781 C 24.050781 9.496094 24.289062 9.519531 24.523438 9.496094 L 24.523438 9.078125 C 24.589844 9.226562 24.613281 9.386719 24.589844 9.566406 C 24.496094 9.554688 24.402344 9.566406 24.3125 9.601562 C 24.398438 9.617188 24.46875 9.652344 24.523438 9.703125 L 24.105469 9.773438 L 24.105469 9.984375 C 24.023438 9.96875 23.953125 9.992188 23.894531 10.050781 C 24.027344 10.109375 24.167969 10.144531 24.3125 10.15625 L 23.894531 10.363281 C 24.265625 10.492188 24.242188 10.558594 23.824219 10.574219 C 24.035156 10.652344 24.246094 10.734375 24.453125 10.816406 C 24.246094 10.910156 24.039062 10.992188 23.824219 11.0625 C 23.972656 11.144531 24.136719 11.191406 24.3125 11.199219 C 24.105469 11.253906 23.917969 11.332031 23.757812 11.445312 C 23.574219 11.519531 23.386719 11.585938 23.199219 11.652344 C 23.320312 11.125 23.410156 10.589844 23.476562 10.050781 C 23.492188 9.804688 23.445312 9.574219 23.339844 9.355469 C 23.472656 9.363281 23.554688 9.429688 23.582031 9.566406 C 23.636719 9.429688 23.601562 9.328125 23.476562 9.253906 C 23.554688 9.234375 23.628906 9.199219 23.6875 9.148438 C 23.578125 9.011719 23.4375 8.917969 23.269531 8.871094 C 23.21875 8.773438 23.160156 8.679688 23.09375 8.589844 C 23.082031 8.484375 23.140625 8.4375 23.269531 8.453125 Z M 23.269531 8.453125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(22.745098%,12.156863%,7.45098%)",
      fillOpacity: 1
    },
    d: "M 9.496094 8.730469 C 9.5 8.800781 9.476562 8.859375 9.425781 8.90625 C 9.503906 8.921875 9.574219 8.957031 9.636719 9.007812 C 9.460938 9.121094 9.460938 9.222656 9.636719 9.320312 C 9.539062 9.402344 9.480469 9.507812 9.460938 9.636719 C 9.414062 9.550781 9.378906 9.550781 9.355469 9.636719 C 9.359375 9.773438 9.359375 9.914062 9.355469 10.050781 C 9.148438 10.027344 8.9375 10.027344 8.730469 10.050781 C 8.871094 9.910156 9.035156 9.792969 9.21875 9.703125 C 9.277344 9.648438 9.300781 9.578125 9.285156 9.496094 C 9.101562 9.5625 8.917969 9.632812 8.730469 9.703125 C 8.847656 9.550781 8.824219 9.433594 8.660156 9.355469 L 8.660156 9.285156 C 8.640625 9.152344 8.664062 9.039062 8.730469 8.9375 C 8.699219 9.097656 8.746094 9.214844 8.871094 9.285156 C 8.855469 9.367188 8.878906 9.4375 8.9375 9.496094 C 9.085938 9.347656 9.25 9.21875 9.425781 9.113281 C 9.523438 9.050781 9.511719 9.015625 9.390625 9.007812 C 9.28125 9.082031 9.175781 9.082031 9.078125 9.007812 C 9.199219 8.886719 9.339844 8.792969 9.496094 8.730469 Z M 9.496094 8.730469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(16.862745%,5.882353%,1.176471%)",
      fillOpacity: 1
    },
    d: "M 9.355469 10.050781 C 9.464844 10.164062 9.511719 10.304688 9.496094 10.46875 C 9.28125 10.464844 9.257812 10.5 9.425781 10.574219 L 9.183594 10.957031 L 9.113281 10.886719 C 8.972656 11.046875 8.996094 11.09375 9.183594 11.027344 C 9.242188 11.339844 9.125 11.453125 8.835938 11.375 C 8.796875 11.570312 8.726562 11.757812 8.625 11.929688 C 8.597656 11.84375 8.539062 11.796875 8.453125 11.792969 C 8.542969 11.699219 8.636719 11.605469 8.730469 11.511719 C 8.5625 11.457031 8.410156 11.5 8.277344 11.652344 C 8.230469 11.605469 8.230469 11.558594 8.277344 11.511719 C 8.496094 11.367188 8.695312 11.191406 8.871094 10.992188 C 8.648438 11.03125 8.441406 11.113281 8.242188 11.234375 C 8.226562 11.125 8.25 11.03125 8.3125 10.957031 C 8.304688 11.003906 8.316406 11.058594 8.347656 11.09375 L 9.007812 10.574219 C 8.777344 10.566406 8.742188 10.488281 8.90625 10.332031 C 9.050781 10.230469 9.203125 10.140625 9.355469 10.050781 Z M 9.355469 10.050781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(43.921569%,31.764706%,21.176471%)",
      fillOpacity: 1
    },
    d: "M 9.355469 10.050781 C 9.203125 10.140625 9.050781 10.230469 8.90625 10.332031 C 8.742188 10.488281 8.777344 10.566406 9.007812 10.574219 L 8.347656 11.09375 C 8.316406 11.058594 8.304688 11.003906 8.3125 10.957031 C 8.4375 10.535156 8.578125 10.117188 8.730469 9.703125 C 8.914062 9.632812 9.101562 9.5625 9.285156 9.496094 C 9.300781 9.578125 9.277344 9.648438 9.21875 9.703125 C 9.035156 9.792969 8.871094 9.910156 8.730469 10.050781 C 8.9375 10.027344 9.148438 10.027344 9.355469 10.050781 Z M 9.355469 10.050781 "
  }), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface74",
    mask: "url(#mask23)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(86.27451%,68.235294%,56.470588%)",
      fillOpacity: 1
    },
    d: "M 22.574219 8.453125 C 22.863281 8.722656 23.121094 9.027344 23.339844 9.355469 C 23.445312 9.574219 23.492188 9.804688 23.476562 10.050781 C 23.410156 10.589844 23.320312 11.125 23.199219 11.652344 C 23.128906 11.75 23.082031 11.867188 23.0625 12 L 22.921875 12.070312 C 22.9375 11.777344 22.984375 11.484375 23.0625 11.199219 C 23.007812 11.078125 22.972656 10.949219 22.957031 10.816406 L 22.886719 8.871094 L 22.816406 8.9375 C 22.71875 8.832031 22.589844 8.773438 22.433594 8.765625 C 22.546875 8.691406 22.59375 8.589844 22.574219 8.453125 Z M 22.574219 8.453125 "
  }), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface77",
    mask: "url(#mask24)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(57.647059%,45.882353%,37.254902%)",
      fillOpacity: 1
    },
    d: "M 10.609375 7.757812 C 10.488281 7.847656 10.464844 7.949219 10.539062 8.070312 C 10.308594 8.207031 10.15625 8.402344 10.085938 8.660156 C 10.074219 9.542969 10.039062 10.425781 9.984375 11.304688 C 9.804688 11.597656 9.550781 11.785156 9.21875 11.859375 C 9.453125 11.636719 9.652344 11.378906 9.808594 11.09375 C 9.949219 10.152344 10.019531 9.199219 10.015625 8.242188 C 10.1875 8.039062 10.382812 7.875 10.609375 7.757812 Z M 10.609375 7.757812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(44.705882%,31.764706%,20%)",
      fillOpacity: 1
    },
    d: "M 8.453125 11.792969 C 8.359375 11.835938 8.292969 11.90625 8.242188 12 C 8.550781 12.367188 8.460938 12.574219 7.964844 12.625 L 7.964844 12.277344 C 8 11.917969 8.09375 11.566406 8.242188 11.234375 C 8.441406 11.113281 8.648438 11.03125 8.871094 10.992188 C 8.695312 11.191406 8.496094 11.367188 8.277344 11.511719 C 8.230469 11.558594 8.230469 11.605469 8.277344 11.652344 C 8.410156 11.5 8.5625 11.457031 8.730469 11.511719 C 8.636719 11.605469 8.542969 11.699219 8.453125 11.792969 Z M 8.453125 11.792969 "
  }), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface80",
    mask: "url(#mask25)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(46.666667%,33.72549%,21.960784%)",
      fillOpacity: 1
    },
    d: "M 24.523438 9.703125 C 24.574219 10.722656 24.621094 11.746094 24.660156 12.765625 L 24.589844 13.042969 C 24.53125 12.984375 24.507812 12.917969 24.523438 12.835938 C 24.382812 12.847656 24.242188 12.835938 24.105469 12.800781 C 23.992188 12.785156 23.921875 12.726562 23.894531 12.625 C 24.046875 12.640625 24.164062 12.582031 24.242188 12.453125 C 24.101562 12.335938 23.941406 12.265625 23.757812 12.242188 C 23.867188 12.175781 23.984375 12.117188 24.105469 12.070312 L 23.546875 11.929688 C 23.796875 11.84375 24.050781 11.785156 24.3125 11.757812 C 24.484375 11.640625 24.464844 11.546875 24.242188 11.476562 C 24.082031 11.445312 23.917969 11.433594 23.757812 11.445312 C 23.917969 11.332031 24.105469 11.253906 24.3125 11.199219 C 24.136719 11.191406 23.972656 11.144531 23.824219 11.0625 C 24.039062 10.992188 24.246094 10.910156 24.453125 10.816406 C 24.246094 10.734375 24.035156 10.652344 23.824219 10.574219 C 24.242188 10.558594 24.265625 10.492188 23.894531 10.363281 L 24.3125 10.15625 C 24.167969 10.144531 24.027344 10.109375 23.894531 10.050781 C 23.953125 9.992188 24.023438 9.96875 24.105469 9.984375 L 24.105469 9.773438 Z M 24.523438 9.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(27.843137%,17.647059%,11.764706%)",
      fillOpacity: 1
    },
    d: "M 23.0625 12 C 23.015625 12.132812 22.992188 12.277344 22.992188 12.417969 C 23.25 12.394531 23.433594 12.5 23.546875 12.730469 C 23.484375 12.75 23.4375 12.785156 23.410156 12.835938 L 23.339844 12.835938 C 23.066406 12.722656 22.925781 12.511719 22.921875 12.207031 L 22.921875 12.070312 Z M 23.0625 12 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(87.058824%,76.862745%,69.803922%)",
      fillOpacity: 1
    },
    d: "M 14.433594 12.554688 L 14.433594 12.488281 C 14.738281 12.5 15.027344 12.5 15.304688 12.488281 C 15.464844 12.539062 15.570312 12.640625 15.617188 12.800781 C 15.570312 13.132812 15.535156 13.472656 15.511719 13.808594 C 15.40625 13.921875 15.289062 13.945312 15.164062 13.878906 C 15.144531 13.988281 15.179688 14.078125 15.269531 14.15625 C 15.085938 14.164062 14.921875 14.117188 14.78125 14.015625 L 14.644531 13.878906 C 15.195312 13.824219 15.464844 13.523438 15.445312 12.972656 C 15.167969 12.695312 14.832031 12.554688 14.433594 12.554688 Z M 14.433594 12.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.843137%,51.372549%,40%)",
      fillOpacity: 1
    },
    d: "M 11.234375 7.339844 C 11 7.84375 10.78125 8.355469 10.574219 8.871094 C 10.433594 9.414062 10.367188 9.976562 10.363281 10.539062 C 10.324219 10.800781 10.253906 11.058594 10.15625 11.304688 C 10.023438 11.699219 9.804688 12.027344 9.496094 12.277344 C 9.375 12.59375 9.226562 12.898438 9.042969 13.183594 C 8.984375 13.390625 8.960938 13.597656 8.972656 13.808594 C 9.046875 13.695312 9.152344 13.652344 9.285156 13.667969 C 9.289062 13.738281 9.253906 13.785156 9.183594 13.808594 C 8.960938 13.894531 8.738281 13.988281 8.523438 14.085938 C 8.453125 13.964844 8.433594 13.824219 8.453125 13.667969 C 8.351562 12.902344 8.605469 12.300781 9.21875 11.859375 C 9.550781 11.785156 9.804688 11.597656 9.984375 11.304688 C 10.039062 10.425781 10.074219 9.542969 10.085938 8.660156 C 10.15625 8.402344 10.308594 8.207031 10.539062 8.070312 C 10.464844 7.949219 10.488281 7.847656 10.609375 7.757812 C 10.761719 7.53125 10.96875 7.390625 11.234375 7.339844 Z M 11.234375 7.339844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(20%,13.333333%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 13.738281 12.488281 C 13.746094 12.53125 13.769531 12.566406 13.808594 12.589844 C 13.640625 12.605469 13.480469 12.640625 13.320312 12.695312 C 13.460938 12.8125 13.601562 12.929688 13.738281 13.042969 C 13.589844 13.117188 13.449219 13.117188 13.320312 13.042969 C 13.371094 13.054688 13.421875 13.039062 13.460938 13.007812 C 13.285156 12.886719 13.121094 12.746094 12.972656 12.589844 C 12.464844 12.542969 11.953125 12.542969 11.445312 12.589844 C 11.269531 12.691406 11.105469 12.804688 10.957031 12.9375 C 11.070312 12.972656 11.1875 12.984375 11.304688 12.972656 C 11.105469 13.035156 10.898438 13.046875 10.679688 13.007812 L 10.746094 13.078125 C 10.492188 13.164062 10.515625 13.222656 10.816406 13.253906 C 10.636719 13.375 10.425781 13.421875 10.191406 13.390625 C 10.1875 13.289062 10.210938 13.195312 10.261719 13.113281 C 10.667969 12.929688 11.042969 12.683594 11.375 12.382812 C 12.164062 12.335938 12.957031 12.367188 13.738281 12.488281 Z M 13.738281 12.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(27.45098%,18.431373%,10.980392%)",
      fillOpacity: 1
    },
    d: "M 13.320312 13.042969 C 12.957031 13.027344 12.597656 12.933594 12.242188 12.765625 C 11.921875 12.816406 11.609375 12.882812 11.304688 12.972656 C 11.1875 12.984375 11.070312 12.972656 10.957031 12.9375 C 11.105469 12.804688 11.269531 12.691406 11.445312 12.589844 C 11.953125 12.542969 12.464844 12.542969 12.972656 12.589844 C 13.121094 12.746094 13.285156 12.886719 13.460938 13.007812 C 13.421875 13.039062 13.371094 13.054688 13.320312 13.042969 Z M 13.320312 13.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(19.215686%,12.156863%,8.235294%)",
      fillOpacity: 1
    },
    d: "M 20.140625 13.042969 C 20.140625 13.136719 20.09375 13.183594 20 13.183594 C 19.683594 13.148438 19.371094 13.101562 19.0625 13.042969 L 18.679688 13.113281 C 18.5 13.246094 18.359375 13.410156 18.261719 13.601562 C 18.210938 13.570312 18.175781 13.523438 18.15625 13.460938 C 18.09375 13.546875 18.035156 13.546875 17.984375 13.460938 C 18.066406 13.367188 18.136719 13.261719 18.191406 13.148438 C 18.167969 13.078125 18.121094 13.042969 18.050781 13.042969 C 18.289062 12.894531 18.554688 12.824219 18.851562 12.835938 C 19.285156 12.863281 19.71875 12.933594 20.140625 13.042969 Z M 20.140625 13.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(34.117647%,22.745098%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 20 13.183594 C 19.792969 13.292969 19.570312 13.3125 19.339844 13.253906 C 19.144531 13.285156 18.96875 13.355469 18.816406 13.460938 C 18.628906 13.5 18.445312 13.542969 18.261719 13.601562 C 18.359375 13.410156 18.5 13.246094 18.679688 13.113281 L 19.0625 13.042969 C 19.371094 13.101562 19.683594 13.148438 20 13.183594 Z M 20 13.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(10.196078%,7.058824%,5.490196%)",
      fillOpacity: 1
    },
    d: "M 14.433594 12.554688 C 14.832031 12.554688 15.167969 12.695312 15.445312 12.972656 C 15.464844 13.523438 15.195312 13.824219 14.644531 13.878906 C 14.464844 13.804688 14.277344 13.792969 14.085938 13.84375 C 14.304688 13.945312 14.542969 14.003906 14.78125 14.015625 C 14.921875 14.117188 15.085938 14.164062 15.269531 14.15625 C 15.394531 14.222656 15.535156 14.269531 15.6875 14.296875 C 16.015625 14.410156 16.363281 14.457031 16.730469 14.433594 L 16.9375 14.433594 C 17.445312 14.589844 17.957031 14.589844 18.46875 14.433594 C 19.886719 14.46875 21.277344 14.65625 22.644531 14.992188 C 22.71875 15.054688 22.808594 15.078125 22.921875 15.0625 L 22.921875 15.6875 L 22.714844 15.6875 C 22.449219 15.722656 22.308594 15.609375 22.296875 15.339844 L 22.085938 15.234375 C 21.507812 15.128906 20.929688 15.023438 20.347656 14.921875 C 20.199219 14.859375 20.035156 14.8125 19.859375 14.78125 C 19.632812 14.691406 19.378906 14.644531 19.09375 14.644531 C 18.828125 14.644531 18.574219 14.667969 18.332031 14.714844 C 18.125 14.71875 17.941406 14.765625 17.773438 14.851562 L 17.636719 14.851562 C 17.421875 14.832031 17.308594 14.921875 17.285156 15.128906 L 17.148438 15.964844 C 17.105469 15.617188 17.058594 15.269531 17.007812 14.921875 L 16.9375 14.921875 C 16.910156 14.871094 16.863281 14.835938 16.800781 14.816406 L 16.140625 14.78125 C 15.890625 14.785156 15.671875 14.828125 15.476562 14.921875 C 15.5 15.078125 15.476562 15.214844 15.410156 15.339844 L 15.269531 14.78125 C 14.9375 14.546875 14.558594 14.378906 14.15625 14.296875 C 14.148438 14.253906 14.125 14.21875 14.085938 14.191406 L 12.207031 13.84375 C 11.683594 13.789062 11.171875 13.824219 10.679688 13.949219 C 10.488281 13.9375 10.347656 14.019531 10.261719 14.191406 C 10.171875 14.226562 10.078125 14.238281 9.984375 14.226562 L 9.914062 14.226562 C 9.789062 14.128906 9.742188 13.988281 9.773438 13.808594 L 9.773438 13.53125 C 10.839844 13.535156 11.90625 13.558594 12.972656 13.601562 C 13.183594 13.726562 13.414062 13.761719 13.667969 13.703125 C 13.511719 13.5625 13.328125 13.503906 13.113281 13.53125 C 12.886719 13.433594 12.652344 13.355469 12.417969 13.285156 C 11.882812 13.253906 11.351562 13.242188 10.816406 13.253906 C 10.515625 13.222656 10.492188 13.164062 10.746094 13.078125 L 10.679688 13.007812 C 10.898438 13.046875 11.105469 13.035156 11.304688 12.972656 C 11.609375 12.882812 11.921875 12.816406 12.242188 12.765625 C 12.597656 12.933594 12.957031 13.027344 13.320312 13.042969 C 13.449219 13.117188 13.589844 13.117188 13.738281 13.042969 C 14.007812 13.269531 14.3125 13.421875 14.644531 13.496094 C 14.523438 13.328125 14.5 13.15625 14.574219 12.972656 C 14.65625 13.183594 14.734375 13.390625 14.816406 13.601562 C 15 13.542969 15.164062 13.449219 15.304688 13.320312 C 15.300781 13.203125 15.289062 13.089844 15.269531 12.972656 C 14.871094 12.878906 14.472656 12.765625 14.085938 12.625 C 14.195312 12.558594 14.308594 12.535156 14.433594 12.554688 Z M 14.433594 12.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.156863%,21.960784%,13.333333%)",
      fillOpacity: 1
    },
    d: "M 13.738281 12.488281 L 14.433594 12.488281 L 14.433594 12.554688 C 14.308594 12.535156 14.195312 12.558594 14.085938 12.625 C 14.472656 12.765625 14.871094 12.878906 15.269531 12.972656 C 15.292969 13.09375 15.304688 13.210938 15.304688 13.320312 C 15.164062 13.449219 15 13.542969 14.816406 13.601562 C 14.734375 13.390625 14.65625 13.183594 14.574219 12.972656 C 14.5 13.15625 14.523438 13.328125 14.644531 13.496094 C 14.3125 13.421875 14.007812 13.269531 13.738281 13.042969 C 13.601562 12.929688 13.460938 12.8125 13.320312 12.695312 C 13.480469 12.640625 13.640625 12.605469 13.808594 12.589844 C 13.769531 12.566406 13.746094 12.53125 13.738281 12.488281 Z M 13.738281 12.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(27.45098%,18.039216%,10.980392%)",
      fillOpacity: 1
    },
    d: "M 20.140625 13.042969 C 20.4375 13.015625 20.71875 13.0625 20.972656 13.183594 C 20.722656 13.128906 20.464844 13.117188 20.207031 13.148438 C 20.503906 13.238281 20.808594 13.308594 21.113281 13.355469 C 21.695312 13.789062 21.601562 13.929688 20.835938 13.773438 C 20.964844 13.699219 20.976562 13.640625 20.871094 13.601562 C 20.605469 13.703125 20.335938 13.726562 20.070312 13.667969 C 20.222656 13.570312 20.382812 13.488281 20.554688 13.425781 C 20.15625 13.472656 19.761719 13.554688 19.375 13.667969 L 19.304688 13.601562 C 19.402344 13.550781 19.496094 13.492188 19.582031 13.425781 C 19.402344 13.382812 19.242188 13.417969 19.09375 13.53125 C 19.003906 13.507812 18.910156 13.484375 18.816406 13.460938 C 18.96875 13.355469 19.144531 13.285156 19.339844 13.253906 C 19.570312 13.3125 19.792969 13.292969 20 13.183594 C 20.09375 13.183594 20.140625 13.136719 20.140625 13.042969 Z M 20.140625 13.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(81.960784%,72.156863%,65.490196%)",
      fillOpacity: 1
    },
    d: "M 10.191406 13.042969 C 10.191406 13.089844 10.214844 13.113281 10.261719 13.113281 C 10.210938 13.195312 10.1875 13.289062 10.191406 13.390625 C 10.425781 13.421875 10.636719 13.375 10.816406 13.253906 C 11.351562 13.242188 11.882812 13.253906 12.417969 13.285156 C 12.652344 13.355469 12.886719 13.433594 13.113281 13.53125 C 13.089844 13.589844 13.042969 13.613281 12.972656 13.601562 C 11.90625 13.558594 10.839844 13.535156 9.773438 13.53125 C 9.8125 13.390625 9.90625 13.320312 10.050781 13.320312 C 10.027344 13.183594 10.074219 13.089844 10.191406 13.042969 Z M 10.191406 13.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.588235%,68.235294%,53.333333%)",
      fillOpacity: 1
    },
    d: "M 23.339844 12.972656 L 23.339844 13.042969 C 23.410156 13.691406 23.410156 14.34375 23.339844 14.992188 C 22.832031 14.992188 22.671875 14.734375 22.851562 14.226562 C 22.828125 14.144531 22.785156 14.089844 22.714844 14.050781 L 22.78125 13.984375 C 22.679688 13.878906 22.632812 13.753906 22.644531 13.601562 C 22.695312 13.320312 22.753906 13.042969 22.816406 12.765625 C 22.984375 12.851562 23.160156 12.921875 23.339844 12.972656 Z M 23.339844 12.972656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(44.705882%,43.137255%,42.745098%)",
      fillOpacity: 1
    },
    d: "M 13.113281 13.53125 C 13.328125 13.503906 13.511719 13.5625 13.667969 13.703125 C 13.414062 13.761719 13.183594 13.726562 12.972656 13.601562 C 13.042969 13.613281 13.089844 13.589844 13.113281 13.53125 Z M 13.113281 13.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(29.803922%,26.27451%,23.921569%)",
      fillOpacity: 1
    },
    d: "M 14.644531 13.878906 L 14.78125 14.015625 C 14.542969 14.003906 14.304688 13.945312 14.085938 13.84375 C 14.277344 13.792969 14.464844 13.804688 14.644531 13.878906 Z M 14.644531 13.878906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(89.803922%,78.431373%,70.980392%)",
      fillOpacity: 1
    },
    d: "M 17.84375 13.183594 C 17.613281 13.554688 17.683594 13.867188 18.050781 14.121094 C 19.003906 14.15625 19.953125 14.203125 20.90625 14.261719 C 21.261719 14.40625 21.636719 14.511719 22.015625 14.574219 C 22.066406 14.636719 22.136719 14.660156 22.226562 14.644531 C 22.402344 14.75 22.589844 14.84375 22.78125 14.921875 C 22.75 14.976562 22.703125 15 22.644531 14.992188 C 21.277344 14.65625 19.886719 14.46875 18.46875 14.433594 C 17.957031 14.484375 17.445312 14.484375 16.9375 14.433594 L 16.730469 14.433594 C 16.394531 14.359375 16.046875 14.3125 15.6875 14.296875 C 15.535156 14.269531 15.394531 14.222656 15.269531 14.15625 C 15.734375 14.164062 16.199219 14.1875 16.660156 14.226562 C 16.613281 13.949219 16.730469 13.832031 17.007812 13.878906 C 17.011719 14.027344 17.0625 14.171875 17.148438 14.296875 L 17.285156 14.226562 C 17.339844 14.101562 17.410156 13.984375 17.496094 13.878906 L 17.355469 13.738281 C 17.414062 13.625 17.425781 13.507812 17.390625 13.390625 C 17.585938 13.601562 17.679688 13.554688 17.667969 13.253906 C 17.714844 13.199219 17.773438 13.175781 17.84375 13.183594 Z M 17.84375 13.183594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(9.019608%,5.882353%,4.313725%)",
      fillOpacity: 1
    },
    d: "M 9.285156 13.667969 L 9.636719 13.667969 L 9.636719 14.15625 C 9.503906 14.136719 9.410156 14.183594 9.355469 14.296875 C 9.148438 14.347656 8.960938 14.441406 8.800781 14.574219 L 8.730469 14.574219 C 8.636719 14.5625 8.558594 14.585938 8.488281 14.644531 C 8.453125 14.484375 8.441406 14.320312 8.453125 14.15625 C 8.5 14.15625 8.523438 14.132812 8.523438 14.085938 C 8.738281 13.988281 8.960938 13.894531 9.183594 13.808594 C 9.253906 13.785156 9.289062 13.738281 9.285156 13.667969 Z M 9.285156 13.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(42.352941%,35.294118%,30.980392%)",
      fillOpacity: 1
    },
    d: "M 9.636719 13.667969 L 9.773438 13.808594 C 9.742188 13.988281 9.789062 14.128906 9.914062 14.226562 C 9.738281 14.226562 9.550781 14.25 9.355469 14.296875 C 9.410156 14.183594 9.503906 14.136719 9.636719 14.15625 Z M 9.636719 13.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(70.588235%,60.784314%,54.509804%)",
      fillOpacity: 1
    },
    d: "M 14.15625 14.296875 C 14.105469 14.285156 14.054688 14.296875 14.015625 14.332031 C 14.121094 14.511719 14.167969 14.710938 14.15625 14.921875 C 14.074219 14.890625 14.003906 14.84375 13.949219 14.78125 C 14.089844 14.769531 14.113281 14.710938 14.015625 14.609375 C 13.15625 14.042969 12.242188 13.9375 11.269531 14.296875 L 11.09375 14.226562 C 11.246094 14.164062 11.386719 14.082031 11.511719 13.984375 C 11.234375 13.949219 10.957031 13.9375 10.679688 13.949219 C 11.171875 13.824219 11.683594 13.789062 12.207031 13.84375 L 14.085938 14.191406 C 14.125 14.21875 14.148438 14.253906 14.15625 14.296875 Z M 14.15625 14.296875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(44.313725%,31.764706%,20%)",
      fillOpacity: 1
    },
    d: "M 8.453125 13.667969 C 8.433594 13.824219 8.453125 13.964844 8.523438 14.085938 C 8.523438 14.132812 8.5 14.15625 8.453125 14.15625 L 8.3125 14.296875 C 8.1875 14.160156 8.046875 14.113281 7.894531 14.15625 C 7.910156 14.011719 7.980469 13.894531 8.105469 13.808594 L 7.964844 13.667969 L 8.175781 13.390625 C 8.097656 13.355469 8.027344 13.332031 7.964844 13.320312 C 8.136719 13.136719 8.230469 12.941406 8.242188 12.730469 L 8.3125 12.695312 C 8.359375 13.03125 8.40625 13.355469 8.453125 13.667969 Z M 8.453125 13.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(11.764706%,6.666667%,3.921569%)",
      fillOpacity: 1
    },
    d: "M 18.050781 13.042969 C 18.121094 13.042969 18.167969 13.078125 18.191406 13.148438 C 18.136719 13.261719 18.066406 13.367188 17.984375 13.460938 C 18.035156 13.546875 18.09375 13.546875 18.15625 13.460938 C 18.175781 13.523438 18.210938 13.570312 18.261719 13.601562 C 18.445312 13.542969 18.628906 13.5 18.816406 13.460938 C 18.910156 13.484375 19 13.507812 19.09375 13.53125 C 19.242188 13.417969 19.402344 13.382812 19.582031 13.425781 C 19.496094 13.492188 19.402344 13.550781 19.304688 13.601562 L 19.375 13.667969 C 19.761719 13.554688 20.15625 13.472656 20.554688 13.425781 C 20.382812 13.488281 20.222656 13.570312 20.070312 13.667969 C 20.335938 13.726562 20.605469 13.703125 20.871094 13.601562 C 20.976562 13.640625 20.964844 13.699219 20.835938 13.773438 C 21.601562 13.929688 21.695312 13.789062 21.113281 13.355469 C 20.808594 13.308594 20.503906 13.238281 20.207031 13.148438 C 20.464844 13.117188 20.722656 13.128906 20.972656 13.183594 C 21.355469 13.308594 21.65625 13.539062 21.878906 13.878906 C 21.890625 13.949219 21.875 14.023438 21.84375 14.085938 C 21.769531 14.015625 21.6875 14.003906 21.601562 14.050781 C 21.820312 14.121094 21.84375 14.214844 21.667969 14.332031 C 21.828125 14.421875 21.945312 14.503906 22.015625 14.574219 C 21.636719 14.511719 21.261719 14.40625 20.90625 14.261719 C 19.953125 14.203125 19.003906 14.15625 18.050781 14.121094 C 17.683594 13.867188 17.613281 13.554688 17.84375 13.183594 Z M 18.050781 13.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(24.313725%,17.254902%,12.54902%)",
      fillOpacity: 1
    },
    d: "M 21.878906 13.878906 C 22.011719 14.105469 22.175781 14.316406 22.363281 14.503906 C 22.363281 14.597656 22.320312 14.644531 22.226562 14.644531 C 22.136719 14.660156 22.066406 14.636719 22.015625 14.574219 C 21.945312 14.503906 21.828125 14.421875 21.667969 14.332031 C 21.84375 14.214844 21.820312 14.121094 21.601562 14.050781 C 21.6875 14.003906 21.769531 14.015625 21.84375 14.085938 C 21.875 14.023438 21.890625 13.949219 21.878906 13.878906 Z M 21.878906 13.878906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(87.45098%,68.235294%,55.686275%)",
      fillOpacity: 1
    },
    d: "M 22.921875 12.207031 C 22.925781 12.511719 23.066406 12.722656 23.339844 12.835938 L 23.339844 12.972656 C 23.160156 12.921875 22.984375 12.851562 22.816406 12.765625 C 22.753906 13.042969 22.695312 13.320312 22.644531 13.601562 C 22.632812 13.753906 22.679688 13.878906 22.78125 13.984375 L 22.714844 14.050781 C 22.785156 14.089844 22.828125 14.144531 22.851562 14.226562 C 22.671875 14.734375 22.832031 14.992188 23.339844 14.992188 C 23.410156 14.34375 23.410156 13.691406 23.339844 13.042969 C 23.386719 13.042969 23.410156 13.066406 23.410156 13.113281 C 23.464844 13.921875 23.488281 14.734375 23.476562 15.546875 L 23.199219 15.546875 C 23.152344 15.484375 23.082031 15.460938 22.992188 15.476562 C 23.011719 15.324219 22.988281 15.183594 22.921875 15.0625 C 22.808594 15.078125 22.71875 15.054688 22.644531 14.992188 C 22.703125 15 22.75 14.976562 22.78125 14.921875 C 22.589844 14.84375 22.402344 14.75 22.226562 14.644531 C 22.320312 14.644531 22.363281 14.597656 22.363281 14.503906 C 22.453125 14.507812 22.511719 14.554688 22.539062 14.644531 C 22.570312 14.375 22.523438 14.121094 22.398438 13.878906 C 22.355469 13.667969 22.355469 13.460938 22.398438 13.253906 C 22.542969 12.878906 22.71875 12.53125 22.921875 12.207031 Z M 22.921875 12.207031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(63.921569%,49.803922%,40%)",
      fillOpacity: 1
    },
    d: "M 23.339844 12.835938 L 23.410156 12.835938 C 23.621094 12.992188 23.773438 13.199219 23.859375 13.460938 C 23.894531 14.226562 23.90625 14.992188 23.894531 15.757812 C 23.917969 15.894531 23.875 15.988281 23.757812 16.035156 C 23.601562 15.863281 23.441406 15.699219 23.269531 15.546875 L 23.476562 15.546875 C 23.472656 15.578125 23.484375 15.601562 23.511719 15.617188 C 23.621094 15.574219 23.722656 15.53125 23.824219 15.476562 C 23.769531 15.320312 23.722656 15.15625 23.6875 14.992188 C 23.75 14.425781 23.703125 13.847656 23.546875 13.253906 C 23.53125 13.167969 23.484375 13.121094 23.410156 13.113281 C 23.410156 13.066406 23.386719 13.042969 23.339844 13.042969 Z M 23.339844 12.835938 "
  }), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface83",
    mask: "url(#mask26)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(47.843137%,40.392157%,35.294118%)",
      fillOpacity: 1
    },
    d: "M 15.6875 14.296875 C 16.046875 14.3125 16.394531 14.359375 16.730469 14.433594 C 16.363281 14.457031 16.015625 14.410156 15.6875 14.296875 Z M 15.6875 14.296875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(35.686275%,30.196078%,26.27451%)",
      fillOpacity: 1
    },
    d: "M 16.9375 14.433594 C 17.445312 14.484375 17.957031 14.484375 18.46875 14.433594 C 17.957031 14.589844 17.445312 14.589844 16.9375 14.433594 Z M 16.9375 14.433594 "
  }), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface86",
    mask: "url(#mask27)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(24.705882%,18.431373%,14.509804%)",
      fillOpacity: 1
    },
    d: "M 18.332031 14.714844 C 18.574219 14.667969 18.828125 14.644531 19.09375 14.644531 C 19.378906 14.644531 19.632812 14.691406 19.859375 14.78125 C 19.351562 14.730469 18.839844 14.707031 18.332031 14.714844 Z M 18.332031 14.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(70.196078%,51.372549%,39.215686%)",
      fillOpacity: 1
    },
    d: "M 23.410156 13.113281 C 23.484375 13.121094 23.53125 13.167969 23.546875 13.253906 C 23.703125 13.847656 23.75 14.425781 23.6875 14.992188 C 23.722656 15.15625 23.769531 15.320312 23.824219 15.476562 C 23.722656 15.53125 23.621094 15.574219 23.511719 15.617188 C 23.484375 15.601562 23.472656 15.578125 23.476562 15.546875 C 23.488281 14.734375 23.464844 13.921875 23.410156 13.113281 Z M 23.410156 13.113281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(30.588235%,25.490196%,22.352941%)",
      fillOpacity: 1
    },
    d: "M 16.9375 14.921875 C 16.464844 14.839844 16 14.839844 15.546875 14.921875 L 15.476562 14.921875 C 15.671875 14.828125 15.890625 14.785156 16.140625 14.78125 L 16.800781 14.816406 C 16.863281 14.835938 16.910156 14.871094 16.9375 14.921875 Z M 16.9375 14.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(74.509804%,64.705882%,58.431373%)",
      fillOpacity: 1
    },
    d: "M 18.332031 14.714844 C 18.84375 14.707031 19.351562 14.730469 19.859375 14.78125 C 20.035156 14.8125 20.199219 14.859375 20.347656 14.921875 C 20.265625 15.050781 20.125 15.15625 19.929688 15.234375 C 19.96875 15.261719 19.992188 15.296875 20 15.339844 L 19.859375 15.339844 C 19.851562 15.296875 19.828125 15.261719 19.792969 15.234375 C 19.65625 15.199219 19.515625 15.1875 19.375 15.199219 L 18.816406 15.199219 C 19.082031 15.144531 19.359375 15.109375 19.652344 15.09375 C 19.261719 15.011719 18.867188 14.964844 18.46875 14.957031 C 18.578125 14.898438 18.695312 14.851562 18.816406 14.816406 C 18.636719 14.769531 18.445312 14.769531 18.261719 14.816406 C 18.34375 14.863281 18.34375 14.898438 18.261719 14.921875 C 18.105469 14.859375 17.9375 14.835938 17.773438 14.851562 C 17.941406 14.765625 18.125 14.71875 18.332031 14.714844 Z M 18.332031 14.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.156863%,79.607843%,71.372549%)",
      fillOpacity: 1
    },
    d: "M 18.816406 15.199219 C 18.621094 15.300781 18.414062 15.347656 18.191406 15.339844 C 18.054688 15.304688 18.054688 15.222656 18.191406 15.09375 C 17.957031 14.972656 17.710938 14.960938 17.460938 15.0625 L 17.425781 14.992188 C 17.496094 14.949219 17.566406 14.902344 17.636719 14.851562 L 17.773438 14.851562 C 17.941406 14.835938 18.105469 14.859375 18.261719 14.921875 C 18.34375 14.898438 18.34375 14.863281 18.261719 14.816406 C 18.445312 14.769531 18.636719 14.769531 18.816406 14.816406 C 18.695312 14.851562 18.578125 14.898438 18.46875 14.957031 C 18.867188 14.964844 19.261719 15.011719 19.652344 15.09375 C 19.359375 15.109375 19.082031 15.144531 18.816406 15.199219 Z M 18.816406 15.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(18.039216%,12.156863%,9.411765%)",
      fillOpacity: 1
    },
    d: "M 8.453125 14.15625 C 8.441406 14.320312 8.453125 14.484375 8.488281 14.644531 C 8.558594 14.585938 8.636719 14.5625 8.730469 14.574219 L 8.453125 14.78125 C 8.167969 14.75 8.007812 14.863281 7.964844 15.128906 C 8.046875 15.113281 8.117188 15.136719 8.175781 15.199219 C 8.113281 15.332031 8.042969 15.460938 7.964844 15.582031 C 8.148438 15.742188 8.125 15.867188 7.894531 15.964844 C 7.84375 16.15625 7.796875 16.386719 7.757812 16.660156 C 7.769531 16.21875 7.757812 15.777344 7.722656 15.339844 C 7.601562 15.230469 7.496094 15.113281 7.410156 14.992188 C 7.226562 14.714844 6.972656 14.585938 6.644531 14.609375 C 6.457031 14.890625 6.367188 15.203125 6.363281 15.546875 L 6.226562 16.035156 C 6.214844 15.589844 6.238281 15.152344 6.296875 14.714844 C 6.394531 14.679688 6.441406 14.609375 6.433594 14.503906 C 6.664062 14.421875 6.898438 14.421875 7.128906 14.503906 C 7.199219 14.492188 7.246094 14.515625 7.269531 14.574219 C 7.269531 14.679688 7.316406 14.761719 7.410156 14.816406 C 7.5 14.855469 7.546875 14.820312 7.546875 14.714844 C 7.546875 14.621094 7.59375 14.574219 7.6875 14.574219 C 7.695312 14.617188 7.71875 14.652344 7.757812 14.679688 C 7.59375 14.820312 7.59375 14.949219 7.757812 15.0625 C 7.765625 14.949219 7.824219 14.835938 7.929688 14.714844 L 8 14.78125 C 8.074219 14.671875 8.175781 14.625 8.3125 14.644531 C 8.351562 14.515625 8.351562 14.398438 8.3125 14.296875 Z M 8.453125 14.15625 "
  }), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface89",
    mask: "url(#mask28)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(45.098039%,31.764706%,19.215686%)",
      fillOpacity: 1
    },
    d: "M 8.453125 14.78125 L 8.453125 15.269531 C 8.347656 15.601562 8.289062 15.949219 8.277344 16.3125 C 8.230469 16.457031 8.152344 16.574219 8.035156 16.660156 C 8.058594 16.429688 8.011719 16.199219 7.894531 15.964844 C 8.125 15.867188 8.148438 15.742188 7.964844 15.582031 C 8.042969 15.460938 8.113281 15.332031 8.175781 15.199219 C 8.117188 15.136719 8.046875 15.113281 7.964844 15.128906 C 8.007812 14.863281 8.167969 14.75 8.453125 14.78125 Z M 8.453125 14.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(87.45098%,69.803922%,58.431373%)",
      fillOpacity: 1
    },
    d: "M 17.636719 14.851562 C 17.566406 14.902344 17.496094 14.949219 17.425781 14.992188 L 17.460938 15.0625 C 17.710938 14.960938 17.957031 14.972656 18.191406 15.09375 C 18.054688 15.222656 18.054688 15.304688 18.191406 15.339844 C 18.183594 15.382812 18.160156 15.417969 18.121094 15.445312 C 18.210938 15.476562 18.304688 15.488281 18.398438 15.476562 L 18.398438 15.546875 C 18.351562 15.710938 18.304688 15.871094 18.261719 16.035156 C 18.136719 15.980469 18.007812 15.933594 17.878906 15.894531 C 17.792969 15.972656 17.710938 15.972656 17.636719 15.894531 C 17.585938 15.929688 17.550781 15.980469 17.53125 16.035156 C 17.394531 15.667969 17.335938 15.691406 17.355469 16.105469 C 17.289062 15.792969 17.265625 15.46875 17.285156 15.128906 C 17.308594 14.921875 17.421875 14.832031 17.636719 14.851562 Z M 17.636719 14.851562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(40.392157%,34.901961%,30.980392%)",
      fillOpacity: 1
    },
    d: "M 6.363281 15.546875 C 6.375 15.875 6.363281 16.199219 6.332031 16.523438 C 6.3125 16.457031 6.277344 16.410156 6.226562 16.382812 C 6.15625 16.351562 6.15625 16.304688 6.226562 16.242188 L 6.226562 16.035156 Z M 6.363281 15.546875 "
  }), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface92",
    mask: "url(#mask29)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(33.333333%,23.921569%,17.254902%)",
      fillOpacity: 1
    },
    d: "M 15.269531 14.78125 L 15.410156 15.339844 C 15.371094 15.601562 15.300781 15.859375 15.199219 16.105469 C 15.066406 16.332031 14.9375 16.5625 14.816406 16.800781 L 14.78125 16.660156 C 15.101562 16.078125 15.261719 15.449219 15.269531 14.78125 Z M 15.269531 14.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(15.294118%,10.196078%,8.235294%)",
      fillOpacity: 1
    },
    d: "M 24.453125 8.730469 C 24.484375 8.828125 24.554688 8.875 24.660156 8.871094 C 24.710938 8.898438 24.746094 8.945312 24.765625 9.007812 C 24.832031 10.792969 24.855469 12.578125 24.835938 14.363281 C 24.726562 15.035156 24.574219 15.683594 24.382812 16.3125 C 24.28125 16.449219 24.304688 16.566406 24.453125 16.660156 C 24.40625 16.796875 24.382812 16.9375 24.382812 17.078125 C 24.304688 17.132812 24.226562 17.179688 24.140625 17.21875 C 24.125 17.347656 24.089844 17.464844 24.035156 17.566406 C 23.9375 17.707031 23.890625 17.867188 23.894531 18.050781 C 23.644531 18.632812 23.460938 19.234375 23.339844 19.859375 C 23.191406 20.292969 23.074219 20.734375 22.992188 21.183594 C 22.890625 21.324219 22.847656 21.484375 22.851562 21.667969 C 22.699219 22.101562 22.582031 22.542969 22.503906 22.992188 C 22.429688 22.832031 22.429688 22.671875 22.503906 22.503906 L 22.226562 22.503906 C 22.25 22.332031 22.207031 22.285156 22.085938 22.363281 C 22.6875 20.777344 23.171875 19.152344 23.546875 17.496094 C 23.613281 17.527344 23.671875 17.574219 23.722656 17.636719 C 23.738281 17.503906 23.773438 17.375 23.824219 17.253906 L 23.757812 17.183594 C 23.820312 17.148438 23.894531 17.136719 23.964844 17.148438 C 24 16.917969 23.929688 16.730469 23.757812 16.589844 C 23.660156 16.425781 23.519531 16.308594 23.339844 16.242188 C 23.296875 16.085938 23.207031 15.972656 23.0625 15.894531 C 23.03125 15.738281 23.078125 15.621094 23.199219 15.546875 L 23.269531 15.546875 C 23.441406 15.699219 23.601562 15.863281 23.757812 16.035156 C 23.847656 16.101562 23.894531 16.195312 23.894531 16.3125 L 24.105469 16.3125 C 24.117188 16.03125 24.152344 15.753906 24.207031 15.476562 L 24.277344 15.546875 C 24.300781 15.386719 24.359375 15.230469 24.453125 15.09375 C 24.402344 14.914062 24.332031 14.738281 24.242188 14.574219 L 24.523438 14.503906 C 24.480469 14.351562 24.410156 14.210938 24.3125 14.085938 C 24.394531 14.003906 24.460938 13.910156 24.523438 13.808594 C 24.585938 13.886719 24.644531 13.886719 24.695312 13.808594 C 24.75 13.609375 24.738281 13.421875 24.660156 13.253906 C 24.503906 13.230469 24.367188 13.253906 24.242188 13.320312 C 24.136719 13.390625 24.089844 13.496094 24.105469 13.636719 C 24.203125 14.367188 24.132812 15.074219 23.894531 15.757812 C 23.90625 14.992188 23.894531 14.226562 23.859375 13.460938 C 23.773438 13.199219 23.621094 12.992188 23.410156 12.835938 C 23.4375 12.785156 23.484375 12.75 23.546875 12.730469 C 23.433594 12.5 23.25 12.394531 22.992188 12.417969 C 22.992188 12.277344 23.015625 12.132812 23.0625 12 C 23.082031 11.867188 23.128906 11.75 23.199219 11.652344 C 23.386719 11.585938 23.574219 11.519531 23.757812 11.445312 C 23.832031 11.5 23.925781 11.535156 24.035156 11.546875 C 23.957031 11.617188 23.980469 11.664062 24.105469 11.6875 C 23.851562 11.742188 23.59375 11.789062 23.339844 11.824219 C 23.425781 11.925781 23.425781 12.03125 23.339844 12.140625 C 23.507812 12.253906 23.695312 12.335938 23.894531 12.382812 L 23.6875 12.453125 C 23.800781 12.46875 23.871094 12.527344 23.894531 12.625 C 23.921875 12.726562 23.992188 12.785156 24.105469 12.800781 C 24.242188 12.835938 24.378906 12.847656 24.523438 12.835938 C 24.507812 12.917969 24.53125 12.984375 24.589844 13.042969 L 24.660156 12.765625 C 24.621094 11.746094 24.574219 10.722656 24.523438 9.703125 C 24.46875 9.652344 24.398438 9.617188 24.3125 9.601562 C 24.402344 9.566406 24.496094 9.554688 24.589844 9.566406 C 24.613281 9.386719 24.589844 9.226562 24.523438 9.078125 C 24.441406 8.9375 24.324219 8.835938 24.175781 8.765625 C 24.261719 8.730469 24.359375 8.71875 24.453125 8.730469 Z M 24.453125 8.730469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(38.823529%,27.45098%,18.039216%)",
      fillOpacity: 1
    },
    d: "M 24.660156 13.253906 C 24.738281 13.421875 24.75 13.609375 24.695312 13.808594 C 24.644531 13.886719 24.585938 13.886719 24.523438 13.808594 C 24.460938 13.910156 24.394531 14.003906 24.3125 14.085938 C 24.410156 14.210938 24.480469 14.351562 24.523438 14.503906 L 24.242188 14.574219 C 24.332031 14.738281 24.402344 14.914062 24.453125 15.09375 C 24.359375 15.230469 24.300781 15.386719 24.277344 15.546875 L 24.207031 15.476562 C 24.152344 15.753906 24.117188 16.03125 24.105469 16.3125 L 23.894531 16.3125 C 23.894531 16.195312 23.847656 16.101562 23.757812 16.035156 C 23.875 15.988281 23.917969 15.894531 23.894531 15.757812 C 24.132812 15.074219 24.203125 14.367188 24.105469 13.636719 C 24.089844 13.496094 24.136719 13.390625 24.242188 13.320312 C 24.316406 13.535156 24.457031 13.671875 24.660156 13.738281 Z M 24.660156 13.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(47.45098%,33.72549%,21.176471%)",
      fillOpacity: 1
    },
    d: "M 24.660156 13.253906 L 24.660156 13.738281 C 24.457031 13.671875 24.316406 13.535156 24.242188 13.320312 C 24.367188 13.253906 24.503906 13.230469 24.660156 13.253906 Z M 24.660156 13.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(20.392157%,9.411765%,3.529412%)",
      fillOpacity: 1
    },
    d: "M 23.757812 11.445312 C 23.921875 11.433594 24.082031 11.445312 24.242188 11.476562 C 24.464844 11.546875 24.484375 11.640625 24.3125 11.757812 C 24.050781 11.785156 23.796875 11.84375 23.546875 11.929688 L 24.105469 12.070312 C 23.984375 12.117188 23.867188 12.175781 23.757812 12.242188 C 23.941406 12.265625 24.101562 12.335938 24.242188 12.453125 C 24.164062 12.582031 24.046875 12.640625 23.894531 12.625 C 23.871094 12.527344 23.800781 12.46875 23.6875 12.453125 L 23.894531 12.382812 C 23.695312 12.335938 23.507812 12.253906 23.339844 12.140625 C 23.425781 12.03125 23.425781 11.925781 23.339844 11.824219 C 23.59375 11.789062 23.851562 11.742188 24.105469 11.6875 C 23.980469 11.664062 23.957031 11.617188 24.035156 11.546875 C 23.925781 11.535156 23.832031 11.5 23.757812 11.445312 Z M 23.757812 11.445312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(66.666667%,50.588235%,40%)",
      fillOpacity: 1
    },
    d: "M 8.730469 14.574219 L 8.800781 14.574219 C 8.824219 14.742188 8.753906 14.847656 8.589844 14.886719 C 8.683594 15.753906 8.730469 16.632812 8.730469 17.53125 C 8.71875 18.769531 8.699219 20.011719 8.660156 21.253906 L 8.589844 21.253906 C 8.585938 20.714844 8.527344 20.179688 8.417969 19.652344 C 8.382812 18.839844 8.371094 18.027344 8.382812 17.21875 C 8.453125 16.582031 8.476562 15.929688 8.453125 15.269531 L 8.453125 14.78125 Z M 8.730469 14.574219 "
  }), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface95",
    mask: "url(#mask30)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(83.921569%,76.078431%,70.588235%)",
      fillOpacity: 1
    },
    d: "M 7.410156 14.992188 C 7.234375 14.847656 7.023438 14.753906 6.78125 14.714844 C 6.691406 14.753906 6.632812 14.824219 6.609375 14.921875 C 6.507812 15.472656 6.484375 16.035156 6.539062 16.589844 C 6.65625 16.636719 6.785156 16.636719 6.921875 16.589844 C 6.503906 17.292969 6.339844 18.058594 6.433594 18.886719 C 6.382812 18.785156 6.335938 18.679688 6.296875 18.574219 C 6.351562 18.179688 6.398438 17.785156 6.433594 17.390625 C 6.371094 17.054688 6.300781 16.71875 6.226562 16.382812 C 6.277344 16.410156 6.3125 16.457031 6.332031 16.523438 C 6.363281 16.199219 6.375 15.875 6.363281 15.546875 C 6.367188 15.203125 6.457031 14.890625 6.644531 14.609375 C 6.972656 14.585938 7.226562 14.714844 7.410156 14.992188 Z M 7.410156 14.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(70.588235%,52.156863%,39.607843%)",
      fillOpacity: 1
    },
    d: "M 23.339844 16.382812 C 23.523438 16.433594 23.566406 16.539062 23.476562 16.695312 C 23.613281 16.820312 23.644531 16.96875 23.582031 17.148438 C 23.523438 17.253906 23.441406 17.289062 23.339844 17.253906 L 23.410156 17.183594 C 23.3125 17.101562 23.253906 16.996094 23.234375 16.871094 C 23.121094 17.179688 23.0625 17.480469 23.0625 17.773438 C 23.347656 17.808594 23.40625 17.949219 23.234375 18.191406 L 23.164062 18.121094 C 23.125 18.257812 23.054688 18.28125 22.957031 18.191406 C 22.8125 18.277344 22.824219 18.332031 22.992188 18.363281 C 22.925781 18.785156 22.808594 19.214844 22.644531 19.652344 C 22.65625 19.757812 22.679688 19.863281 22.714844 19.964844 C 22.636719 20.15625 22.542969 20.328125 22.433594 20.488281 C 22.554688 19.578125 22.695312 18.675781 22.851562 17.773438 C 22.988281 17.300781 23.148438 16.835938 23.339844 16.382812 Z M 23.339844 16.382812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.54902%,77.647059%,67.45098%)",
      fillOpacity: 1
    },
    d: "M 7.410156 14.992188 C 7.496094 15.113281 7.601562 15.230469 7.722656 15.339844 C 7.757812 15.777344 7.769531 16.21875 7.757812 16.660156 C 7.777344 16.964844 7.753906 17.269531 7.6875 17.566406 C 7.597656 17.582031 7.527344 17.558594 7.476562 17.496094 C 7.445312 17.378906 7.445312 17.273438 7.476562 17.183594 L 7.375 17.078125 C 6.722656 17.730469 6.617188 18.460938 7.0625 19.269531 C 7.046875 19.296875 7.023438 19.308594 6.992188 19.304688 C 6.90625 19.25 6.835938 19.179688 6.78125 19.09375 C 6.542969 18.609375 6.507812 18.097656 6.679688 17.566406 C 6.789062 17.203125 6.941406 16.851562 7.128906 16.523438 L 7.0625 16.453125 C 7.015625 16.5 6.96875 16.546875 6.921875 16.589844 C 6.785156 16.636719 6.65625 16.636719 6.539062 16.589844 C 6.484375 16.035156 6.507812 15.472656 6.609375 14.921875 C 6.632812 14.824219 6.691406 14.753906 6.78125 14.714844 C 7.023438 14.753906 7.234375 14.847656 7.410156 14.992188 Z M 7.410156 14.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(37.647059%,25.882353%,16.470588%)",
      fillOpacity: 1
    },
    d: "M 6.644531 15.546875 C 6.773438 15.535156 6.878906 15.578125 6.957031 15.6875 C 7.207031 16.144531 7.160156 16.191406 6.816406 15.824219 C 6.777344 15.929688 6.71875 16.023438 6.644531 16.105469 C 6.566406 15.917969 6.566406 15.734375 6.644531 15.546875 Z M 6.644531 15.546875 "
  }), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface98",
    mask: "url(#mask31)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(50.196078%,38.431373%,29.411765%)",
      fillOpacity: 1
    },
    d: "M 22.921875 15.0625 C 22.988281 15.183594 23.011719 15.324219 22.992188 15.476562 C 23.082031 15.460938 23.152344 15.484375 23.199219 15.546875 C 23.078125 15.621094 23.03125 15.738281 23.0625 15.894531 C 22.992188 15.804688 22.902344 15.757812 22.78125 15.757812 C 22.773438 16.566406 22.492188 17.261719 21.949219 17.84375 C 21.269531 18.308594 20.527344 18.449219 19.722656 18.261719 L 19.722656 18.191406 C 21.609375 18.414062 22.605469 17.578125 22.714844 15.6875 L 22.921875 15.6875 Z M 22.921875 15.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(32.54902%,20.392157%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 23.757812 16.589844 C 23.929688 16.730469 24 16.917969 23.964844 17.148438 C 23.894531 17.136719 23.820312 17.148438 23.757812 17.183594 L 23.824219 17.253906 C 23.773438 17.375 23.738281 17.503906 23.722656 17.636719 C 23.671875 17.574219 23.613281 17.527344 23.546875 17.496094 C 23.65625 17.203125 23.726562 16.898438 23.757812 16.589844 Z M 23.757812 16.589844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(70.196078%,57.647059%,49.019608%)",
      fillOpacity: 1
    },
    d: "M 10.050781 15.894531 C 10.234375 16.554688 10.652344 17.007812 11.304688 17.253906 C 12.035156 17.417969 12.785156 17.464844 13.53125 17.390625 C 13.777344 17.378906 13.996094 17.296875 14.191406 17.148438 L 14.296875 17.21875 C 14.214844 17.292969 14.121094 17.351562 14.015625 17.390625 C 12.996094 17.664062 12 17.605469 11.027344 17.21875 C 10.492188 17.054688 10.144531 16.703125 9.984375 16.175781 C 9.964844 16.0625 9.988281 15.96875 10.050781 15.894531 Z M 10.050781 15.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(94.117647%,81.176471%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 10.679688 13.949219 C 10.957031 13.9375 11.234375 13.949219 11.511719 13.984375 C 11.386719 14.082031 11.246094 14.164062 11.09375 14.226562 L 11.269531 14.296875 C 12.242188 13.9375 13.15625 14.042969 14.015625 14.609375 C 14.113281 14.710938 14.089844 14.769531 13.949219 14.78125 C 13.308594 14.367188 12.613281 14.261719 11.859375 14.46875 C 11.738281 14.539062 11.621094 14.621094 11.511719 14.714844 C 11.40625 14.730469 11.3125 14.777344 11.234375 14.851562 C 10.722656 15.304688 10.804688 15.441406 11.476562 15.269531 C 11.726562 15.296875 11.96875 15.34375 12.207031 15.410156 C 12.441406 15.398438 12.675781 15.421875 12.90625 15.476562 C 13.054688 15.523438 13.214844 15.546875 13.390625 15.546875 C 13.582031 15.546875 13.746094 15.5 13.878906 15.410156 C 14.058594 15.371094 14.128906 15.253906 14.085938 15.0625 C 14.238281 15.066406 14.261719 15.019531 14.15625 14.921875 C 14.167969 14.710938 14.121094 14.511719 14.015625 14.332031 C 14.054688 14.296875 14.105469 14.285156 14.15625 14.296875 C 14.558594 14.378906 14.9375 14.546875 15.269531 14.78125 C 15.261719 15.449219 15.101562 16.078125 14.78125 16.660156 L 14.816406 16.800781 C 14.9375 16.5625 15.066406 16.332031 15.199219 16.105469 C 15.242188 16.097656 15.277344 16.074219 15.304688 16.035156 C 15.339844 16.40625 15.328125 16.78125 15.269531 17.148438 C 15.105469 17.371094 14.953125 17.601562 14.816406 17.84375 C 14.757812 18.152344 14.78125 18.453125 14.886719 18.746094 C 14.910156 18.214844 15.09375 17.753906 15.445312 17.355469 C 15.539062 17.128906 15.621094 16.898438 15.6875 16.660156 C 15.792969 16.5 15.839844 16.3125 15.824219 16.105469 C 15.894531 15.816406 15.917969 15.515625 15.894531 15.199219 C 15.65625 15.25 15.539062 15.160156 15.546875 14.921875 C 16 14.839844 16.464844 14.839844 16.9375 14.921875 L 17.007812 14.921875 C 16.988281 15.390625 17.011719 15.855469 17.078125 16.3125 C 16.855469 16.652344 16.707031 17.070312 16.625 17.566406 C 16.585938 17.820312 16.597656 18.082031 16.660156 18.332031 C 16.882812 18.5 17.136719 18.617188 17.425781 18.679688 L 17.148438 17.078125 L 17.183594 16.660156 C 17.203125 16.722656 17.238281 16.769531 17.285156 16.800781 C 17.289062 16.980469 17.359375 17.050781 17.496094 17.007812 C 17.410156 16.714844 17.363281 16.410156 17.355469 16.105469 C 17.335938 15.691406 17.394531 15.667969 17.53125 16.035156 C 17.550781 15.980469 17.585938 15.929688 17.636719 15.894531 C 17.710938 15.972656 17.792969 15.972656 17.878906 15.894531 C 18.007812 15.933594 18.136719 15.980469 18.261719 16.035156 C 18.304688 15.871094 18.351562 15.710938 18.398438 15.546875 C 18.386719 15.71875 18.410156 15.878906 18.46875 16.035156 C 18.472656 16.109375 18.496094 16.183594 18.539062 16.242188 C 18.707031 16.300781 18.867188 16.371094 19.027344 16.453125 C 19.261719 16.335938 19.484375 16.359375 19.6875 16.523438 C 19.933594 16.484375 20.175781 16.4375 20.417969 16.382812 C 20.695312 16.414062 20.972656 16.507812 21.253906 16.660156 C 21.265625 16.457031 21.171875 16.296875 20.972656 16.175781 C 20.855469 16.007812 20.71875 15.859375 20.554688 15.722656 C 20.359375 15.613281 20.171875 15.484375 20 15.339844 C 19.992188 15.296875 19.96875 15.261719 19.929688 15.234375 C 20.125 15.15625 20.265625 15.050781 20.347656 14.921875 C 20.929688 15.023438 21.507812 15.128906 22.085938 15.234375 L 22.296875 15.339844 C 22.308594 15.609375 22.449219 15.722656 22.714844 15.6875 C 22.605469 17.578125 21.609375 18.414062 19.722656 18.191406 C 19.246094 18.152344 18.78125 18.050781 18.332031 17.878906 C 18.101562 17.71875 17.890625 17.53125 17.703125 17.320312 C 17.644531 17.273438 17.601562 17.285156 17.566406 17.355469 C 17.792969 17.609375 18.046875 17.832031 18.332031 18.015625 C 18.78125 18.15625 19.25 18.238281 19.722656 18.261719 C 20.527344 18.449219 21.269531 18.308594 21.949219 17.84375 C 21.964844 17.929688 21.964844 18.007812 21.949219 18.085938 C 21.867188 18.15625 21.796875 18.238281 21.738281 18.332031 C 21.640625 18.394531 21.546875 18.476562 21.460938 18.574219 C 21.304688 18.589844 21.15625 18.625 21.007812 18.679688 C 20.960938 18.492188 20.914062 18.492188 20.871094 18.679688 L 20.800781 18.539062 C 20.558594 18.667969 20.289062 18.714844 20 18.679688 C 20.011719 18.75 20 18.824219 19.964844 18.886719 L 19.757812 18.609375 C 19.648438 18.683594 19.554688 18.777344 19.476562 18.886719 C 19.457031 18.78125 19.410156 18.6875 19.339844 18.609375 L 18.992188 18.679688 L 18.816406 18.503906 C 18.46875 18.457031 18.121094 18.457031 17.773438 18.503906 C 17.6875 18.605469 17.6875 18.710938 17.773438 18.816406 C 17.914062 18.933594 18.082031 19.019531 18.261719 19.0625 L 18.191406 19.128906 C 18.242188 19.230469 18.277344 19.335938 18.296875 19.445312 C 18.339844 19.359375 18.375 19.359375 18.398438 19.445312 C 18.128906 19.789062 18.011719 20.179688 18.050781 20.625 C 17.902344 20.574219 17.753906 20.527344 17.601562 20.488281 L 17.355469 20.554688 C 17.421875 20.664062 17.503906 20.757812 17.601562 20.835938 C 17.800781 20.773438 17.996094 20.707031 18.191406 20.625 C 18.261719 20.691406 18.3125 20.773438 18.332031 20.871094 C 18.304688 21.019531 18.28125 21.171875 18.261719 21.320312 C 17.773438 21.082031 17.308594 20.804688 16.871094 20.488281 C 17.144531 20.429688 17.421875 20.394531 17.703125 20.382812 C 17.757812 20.335938 17.78125 20.277344 17.773438 20.207031 C 18.027344 19.953125 18.097656 19.652344 17.984375 19.304688 C 17.890625 19.234375 17.796875 19.164062 17.703125 19.09375 C 17.625 19.171875 17.636719 19.238281 17.738281 19.304688 C 17.773438 19.488281 17.785156 19.675781 17.773438 19.859375 L 17.703125 20 L 17.566406 20.070312 C 17.199219 20.007812 16.824219 19.996094 16.453125 20.035156 C 16.414062 20.0625 16.390625 20.097656 16.382812 20.140625 C 16.179688 20.21875 15.96875 20.253906 15.757812 20.242188 C 15.207031 19.742188 14.558594 19.535156 13.808594 19.617188 C 13.734375 19.527344 13.6875 19.417969 13.667969 19.304688 C 13.691406 19.148438 13.667969 19.007812 13.601562 18.886719 C 13.648438 18.691406 13.773438 18.574219 13.984375 18.539062 C 14.117188 18.632812 14.265625 18.691406 14.433594 18.714844 C 14.476562 18.765625 14.511719 18.824219 14.539062 18.886719 C 14.570312 18.375 14.617188 17.867188 14.679688 17.355469 C 14.800781 17.304688 14.929688 17.269531 15.0625 17.253906 C 15.234375 17.117188 15.246094 16.964844 15.09375 16.800781 L 15.027344 17.148438 C 14.921875 17.195312 14.796875 17.195312 14.644531 17.148438 C 14.597656 17.261719 14.5625 17.375 14.539062 17.496094 L 14.46875 17.425781 C 14.433594 17.539062 14.421875 17.65625 14.433594 17.773438 C 13.320312 17.832031 12.210938 17.84375 11.09375 17.808594 C 11.101562 17.613281 11.078125 17.417969 11.027344 17.21875 C 12 17.605469 12.996094 17.664062 14.015625 17.390625 C 14.121094 17.351562 14.214844 17.292969 14.296875 17.21875 L 14.191406 17.148438 C 13.996094 17.296875 13.777344 17.378906 13.53125 17.390625 C 12.785156 17.464844 12.035156 17.417969 11.304688 17.253906 C 10.652344 17.007812 10.234375 16.554688 10.050781 15.894531 C 9.996094 15.339844 9.972656 14.785156 9.984375 14.226562 C 10.078125 14.238281 10.171875 14.226562 10.261719 14.191406 C 10.347656 14.019531 10.488281 13.9375 10.679688 13.949219 Z M 10.679688 13.949219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(18.823529%,12.54902%,9.019608%)",
      fillOpacity: 1
    },
    d: "M 15.617188 16.589844 C 15.664062 16.589844 15.6875 16.613281 15.6875 16.660156 C 15.621094 16.898438 15.539062 17.128906 15.445312 17.355469 C 15.09375 17.753906 14.910156 18.214844 14.886719 18.746094 C 14.78125 18.453125 14.757812 18.152344 14.816406 17.84375 C 14.953125 17.601562 15.105469 17.371094 15.269531 17.148438 C 15.410156 16.980469 15.527344 16.792969 15.617188 16.589844 Z M 15.617188 16.589844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(89.019608%,69.411765%,56.470588%)",
      fillOpacity: 1
    },
    d: "M 17.078125 16.3125 L 17.21875 16.523438 C 17.28125 16.597656 17.304688 16.6875 17.285156 16.800781 C 17.238281 16.769531 17.203125 16.722656 17.183594 16.660156 L 17.148438 17.078125 L 17.425781 18.679688 C 17.136719 18.617188 16.882812 18.5 16.660156 18.332031 C 16.597656 18.082031 16.585938 17.820312 16.625 17.566406 C 16.707031 17.070312 16.855469 16.652344 17.078125 16.3125 Z M 17.078125 16.3125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(88.627451%,69.803922%,57.647059%)",
      fillOpacity: 1
    },
    d: "M 18.121094 16.382812 C 18.925781 16.625 19.738281 16.832031 20.554688 17.007812 C 19.730469 17.144531 18.941406 16.996094 18.191406 16.554688 C 18.140625 16.511719 18.117188 16.453125 18.121094 16.382812 Z M 18.121094 16.382812 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.745098%,73.333333%,67.058824%)",
      fillOpacity: 1
    },
    d: "M 18.886719 15.894531 C 18.941406 15.941406 18.988281 16 19.027344 16.070312 L 18.609375 16.140625 C 19.015625 16.207031 19.421875 16.289062 19.824219 16.382812 C 19.902344 16.378906 19.957031 16.359375 20 16.3125 C 20.261719 16.304688 20.398438 16.164062 20.417969 15.894531 C 20.464844 15.894531 20.488281 15.917969 20.488281 15.964844 C 20.492188 16.050781 20.539062 16.109375 20.625 16.140625 C 20.542969 16.207031 20.472656 16.289062 20.417969 16.382812 C 20.175781 16.4375 19.933594 16.484375 19.6875 16.523438 C 19.484375 16.359375 19.261719 16.335938 19.027344 16.453125 C 18.867188 16.371094 18.707031 16.300781 18.539062 16.242188 C 18.496094 16.183594 18.472656 16.109375 18.46875 16.035156 C 18.648438 16.066406 18.789062 16.019531 18.886719 15.894531 Z M 18.886719 15.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(84.705882%,67.45098%,55.686275%)",
      fillOpacity: 1
    },
    d: "M 15.476562 14.921875 L 15.546875 14.921875 C 15.539062 15.160156 15.65625 15.25 15.894531 15.199219 C 15.917969 15.515625 15.894531 15.816406 15.824219 16.105469 C 15.835938 16.03125 15.824219 15.960938 15.792969 15.894531 C 15.71875 16.125 15.664062 16.355469 15.617188 16.589844 C 15.527344 16.792969 15.410156 16.980469 15.269531 17.148438 C 15.328125 16.78125 15.339844 16.40625 15.304688 16.035156 C 15.277344 16.074219 15.242188 16.097656 15.199219 16.105469 C 15.300781 15.859375 15.371094 15.601562 15.410156 15.339844 C 15.476562 15.214844 15.5 15.078125 15.476562 14.921875 Z M 15.476562 14.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(85.490196%,68.235294%,56.862745%)",
      fillOpacity: 1
    },
    d: "M 20.488281 15.964844 C 20.652344 16.03125 20.804688 16.125 20.9375 16.242188 C 20.96875 16.226562 20.976562 16.203125 20.972656 16.175781 C 21.171875 16.296875 21.265625 16.457031 21.253906 16.660156 C 20.972656 16.507812 20.695312 16.414062 20.417969 16.382812 C 20.472656 16.289062 20.542969 16.207031 20.625 16.140625 C 20.539062 16.109375 20.492188 16.050781 20.488281 15.964844 Z M 20.488281 15.964844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(47.45098%,34.509804%,23.921569%)",
      fillOpacity: 1
    },
    d: "M 15.824219 16.105469 C 15.839844 16.3125 15.792969 16.5 15.6875 16.660156 C 15.6875 16.613281 15.664062 16.589844 15.617188 16.589844 C 15.664062 16.355469 15.71875 16.125 15.792969 15.894531 C 15.824219 15.960938 15.835938 16.03125 15.824219 16.105469 Z M 15.824219 16.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(71.764706%,62.352941%,55.686275%)",
      fillOpacity: 1
    },
    d: "M 17.007812 14.921875 C 17.058594 15.269531 17.105469 15.617188 17.148438 15.964844 L 17.21875 16.523438 L 17.078125 16.3125 C 17.011719 15.851562 16.988281 15.386719 17.007812 14.921875 Z M 17.007812 14.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(89.803922%,88.627451%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 20.417969 15.894531 C 20.398438 16.164062 20.261719 16.304688 20 16.3125 C 19.613281 16.289062 19.578125 16.195312 19.894531 16.035156 C 19.929688 15.945312 19.941406 15.851562 19.929688 15.757812 C 19.945312 15.714844 19.980469 15.691406 20.035156 15.6875 C 20.15625 15.765625 20.285156 15.835938 20.417969 15.894531 Z M 20.417969 15.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(22.745098%,15.686275%,10.980392%)",
      fillOpacity: 1
    },
    d: "M 18.816406 15.410156 C 18.867188 15.4375 18.902344 15.484375 18.921875 15.546875 C 19.125 15.457031 19.324219 15.457031 19.511719 15.546875 L 19.304688 15.546875 L 19.304688 15.757812 C 19.441406 15.78125 19.535156 15.734375 19.582031 15.617188 C 19.710938 15.640625 19.824219 15.6875 19.929688 15.757812 C 19.941406 15.851562 19.929688 15.945312 19.894531 16.035156 C 19.578125 16.195312 19.613281 16.289062 20 16.3125 C 19.957031 16.359375 19.902344 16.378906 19.824219 16.382812 C 19.421875 16.289062 19.015625 16.207031 18.609375 16.140625 L 19.027344 16.070312 C 18.988281 16 18.941406 15.941406 18.886719 15.894531 C 18.828125 15.871094 18.804688 15.824219 18.816406 15.757812 Z M 18.816406 15.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(20.784314%,13.72549%,9.019608%)",
      fillOpacity: 1
    },
    d: "M 17.285156 15.128906 C 17.265625 15.46875 17.289062 15.792969 17.355469 16.105469 C 17.363281 16.410156 17.410156 16.714844 17.496094 17.007812 C 17.359375 17.050781 17.289062 16.980469 17.285156 16.800781 C 17.304688 16.6875 17.28125 16.597656 17.21875 16.523438 L 17.148438 15.964844 Z M 17.285156 15.128906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.72549%,9.803922%,7.45098%)",
      fillOpacity: 1
    },
    d: "M 18.816406 15.199219 L 19.375 15.199219 C 19.523438 15.261719 19.6875 15.308594 19.859375 15.339844 L 20 15.339844 C 20.171875 15.484375 20.359375 15.613281 20.554688 15.722656 C 20.71875 15.859375 20.855469 16.007812 20.972656 16.175781 C 20.976562 16.203125 20.96875 16.226562 20.9375 16.242188 C 20.804688 16.125 20.652344 16.03125 20.488281 15.964844 C 20.488281 15.917969 20.464844 15.894531 20.417969 15.894531 C 20.285156 15.835938 20.15625 15.765625 20.035156 15.6875 C 19.980469 15.691406 19.945312 15.714844 19.929688 15.757812 C 19.824219 15.6875 19.707031 15.640625 19.582031 15.617188 C 19.582031 15.570312 19.558594 15.546875 19.511719 15.546875 C 19.324219 15.457031 19.125 15.457031 18.921875 15.546875 C 18.902344 15.484375 18.867188 15.4375 18.816406 15.410156 C 18.707031 15.390625 18.613281 15.414062 18.539062 15.476562 L 18.398438 15.476562 C 18.304688 15.488281 18.210938 15.476562 18.121094 15.445312 C 18.160156 15.417969 18.183594 15.382812 18.191406 15.339844 C 18.414062 15.347656 18.621094 15.300781 18.816406 15.199219 Z M 18.816406 15.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(80.392157%,76.078431%,72.54902%)",
      fillOpacity: 1
    },
    d: "M 19.511719 15.546875 C 19.558594 15.546875 19.582031 15.570312 19.582031 15.617188 C 19.535156 15.734375 19.441406 15.78125 19.304688 15.757812 L 19.304688 15.546875 Z M 19.511719 15.546875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(97.254902%,94.901961%,93.333333%)",
      fillOpacity: 1
    },
    d: "M 18.398438 15.476562 L 18.746094 15.476562 C 18.730469 15.589844 18.753906 15.683594 18.816406 15.757812 C 18.804688 15.824219 18.828125 15.871094 18.886719 15.894531 C 18.789062 16.019531 18.648438 16.066406 18.46875 16.035156 C 18.410156 15.878906 18.386719 15.71875 18.398438 15.546875 Z M 18.398438 15.476562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(63.529412%,56.078431%,50.980392%)",
      fillOpacity: 1
    },
    d: "M 13.601562 15.410156 L 13.878906 15.410156 C 13.746094 15.5 13.582031 15.546875 13.390625 15.546875 C 13.214844 15.546875 13.054688 15.523438 12.90625 15.476562 C 13.152344 15.5 13.382812 15.476562 13.601562 15.410156 Z M 13.601562 15.410156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(51.372549%,50.588235%,50.588235%)",
      fillOpacity: 1
    },
    d: "M 18.539062 15.476562 C 18.613281 15.414062 18.707031 15.390625 18.816406 15.410156 L 18.816406 15.757812 C 18.753906 15.683594 18.730469 15.589844 18.746094 15.476562 Z M 18.539062 15.476562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(36.470588%,30.588235%,27.058824%)",
      fillOpacity: 1
    },
    d: "M 19.375 15.199219 C 19.515625 15.1875 19.65625 15.199219 19.792969 15.234375 C 19.828125 15.261719 19.851562 15.296875 19.859375 15.339844 C 19.6875 15.308594 19.523438 15.261719 19.375 15.199219 Z M 19.375 15.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(92.156863%,89.803922%,87.843137%)",
      fillOpacity: 1
    },
    d: "M 14.085938 15.0625 C 14.128906 15.253906 14.058594 15.371094 13.878906 15.410156 L 13.601562 15.410156 C 13.699219 15.265625 13.746094 15.101562 13.738281 14.921875 C 13.882812 14.914062 13.996094 14.960938 14.085938 15.0625 Z M 14.085938 15.0625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(86.27451%,67.843137%,55.686275%)",
      fillOpacity: 1
    },
    d: "M 11.929688 14.78125 C 11.917969 14.898438 11.929688 15.019531 11.964844 15.128906 C 11.996094 15.21875 12.050781 15.265625 12.140625 15.269531 L 12.277344 15.269531 L 12.207031 15.410156 C 11.96875 15.34375 11.726562 15.296875 11.476562 15.269531 C 10.804688 15.441406 10.722656 15.304688 11.234375 14.851562 C 11.25 14.894531 11.285156 14.917969 11.339844 14.921875 C 11.53125 14.859375 11.730469 14.8125 11.929688 14.78125 Z M 11.929688 14.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(43.921569%,31.372549%,20.784314%)",
      fillOpacity: 1
    },
    d: "M 12 14.644531 L 11.929688 14.78125 C 11.730469 14.8125 11.53125 14.859375 11.339844 14.921875 C 11.285156 14.917969 11.25 14.894531 11.234375 14.851562 C 11.3125 14.777344 11.40625 14.730469 11.511719 14.714844 C 11.515625 14.75 11.539062 14.773438 11.582031 14.78125 C 11.714844 14.722656 11.855469 14.675781 12 14.644531 Z M 12 14.644531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(83.137255%,79.215686%,76.862745%)",
      fillOpacity: 1
    },
    d: "M 12 14.644531 L 12.417969 14.644531 C 12.429688 14.851562 12.453125 15.0625 12.488281 15.269531 L 12.277344 15.269531 C 12.324219 15.222656 12.367188 15.175781 12.417969 15.128906 C 12.359375 15 12.335938 14.855469 12.347656 14.714844 C 12.234375 14.699219 12.128906 14.722656 12.035156 14.78125 C 12.027344 14.949219 12.058594 15.113281 12.140625 15.269531 C 12.050781 15.265625 11.996094 15.21875 11.964844 15.128906 C 11.929688 15.019531 11.917969 14.898438 11.929688 14.78125 Z M 12 14.644531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.039216%,98.431373%,98.431373%)",
      fillOpacity: 1
    },
    d: "M 12.277344 15.269531 L 12.140625 15.269531 C 12.058594 15.113281 12.027344 14.949219 12.035156 14.78125 C 12.128906 14.722656 12.234375 14.699219 12.347656 14.714844 C 12.335938 14.855469 12.359375 15 12.417969 15.128906 C 12.367188 15.175781 12.324219 15.222656 12.277344 15.269531 Z M 12.277344 15.269531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(16.078431%,11.372549%,9.019608%)",
      fillOpacity: 1
    },
    d: "M 13.949219 14.78125 C 14.003906 14.84375 14.074219 14.890625 14.15625 14.921875 C 14.261719 15.019531 14.238281 15.066406 14.085938 15.0625 C 13.996094 14.960938 13.882812 14.914062 13.738281 14.921875 C 13.746094 15.101562 13.699219 15.265625 13.601562 15.410156 C 13.382812 15.476562 13.152344 15.5 12.90625 15.476562 C 12.675781 15.421875 12.441406 15.398438 12.207031 15.410156 L 12.277344 15.269531 L 12.488281 15.269531 C 12.453125 15.0625 12.429688 14.851562 12.417969 14.644531 L 12 14.644531 C 11.855469 14.675781 11.714844 14.722656 11.582031 14.78125 C 11.539062 14.773438 11.515625 14.75 11.511719 14.714844 C 11.621094 14.621094 11.738281 14.539062 11.859375 14.46875 C 12.613281 14.261719 13.308594 14.367188 13.949219 14.78125 Z M 13.949219 14.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(27.058824%,16.862745%,7.843137%)",
      fillOpacity: 1
    },
    d: "M 12.972656 14.78125 C 12.996094 14.863281 13.050781 14.910156 13.148438 14.921875 C 13.242188 14.910156 13.300781 14.863281 13.320312 14.78125 C 13.441406 14.808594 13.554688 14.84375 13.667969 14.886719 C 13.5 15.289062 13.195312 15.417969 12.765625 15.269531 C 12.660156 15.152344 12.585938 15.007812 12.554688 14.851562 C 12.648438 14.578125 12.753906 14.578125 12.871094 14.851562 C 12.894531 14.8125 12.929688 14.789062 12.972656 14.78125 Z M 12.972656 14.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(81.568627%,78.823529%,77.254902%)",
      fillOpacity: 1
    },
    d: "M 13.320312 14.78125 C 13.300781 14.863281 13.242188 14.910156 13.148438 14.921875 C 13.050781 14.910156 12.996094 14.863281 12.972656 14.78125 C 13.089844 14.691406 13.207031 14.691406 13.320312 14.78125 Z M 13.320312 14.78125 "
  }), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface101",
    mask: "url(#mask32)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(49.803922%,45.098039%,41.960784%)",
      fillOpacity: 1
    },
    d: "M 24.035156 17.566406 C 24.023438 17.636719 24.035156 17.710938 24.070312 17.773438 C 24.117188 17.722656 24.175781 17.699219 24.242188 17.703125 L 24.242188 17.84375 C 24.140625 17.929688 24.023438 18 23.894531 18.050781 C 23.890625 17.867188 23.9375 17.707031 24.035156 17.566406 Z M 24.035156 17.566406 "
  }), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface104",
    mask: "url(#mask33)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(62.745098%,50.588235%,41.960784%)",
      fillOpacity: 1
    },
    d: "M 19.722656 18.191406 L 19.722656 18.261719 C 19.25 18.238281 18.78125 18.15625 18.332031 18.015625 C 18.046875 17.832031 17.792969 17.609375 17.566406 17.355469 C 17.601562 17.285156 17.644531 17.273438 17.703125 17.320312 C 17.890625 17.53125 18.101562 17.71875 18.332031 17.878906 C 18.78125 18.050781 19.246094 18.152344 19.722656 18.191406 Z M 19.722656 18.191406 "
  }), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface107",
    mask: "url(#mask34)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.980392%,79.215686%,71.372549%)",
      fillOpacity: 1
    },
    d: "M 24.242188 17.84375 C 24.628906 17.824219 24.929688 17.960938 25.148438 18.261719 L 25.148438 18.398438 C 25.175781 18.671875 25.128906 18.925781 25.007812 19.164062 C 24.769531 19.238281 24.652344 19.378906 24.660156 19.582031 C 24.519531 19.679688 24.449219 19.820312 24.453125 20 C 24.40625 20 24.382812 19.976562 24.382812 19.929688 C 24.398438 19.703125 24.339844 19.492188 24.207031 19.304688 C 24.175781 19.765625 24.164062 20.230469 24.175781 20.695312 C 24.101562 20.894531 23.960938 21.035156 23.757812 21.113281 C 23.679688 21.054688 23.679688 20.984375 23.757812 20.90625 C 23.867188 20.875 23.949219 20.804688 24 20.695312 C 24.046875 20.324219 24.046875 19.953125 24 19.582031 C 23.980469 19.476562 23.933594 19.382812 23.859375 19.304688 C 23.75 19.398438 23.625 19.445312 23.476562 19.445312 C 23.472656 19.601562 23.425781 19.742188 23.339844 19.859375 C 23.460938 19.234375 23.644531 18.632812 23.894531 18.050781 C 24.023438 18 24.140625 17.929688 24.242188 17.84375 Z M 24.242188 17.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(38.039216%,27.058824%,18.039216%)",
      fillOpacity: 1
    },
    d: "M 8.453125 15.269531 C 8.476562 15.929688 8.453125 16.582031 8.382812 17.21875 C 8.394531 17.007812 8.382812 16.796875 8.347656 16.589844 C 8.203125 18.007812 8.238281 19.398438 8.453125 20.765625 C 8.464844 20.929688 8.453125 21.09375 8.417969 21.253906 C 8.347656 21.308594 8.265625 21.332031 8.175781 21.320312 C 8.164062 21.183594 8.210938 21.066406 8.3125 20.972656 C 8.21875 20.90625 8.21875 20.835938 8.3125 20.765625 C 8.257812 20.679688 8.203125 20.679688 8.140625 20.765625 C 8.101562 20.621094 8.136719 20.492188 8.242188 20.382812 C 8.207031 20.316406 8.160156 20.257812 8.105469 20.207031 L 8.175781 19.652344 L 8.035156 19.511719 C 8.09375 19.441406 8.144531 19.359375 8.175781 19.269531 C 8.089844 19.164062 8.089844 19.058594 8.175781 18.957031 C 8.117188 18.894531 8.046875 18.871094 7.964844 18.886719 C 7.957031 18.75 8.003906 18.632812 8.105469 18.539062 C 7.953125 18.414062 7.953125 18.277344 8.105469 18.121094 C 8.046875 18.058594 7.976562 18.035156 7.894531 18.050781 C 7.976562 17.828125 8.070312 17.605469 8.175781 17.390625 C 8.097656 17.332031 8.050781 17.25 8.035156 17.148438 C 8.097656 16.972656 8.097656 16.808594 8.035156 16.660156 C 8.152344 16.574219 8.230469 16.457031 8.277344 16.3125 C 8.289062 15.949219 8.347656 15.601562 8.453125 15.269531 Z M 8.453125 15.269531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(89.019608%,67.843137%,54.117647%)",
      fillOpacity: 1
    },
    d: "M 23.0625 15.894531 C 23.207031 15.972656 23.296875 16.085938 23.339844 16.242188 L 23.339844 16.382812 C 23.148438 16.835938 22.988281 17.300781 22.851562 17.773438 C 22.695312 18.675781 22.554688 19.578125 22.433594 20.488281 C 22.28125 21.160156 22.117188 21.835938 21.949219 22.503906 C 21.9375 22.667969 21.914062 22.832031 21.878906 22.992188 C 21.828125 23.324219 21.738281 23.648438 21.601562 23.964844 C 21.382812 24.082031 21.269531 24.269531 21.253906 24.523438 C 21.074219 24.71875 20.914062 24.929688 20.765625 25.148438 C 21.050781 24.386719 21.269531 23.597656 21.425781 22.78125 C 21.488281 22.726562 21.535156 22.652344 21.566406 22.574219 C 21.589844 22.292969 21.636719 22.011719 21.703125 21.738281 C 21.738281 20.601562 21.75 19.46875 21.738281 18.332031 C 21.796875 18.238281 21.867188 18.15625 21.949219 18.085938 C 21.964844 18.007812 21.964844 17.929688 21.949219 17.84375 C 22.492188 17.261719 22.773438 16.566406 22.78125 15.757812 C 22.902344 15.757812 22.992188 15.804688 23.0625 15.894531 Z M 23.0625 15.894531 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(77.647059%,61.568627%,50.588235%)",
      fillOpacity: 1
    },
    d: "M 7.476562 17.496094 C 7.527344 17.558594 7.597656 17.582031 7.6875 17.566406 L 7.6875 17.703125 L 7.546875 17.703125 C 7.28125 17.886719 7.09375 18.144531 6.992188 18.46875 C 7.242188 18.734375 7.488281 19.011719 7.722656 19.304688 C 7.78125 19.859375 7.8125 20.417969 7.824219 20.972656 C 7.707031 21.011719 7.613281 21.078125 7.546875 21.183594 C 7.328125 21.273438 7.105469 21.273438 6.886719 21.183594 C 6.734375 20.875 6.769531 20.597656 6.992188 20.347656 C 6.839844 21.011719 7.0625 21.152344 7.652344 20.765625 C 7.6875 20.371094 7.699219 19.976562 7.6875 19.582031 C 7.503906 19.503906 7.375 19.363281 7.304688 19.164062 L 7.234375 19.234375 C 7.160156 19.082031 7.066406 18.941406 6.957031 18.816406 C 6.910156 18.519531 6.910156 18.210938 6.957031 17.914062 L 7.027344 17.984375 C 7.058594 17.894531 7.070312 17.796875 7.0625 17.703125 C 7.214844 17.667969 7.355469 17.597656 7.476562 17.496094 Z M 7.476562 17.496094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(35.294118%,25.882353%,19.215686%)",
      fillOpacity: 1
    },
    d: "M 24.453125 18.539062 L 24.800781 18.539062 C 24.800781 18.664062 24.765625 18.78125 24.695312 18.886719 C 24.664062 18.824219 24.648438 18.75 24.660156 18.679688 C 24.589844 18.667969 24.515625 18.679688 24.453125 18.714844 C 24.277344 18.910156 24.078125 19.085938 23.859375 19.234375 C 23.839844 19.136719 23.863281 19.042969 23.929688 18.957031 C 24.074219 18.777344 24.25 18.636719 24.453125 18.539062 Z M 24.453125 18.539062 "
  }), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface110",
    mask: "url(#mask35)"
  })), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface113",
    mask: "url(#mask36)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(13.333333%,7.843137%,4.313725%)",
      fillOpacity: 1
    },
    d: "M 7.894531 15.964844 C 8.011719 16.199219 8.058594 16.429688 8.035156 16.660156 C 8.097656 16.808594 8.097656 16.972656 8.035156 17.148438 C 8.050781 17.25 8.097656 17.332031 8.175781 17.390625 C 8.070312 17.605469 7.976562 17.828125 7.894531 18.050781 C 7.976562 18.035156 8.046875 18.058594 8.105469 18.121094 C 7.953125 18.277344 7.953125 18.414062 8.105469 18.539062 C 8.003906 18.632812 7.957031 18.75 7.964844 18.886719 C 8.046875 18.871094 8.117188 18.894531 8.175781 18.957031 C 8.089844 19.058594 8.089844 19.164062 8.175781 19.269531 C 8.144531 19.359375 8.09375 19.441406 8.035156 19.511719 L 8.175781 19.652344 L 8.105469 20.207031 C 8.160156 20.257812 8.207031 20.316406 8.242188 20.382812 C 8.136719 20.492188 8.101562 20.621094 8.140625 20.765625 C 8.203125 20.679688 8.257812 20.679688 8.3125 20.765625 C 8.21875 20.835938 8.21875 20.90625 8.3125 20.972656 C 8.210938 21.066406 8.164062 21.183594 8.175781 21.320312 C 8.265625 21.332031 8.347656 21.308594 8.417969 21.253906 C 8.453125 21.089844 8.464844 20.929688 8.453125 20.765625 C 8.503906 20.886719 8.550781 21.046875 8.589844 21.253906 L 8.589844 21.601562 C 8.402344 21.59375 8.214844 21.617188 8.035156 21.667969 C 7.964844 21.644531 7.917969 21.601562 7.894531 21.53125 C 7.902344 21.34375 7.878906 21.15625 7.824219 20.972656 C 7.8125 20.417969 7.78125 19.859375 7.722656 19.304688 C 7.488281 19.011719 7.242188 18.734375 6.992188 18.46875 C 7.09375 18.144531 7.28125 17.886719 7.546875 17.703125 C 7.242188 18.195312 7.277344 18.65625 7.652344 19.09375 C 7.6875 18.632812 7.699219 18.167969 7.6875 17.703125 L 7.6875 17.566406 C 7.753906 17.269531 7.777344 16.964844 7.757812 16.660156 C 7.796875 16.386719 7.84375 16.15625 7.894531 15.964844 Z M 7.894531 15.964844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(84.313725%,72.941176%,65.490196%)",
      fillOpacity: 1
    },
    d: "M 7.546875 17.703125 L 7.6875 17.703125 C 7.699219 18.167969 7.6875 18.632812 7.652344 19.09375 C 7.277344 18.65625 7.242188 18.195312 7.546875 17.703125 Z M 7.546875 17.703125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(44.313725%,36.862745%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 24.382812 19.929688 C 24.328125 19.851562 24.292969 19.761719 24.277344 19.652344 C 24.265625 20.011719 24.230469 20.359375 24.175781 20.695312 C 24.164062 20.230469 24.175781 19.765625 24.207031 19.304688 C 24.339844 19.492188 24.398438 19.703125 24.382812 19.929688 Z M 24.382812 19.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(93.72549%,76.862745%,65.098039%)",
      fillOpacity: 1
    },
    d: "M 23.757812 20.90625 C 23.769531 20.554688 23.757812 20.207031 23.722656 19.859375 C 23.613281 19.769531 23.53125 19.792969 23.476562 19.929688 C 23.410156 19.941406 23.363281 19.917969 23.339844 19.859375 C 23.425781 19.742188 23.472656 19.601562 23.476562 19.445312 C 23.625 19.445312 23.75 19.398438 23.859375 19.304688 C 23.933594 19.382812 23.980469 19.476562 24 19.582031 C 24.046875 19.953125 24.046875 20.324219 24 20.695312 C 23.949219 20.804688 23.867188 20.875 23.757812 20.90625 Z M 23.757812 20.90625 "
  }), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface116",
    mask: "url(#mask37)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(91.372549%,72.54902%,59.607843%)",
      fillOpacity: 1
    },
    d: "M 7.476562 17.496094 C 7.355469 17.597656 7.214844 17.667969 7.0625 17.703125 C 7.070312 17.796875 7.058594 17.894531 7.027344 17.984375 L 6.957031 17.914062 C 6.910156 18.210938 6.910156 18.519531 6.957031 18.816406 C 7.066406 18.941406 7.160156 19.082031 7.234375 19.234375 L 7.304688 19.164062 C 7.375 19.363281 7.503906 19.503906 7.6875 19.582031 C 7.554688 19.78125 7.472656 20.011719 7.445312 20.277344 C 7.429688 20.042969 7.324219 19.972656 7.128906 20.070312 C 7.128906 20.023438 7.105469 20 7.0625 20 C 6.972656 19.847656 6.996094 19.695312 7.128906 19.546875 C 7.066406 19.472656 7.019531 19.390625 6.992188 19.304688 C 7.023438 19.308594 7.046875 19.296875 7.0625 19.269531 C 6.617188 18.460938 6.722656 17.730469 7.375 17.078125 L 7.476562 17.183594 C 7.445312 17.273438 7.445312 17.378906 7.476562 17.496094 Z M 7.476562 17.496094 "
  }), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface119",
    mask: "url(#mask38)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(89.019608%,68.235294%,54.117647%)",
      fillOpacity: 1
    },
    d: "M 9.914062 14.226562 L 9.984375 14.226562 C 9.972656 14.785156 9.996094 15.339844 10.050781 15.894531 C 9.988281 15.96875 9.964844 16.0625 9.984375 16.175781 C 9.898438 16.714844 9.769531 17.25 9.601562 17.773438 C 9.472656 18.601562 9.585938 19.390625 9.949219 20.140625 C 10.035156 20.574219 10.058594 21.019531 10.015625 21.460938 C 9.761719 21.921875 9.660156 22.421875 9.703125 22.957031 C 9.703125 23.554688 9.773438 24.148438 9.914062 24.730469 C 9.789062 24.554688 9.6875 24.371094 9.601562 24.175781 L 9.53125 24.453125 L 9.460938 23.894531 C 9.414062 23.988281 9.367188 23.988281 9.320312 23.894531 L 9.21875 23.476562 C 9.199219 23.394531 9.152344 23.347656 9.078125 23.339844 C 9.089844 23.027344 9.007812 22.75 8.835938 22.503906 C 8.820312 22.289062 8.773438 22.078125 8.695312 21.878906 C 8.660156 21.671875 8.648438 21.460938 8.660156 21.253906 C 8.699219 20.011719 8.71875 18.769531 8.730469 17.53125 C 8.730469 16.632812 8.683594 15.753906 8.589844 14.886719 C 8.753906 14.847656 8.824219 14.742188 8.800781 14.574219 C 8.960938 14.441406 9.148438 14.347656 9.355469 14.296875 C 9.550781 14.25 9.738281 14.226562 9.914062 14.226562 Z M 9.914062 14.226562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(96.078431%,79.215686%,67.843137%)",
      fillOpacity: 1
    },
    d: "M 7.6875 19.582031 C 7.699219 19.976562 7.6875 20.371094 7.652344 20.765625 C 7.0625 21.152344 6.839844 21.011719 6.992188 20.347656 C 7.066406 20.269531 7.113281 20.179688 7.128906 20.070312 C 7.324219 19.972656 7.429688 20.042969 7.445312 20.277344 C 7.472656 20.011719 7.554688 19.78125 7.6875 19.582031 Z M 7.6875 19.582031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(64.705882%,49.803922%,39.607843%)",
      fillOpacity: 1
    },
    d: "M 23.757812 20.90625 C 23.683594 20.90625 23.609375 20.929688 23.546875 20.972656 C 23.550781 20.648438 23.527344 20.320312 23.476562 20 L 23.476562 19.929688 C 23.53125 19.792969 23.613281 19.769531 23.722656 19.859375 C 23.757812 20.207031 23.769531 20.554688 23.757812 20.90625 Z M 23.757812 20.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(17.647059%,8.627451%,3.137255%)",
      fillOpacity: 1
    },
    d: "M 8.382812 17.21875 C 8.371094 18.027344 8.382812 18.839844 8.417969 19.652344 C 8.527344 20.179688 8.585938 20.714844 8.589844 21.253906 C 8.550781 21.046875 8.503906 20.886719 8.453125 20.765625 C 8.238281 19.398438 8.203125 18.007812 8.347656 16.589844 C 8.382812 16.796875 8.394531 17.007812 8.382812 17.21875 Z M 8.382812 17.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(15.686275%,10.980392%,8.627451%)",
      fillOpacity: 1
    },
    d: "M 23.476562 20 C 23.527344 20.320312 23.550781 20.648438 23.546875 20.972656 C 23.5 20.972656 23.476562 20.996094 23.476562 21.042969 C 23.410156 21.089844 23.339844 21.132812 23.269531 21.183594 C 23.226562 21.175781 23.203125 21.152344 23.199219 21.113281 C 23.289062 20.742188 23.378906 20.371094 23.476562 20 Z M 23.476562 20 "
  }), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface122",
    mask: "url(#mask39)"
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface125",
    mask: "url(#mask40)"
  })), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface128",
    mask: "url(#mask41)"
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface131",
    mask: "url(#mask42)"
  })), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface134",
    mask: "url(#mask43)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(64.313725%,49.803922%,40%)",
      fillOpacity: 1
    },
    d: "M 23.339844 16.242188 C 23.519531 16.308594 23.660156 16.425781 23.757812 16.589844 C 23.726562 16.898438 23.65625 17.203125 23.546875 17.496094 C 23.171875 19.152344 22.6875 20.777344 22.085938 22.363281 L 21.949219 22.503906 C 22.117188 21.835938 22.28125 21.160156 22.433594 20.488281 C 22.542969 20.328125 22.636719 20.15625 22.714844 19.964844 C 22.679688 19.863281 22.65625 19.757812 22.644531 19.652344 C 22.808594 19.214844 22.925781 18.785156 22.992188 18.363281 C 22.824219 18.332031 22.8125 18.277344 22.957031 18.191406 C 23.054688 18.28125 23.125 18.257812 23.164062 18.121094 L 23.234375 18.191406 C 23.40625 17.949219 23.347656 17.808594 23.0625 17.773438 C 23.0625 17.480469 23.121094 17.179688 23.234375 16.871094 C 23.253906 16.996094 23.3125 17.101562 23.410156 17.183594 L 23.339844 17.253906 C 23.441406 17.289062 23.523438 17.253906 23.582031 17.148438 C 23.644531 16.96875 23.613281 16.820312 23.476562 16.695312 C 23.566406 16.539062 23.523438 16.433594 23.339844 16.382812 Z M 23.339844 16.242188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(63.921569%,52.54902%,44.313725%)",
      fillOpacity: 1
    },
    d: "M 23.476562 21.042969 C 23.421875 21.195312 23.316406 21.3125 23.164062 21.390625 C 23.132812 21.457031 23.121094 21.527344 23.128906 21.601562 L 22.851562 21.667969 C 22.847656 21.484375 22.890625 21.324219 22.992188 21.183594 C 22.980469 21.230469 22.996094 21.28125 23.027344 21.320312 C 23.082031 21.25 23.140625 21.179688 23.199219 21.113281 C 23.203125 21.152344 23.226562 21.175781 23.269531 21.183594 C 23.339844 21.136719 23.410156 21.089844 23.476562 21.042969 Z M 23.476562 21.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(81.176471%,67.843137%,58.823529%)",
      fillOpacity: 1
    },
    d: "M 23.757812 20.90625 C 23.679688 20.984375 23.679688 21.054688 23.757812 21.113281 C 23.71875 21.203125 23.648438 21.261719 23.546875 21.285156 C 23.601562 21.308594 23.652344 21.34375 23.6875 21.390625 C 23.59375 21.53125 23.503906 21.671875 23.410156 21.808594 C 23.316406 21.738281 23.222656 21.667969 23.128906 21.601562 C 23.121094 21.527344 23.132812 21.457031 23.164062 21.390625 C 23.316406 21.3125 23.421875 21.195312 23.476562 21.042969 C 23.476562 20.996094 23.5 20.972656 23.546875 20.972656 C 23.609375 20.929688 23.683594 20.90625 23.757812 20.90625 Z M 23.757812 20.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(95.294118%,81.568627%,71.764706%)",
      fillOpacity: 1
    },
    d: "M 9.984375 16.175781 C 10.144531 16.703125 10.492188 17.054688 11.027344 17.21875 C 11.078125 17.417969 11.101562 17.613281 11.09375 17.808594 C 12.210938 17.84375 13.320312 17.832031 14.433594 17.773438 C 14.421875 17.65625 14.433594 17.539062 14.46875 17.425781 L 14.539062 17.496094 C 14.5625 17.375 14.597656 17.261719 14.644531 17.148438 C 14.796875 17.195312 14.921875 17.195312 15.027344 17.148438 L 15.09375 16.800781 C 15.246094 16.964844 15.234375 17.117188 15.0625 17.253906 C 14.929688 17.269531 14.800781 17.304688 14.679688 17.355469 C 14.617188 17.867188 14.570312 18.375 14.539062 18.886719 C 14.511719 18.824219 14.476562 18.765625 14.433594 18.714844 C 14.265625 18.691406 14.117188 18.632812 13.984375 18.539062 C 13.773438 18.574219 13.648438 18.691406 13.601562 18.886719 C 13.339844 19.15625 13.257812 19.480469 13.355469 19.859375 C 13.445312 19.933594 13.554688 19.984375 13.667969 20 C 13.839844 20.097656 14.027344 20.179688 14.226562 20.242188 C 13.894531 20.320312 13.59375 20.445312 13.320312 20.625 L 13.320312 21.667969 C 13.832031 21.550781 14.339844 21.4375 14.851562 21.320312 C 15.503906 21.511719 16.175781 21.652344 16.871094 21.738281 C 17.640625 22.027344 18.40625 22.328125 19.164062 22.644531 C 19.261719 22.734375 19.351562 22.828125 19.445312 22.921875 C 19.496094 23.003906 19.519531 23.097656 19.511719 23.199219 L 19.722656 23.199219 C 19.765625 22.992188 19.8125 22.78125 19.859375 22.574219 L 19.792969 22.296875 C 19.714844 22.148438 19.597656 22.054688 19.445312 22.015625 C 19.085938 21.726562 18.6875 21.492188 18.261719 21.320312 C 18.277344 21.175781 18.300781 21.027344 18.332031 20.871094 C 18.3125 20.773438 18.261719 20.691406 18.191406 20.625 C 17.996094 20.707031 17.800781 20.773438 17.601562 20.835938 C 17.503906 20.757812 17.421875 20.664062 17.355469 20.554688 L 17.601562 20.488281 C 17.753906 20.527344 17.902344 20.574219 18.050781 20.625 C 18.011719 20.179688 18.128906 19.789062 18.398438 19.445312 C 18.375 19.359375 18.339844 19.359375 18.296875 19.445312 C 18.277344 19.335938 18.242188 19.230469 18.191406 19.128906 L 18.261719 19.0625 C 18.082031 19.019531 17.914062 18.933594 17.773438 18.816406 C 17.6875 18.710938 17.6875 18.605469 17.773438 18.503906 C 18.121094 18.457031 18.46875 18.457031 18.816406 18.503906 L 18.992188 18.679688 L 19.339844 18.609375 C 19.410156 18.6875 19.457031 18.78125 19.476562 18.886719 C 19.554688 18.777344 19.648438 18.683594 19.757812 18.609375 L 19.964844 18.886719 C 20 18.824219 20.011719 18.75 20 18.679688 C 20.289062 18.714844 20.558594 18.667969 20.800781 18.539062 L 20.871094 18.679688 C 20.914062 18.492188 20.960938 18.492188 21.007812 18.679688 C 21.15625 18.625 21.304688 18.589844 21.460938 18.574219 C 21.546875 18.476562 21.640625 18.394531 21.738281 18.332031 C 21.75 19.46875 21.738281 20.601562 21.703125 21.738281 C 21.636719 22.011719 21.589844 22.292969 21.566406 22.574219 C 21.535156 22.652344 21.488281 22.726562 21.425781 22.78125 C 21.269531 23.597656 21.050781 24.386719 20.765625 25.148438 C 20.605469 25.398438 20.417969 25.632812 20.207031 25.84375 C 19.960938 26.046875 19.71875 26.257812 19.476562 26.46875 C 19.464844 26.632812 19.382812 26.75 19.234375 26.816406 C 19.175781 26.449219 19.082031 26.472656 18.957031 26.886719 C 18.863281 27.039062 18.746094 27.179688 18.609375 27.304688 C 18.539062 27.328125 18.492188 27.375 18.46875 27.445312 C 18.070312 27.597656 17.675781 27.757812 17.285156 27.929688 C 16.867188 27.960938 16.449219 28.007812 16.035156 28.070312 L 16.035156 28.347656 L 15.964844 28.347656 L 15.964844 28.140625 C 14.566406 28.183594 13.246094 27.929688 12 27.375 C 11.757812 27.152344 11.5 26.941406 11.234375 26.746094 C 11.179688 26.683594 11.109375 26.640625 11.027344 26.609375 C 11.023438 26.535156 11 26.460938 10.957031 26.398438 C 10.878906 26.324219 10.832031 26.230469 10.816406 26.121094 C 10.789062 26.003906 10.753906 25.886719 10.714844 25.773438 L 10.503906 25.84375 C 10.429688 25.589844 10.28125 25.378906 10.050781 25.21875 C 10 25.058594 9.953125 24.894531 9.914062 24.730469 C 9.773438 24.148438 9.703125 23.554688 9.703125 22.957031 C 9.660156 22.421875 9.761719 21.921875 10.015625 21.460938 C 10.058594 21.019531 10.035156 20.574219 9.949219 20.140625 C 9.585938 19.390625 9.472656 18.601562 9.601562 17.773438 C 9.769531 17.25 9.898438 16.714844 9.984375 16.175781 Z M 9.984375 16.175781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(65.882353%,55.686275%,48.627451%)",
      fillOpacity: 1
    },
    d: "M 13.042969 21.808594 C 12.433594 21.894531 11.832031 22.011719 11.234375 22.15625 L 11.234375 21.808594 C 11.222656 21.714844 11.246094 21.636719 11.304688 21.566406 C 11.933594 21.304688 12.558594 21.035156 13.183594 20.765625 C 13.261719 21.035156 13.273438 21.324219 13.21875 21.601562 L 13.148438 21.53125 C 13.09375 21.613281 13.058594 21.710938 13.042969 21.808594 Z M 13.042969 21.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(76.470588%,65.098039%,57.254902%)",
      fillOpacity: 1
    },
    d: "M 13.667969 20 C 14.148438 19.964844 14.613281 20.011719 15.0625 20.140625 C 15.28125 20.261719 15.492188 20.398438 15.6875 20.554688 C 15.761719 20.621094 15.855469 20.644531 15.964844 20.625 C 15.992188 20.792969 15.921875 20.898438 15.757812 20.9375 C 15.863281 21.039062 15.921875 21.167969 15.929688 21.320312 L 16 21.253906 C 16.269531 21.371094 16.535156 21.488281 16.800781 21.601562 C 16.789062 21.4375 16.800781 21.273438 16.835938 21.113281 C 16.871094 21.320312 16.882812 21.527344 16.871094 21.738281 C 16.175781 21.652344 15.503906 21.511719 14.851562 21.320312 L 14.851562 20.277344 C 14.347656 20.421875 13.839844 20.539062 13.320312 20.625 C 13.59375 20.445312 13.894531 20.320312 14.226562 20.242188 C 14.027344 20.179688 13.839844 20.097656 13.667969 20 Z M 13.667969 20 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(62.745098%,52.941176%,45.882353%)",
      fillOpacity: 1
    },
    d: "M 15.0625 20.554688 C 15.140625 20.703125 15.269531 20.796875 15.445312 20.835938 L 15.511719 21.253906 C 15.738281 20.980469 15.84375 21.003906 15.824219 21.320312 L 15.0625 21.320312 Z M 15.0625 20.554688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(64.705882%,54.901961%,47.843137%)",
      fillOpacity: 1
    },
    d: "M 14.851562 21.320312 C 14.339844 21.4375 13.832031 21.550781 13.320312 21.667969 L 13.320312 20.625 C 13.835938 20.539062 14.34375 20.425781 14.851562 20.277344 Z M 14.851562 21.320312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(73.333333%,56.078431%,45.098039%)",
      fillOpacity: 1
    },
    d: "M 12 20 C 12.167969 19.988281 12.214844 20.046875 12.140625 20.175781 C 11.632812 20.464844 11.15625 20.804688 10.714844 21.183594 C 10.652344 21.417969 10.582031 21.648438 10.503906 21.878906 C 10.359375 21.570312 10.382812 21.269531 10.574219 20.972656 C 11.039062 20.632812 11.515625 20.308594 12 20 Z M 12 20 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(30.588235%,19.607843%,12.941176%)",
      fillOpacity: 1
    },
    d: "M 17.984375 19.304688 C 18.097656 19.652344 18.027344 19.953125 17.773438 20.207031 C 17.769531 20.140625 17.792969 20.082031 17.84375 20.035156 C 17.804688 20.003906 17.753906 19.992188 17.703125 20 L 17.773438 19.859375 C 17.917969 19.722656 17.941406 19.558594 17.84375 19.375 C 17.875 19.320312 17.921875 19.296875 17.984375 19.304688 Z M 17.984375 19.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(16.470588%,10.980392%,8.235294%)",
      fillOpacity: 1
    },
    d: "M 13.667969 19.304688 C 13.6875 19.417969 13.734375 19.527344 13.808594 19.617188 C 14.558594 19.535156 15.207031 19.742188 15.757812 20.242188 C 15.96875 20.253906 16.179688 20.21875 16.382812 20.140625 C 16.785156 20.09375 17.179688 20.070312 17.566406 20.070312 L 17.703125 20 C 17.753906 19.992188 17.804688 20.003906 17.84375 20.035156 C 17.792969 20.082031 17.769531 20.140625 17.773438 20.207031 C 17.359375 20.261719 16.941406 20.296875 16.523438 20.3125 C 16.269531 20.46875 15.988281 20.550781 15.6875 20.554688 C 15.492188 20.398438 15.28125 20.261719 15.0625 20.140625 C 15.023438 20.050781 14.953125 19.992188 14.851562 19.964844 C 14.480469 19.953125 14.109375 19.917969 13.738281 19.859375 C 13.546875 19.613281 13.488281 19.335938 13.566406 19.027344 C 13.578125 19.132812 13.613281 19.226562 13.667969 19.304688 Z M 13.667969 19.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(41.176471%,33.72549%,29.019608%)",
      fillOpacity: 1
    },
    d: "M 17.566406 20.070312 C 17.179688 20.070312 16.785156 20.09375 16.382812 20.140625 C 16.390625 20.097656 16.414062 20.0625 16.453125 20.035156 C 16.824219 19.996094 17.199219 20.007812 17.566406 20.070312 Z M 17.566406 20.070312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(60%,49.019608%,41.176471%)",
      fillOpacity: 1
    },
    d: "M 13.601562 18.886719 C 13.667969 19.007812 13.691406 19.148438 13.667969 19.304688 C 13.613281 19.226562 13.578125 19.132812 13.566406 19.027344 C 13.488281 19.335938 13.546875 19.613281 13.738281 19.859375 C 14.109375 19.917969 14.480469 19.953125 14.851562 19.964844 C 14.953125 19.992188 15.023438 20.050781 15.0625 20.140625 C 14.613281 20.011719 14.148438 19.964844 13.667969 20 C 13.554688 19.984375 13.445312 19.933594 13.355469 19.859375 C 13.257812 19.480469 13.339844 19.15625 13.601562 18.886719 Z M 13.601562 18.886719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(66.666667%,56.470588%,49.411765%)",
      fillOpacity: 1
    },
    d: "M 17.984375 19.304688 C 17.921875 19.296875 17.875 19.320312 17.84375 19.375 C 17.941406 19.558594 17.917969 19.722656 17.773438 19.859375 C 17.785156 19.675781 17.773438 19.488281 17.738281 19.304688 C 17.636719 19.238281 17.625 19.171875 17.703125 19.09375 C 17.796875 19.164062 17.890625 19.234375 17.984375 19.304688 Z M 17.984375 19.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(51.372549%,45.098039%,40.784314%)",
      fillOpacity: 1
    },
    d: "M 8.382812 22.085938 L 8.3125 22.085938 C 8.242188 22.113281 8.21875 22.207031 8.242188 22.363281 C 8.164062 22.171875 8.117188 21.964844 8.105469 21.738281 C 8.242188 21.683594 8.378906 21.671875 8.523438 21.703125 C 8.425781 21.816406 8.378906 21.941406 8.382812 22.085938 Z M 8.382812 22.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(77.254902%,59.607843%,47.843137%)",
      fillOpacity: 1
    },
    d: "M 19.164062 20.554688 C 19.363281 20.789062 19.570312 21.007812 19.792969 21.21875 C 20.089844 21.382812 20.371094 21.582031 20.625 21.808594 C 20.726562 22.148438 20.691406 22.472656 20.523438 22.78125 L 20.523438 21.949219 C 20.367188 21.816406 20.191406 21.707031 20 21.636719 C 19.824219 21.449219 19.640625 21.273438 19.445312 21.113281 C 19.277344 20.964844 19.183594 20.777344 19.164062 20.554688 Z M 19.164062 20.554688 "
  }), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface137",
    mask: "url(#mask44)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(65.490196%,55.294118%,48.627451%)",
      fillOpacity: 1
    },
    d: "M 17.773438 20.207031 C 17.78125 20.277344 17.757812 20.335938 17.703125 20.382812 C 17.421875 20.394531 17.144531 20.429688 16.871094 20.488281 C 17.308594 20.804688 17.773438 21.082031 18.261719 21.320312 C 18.6875 21.492188 19.085938 21.726562 19.445312 22.015625 C 19.617188 22.335938 19.617188 22.636719 19.445312 22.921875 C 19.351562 22.828125 19.261719 22.734375 19.164062 22.644531 C 18.40625 22.328125 17.640625 22.027344 16.871094 21.738281 C 16.882812 21.53125 16.871094 21.320312 16.835938 21.113281 C 16.800781 21.273438 16.789062 21.4375 16.800781 21.601562 C 16.53125 21.484375 16.265625 21.371094 16 21.253906 L 15.929688 21.320312 C 15.921875 21.167969 15.863281 21.039062 15.757812 20.9375 C 15.921875 20.898438 15.992188 20.792969 15.964844 20.625 C 15.855469 20.644531 15.761719 20.621094 15.6875 20.554688 C 15.988281 20.550781 16.269531 20.46875 16.523438 20.3125 C 16.941406 20.296875 17.359375 20.261719 17.773438 20.207031 Z M 17.773438 20.207031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(85.490196%,67.843137%,56.078431%)",
      fillOpacity: 1
    },
    d: "M 16.871094 22.363281 C 15.851562 22.234375 14.832031 22.140625 13.808594 22.085938 C 13.410156 22.101562 13.015625 22.144531 12.625 22.226562 C 13.113281 21.949219 13.644531 21.832031 14.226562 21.878906 L 14.992188 21.914062 C 15.613281 22.078125 16.238281 22.226562 16.871094 22.363281 Z M 16.871094 22.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(79.215686%,67.843137%,60%)",
      fillOpacity: 1
    },
    d: "M 11.234375 21.808594 L 11.234375 22.15625 C 11.832031 22.011719 12.433594 21.894531 13.042969 21.808594 C 13.035156 21.882812 12.988281 21.929688 12.90625 21.949219 C 12.550781 22.03125 12.203125 22.132812 11.859375 22.261719 C 11.558594 22.253906 11.257812 22.242188 10.957031 22.226562 C 10.914062 21.992188 11.007812 21.851562 11.234375 21.808594 Z M 11.234375 21.808594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(62.352941%,48.627451%,39.607843%)",
      fillOpacity: 1
    },
    d: "M 16.871094 22.363281 C 16.9375 22.351562 16.984375 22.375 17.007812 22.433594 C 17.320312 22.625 17.644531 22.785156 17.984375 22.921875 L 17.84375 22.921875 C 16.304688 22.453125 14.726562 22.234375 13.113281 22.261719 C 12.804688 22.40625 12.480469 22.464844 12.140625 22.433594 C 12.257812 22.292969 12.421875 22.222656 12.625 22.226562 C 13.015625 22.144531 13.410156 22.101562 13.808594 22.085938 C 14.832031 22.140625 15.851562 22.234375 16.871094 22.363281 Z M 16.871094 22.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(74.117647%,60.784314%,51.372549%)",
      fillOpacity: 1
    },
    d: "M 17.007812 22.433594 C 17.507812 22.5 17.96875 22.652344 18.398438 22.886719 L 19.027344 22.957031 C 19.121094 23.058594 19.097656 23.117188 18.957031 23.128906 C 18.886719 23.042969 18.78125 22.996094 18.644531 22.992188 C 18.421875 22.964844 18.203125 22.941406 17.984375 22.921875 C 17.644531 22.785156 17.320312 22.625 17.007812 22.433594 Z M 17.007812 22.433594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(90.588235%,78.431373%,69.411765%)",
      fillOpacity: 1
    },
    d: "M 23.128906 21.601562 C 23.222656 21.667969 23.316406 21.738281 23.410156 21.808594 C 23.378906 21.96875 23.425781 22.082031 23.546875 22.15625 L 23.6875 22.433594 C 23.597656 22.40625 23.519531 22.359375 23.445312 22.296875 L 23.339844 22.363281 C 23.5 22.457031 23.59375 22.597656 23.617188 22.78125 C 23.652344 23.050781 23.582031 23.28125 23.410156 23.476562 C 23.078125 23.503906 22.8125 23.386719 22.609375 23.128906 C 22.582031 23.144531 22.570312 23.167969 22.574219 23.199219 L 22.503906 23.199219 L 22.503906 22.992188 C 22.582031 22.542969 22.699219 22.101562 22.851562 21.667969 Z M 23.128906 21.601562 "
  }), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface140",
    mask: "url(#mask45)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(79.607843%,68.235294%,60.392157%)",
      fillOpacity: 1
    },
    d: "M 19.445312 22.015625 C 19.597656 22.054688 19.714844 22.148438 19.792969 22.296875 L 19.859375 22.574219 C 19.8125 22.78125 19.765625 22.992188 19.722656 23.199219 L 19.511719 23.199219 C 19.519531 23.097656 19.496094 23.003906 19.445312 22.921875 C 19.617188 22.636719 19.617188 22.335938 19.445312 22.015625 Z M 19.445312 22.015625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(12.54902%,9.411765%,7.45098%)",
      fillOpacity: 1
    },
    d: "M 17.84375 22.921875 C 18.070312 23.027344 18.300781 23.121094 18.539062 23.199219 C 18.273438 23.367188 18.015625 23.554688 17.773438 23.757812 C 17.386719 23.9375 16.992188 24.101562 16.589844 24.242188 C 15.8125 24.375 15.046875 24.328125 14.296875 24.105469 C 13.5 23.914062 12.804688 23.542969 12.207031 22.992188 C 12.070312 22.820312 11.90625 22.667969 11.722656 22.539062 L 12.140625 22.433594 C 12.480469 22.464844 12.804688 22.40625 13.113281 22.261719 C 14.726562 22.234375 16.304688 22.453125 17.84375 22.921875 Z M 17.84375 22.921875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(96.078431%,96.470588%,96.078431%)",
      fillOpacity: 1
    },
    d: "M 17.078125 23.6875 C 16.777344 23.675781 16.472656 23.6875 16.175781 23.722656 L 16.105469 23.792969 C 16.21875 23.824219 16.335938 23.835938 16.453125 23.824219 C 16.515625 23.875 16.539062 23.945312 16.523438 24.035156 L 16.105469 24.035156 C 15.542969 24.0625 14.984375 24.015625 14.433594 23.894531 C 14.191406 23.894531 14.007812 23.800781 13.878906 23.617188 C 13.980469 23.636719 14.074219 23.613281 14.15625 23.546875 C 13.9375 23.457031 13.699219 23.410156 13.460938 23.410156 L 13.253906 23.410156 C 13.113281 23.339844 12.972656 23.269531 12.835938 23.199219 C 12.765625 23.207031 12.707031 23.183594 12.660156 23.128906 C 12.570312 22.832031 12.648438 22.613281 12.90625 22.46875 C 14.5 22.492188 16.066406 22.734375 17.601562 23.199219 C 17.703125 23.296875 17.691406 23.398438 17.566406 23.511719 C 17.429688 23.644531 17.269531 23.703125 17.078125 23.6875 Z M 17.078125 23.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(9.803922%,7.058824%,5.490196%)",
      fillOpacity: 1
    },
    d: "M 22.503906 22.992188 L 22.503906 23.199219 C 22.480469 23.386719 22.386719 23.527344 22.226562 23.617188 L 21.878906 23.617188 L 21.878906 22.992188 C 21.914062 22.832031 21.9375 22.667969 21.949219 22.503906 L 22.085938 22.363281 C 22.207031 22.285156 22.25 22.332031 22.226562 22.503906 L 22.503906 22.503906 C 22.429688 22.671875 22.429688 22.832031 22.503906 22.992188 Z M 22.503906 22.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(19.607843%,12.54902%,9.019608%)",
      fillOpacity: 1
    },
    d: "M 17.84375 22.921875 L 17.984375 22.921875 C 18.203125 22.941406 18.421875 22.964844 18.644531 22.992188 C 18.78125 22.996094 18.886719 23.042969 18.957031 23.128906 L 18.539062 23.199219 C 18.300781 23.121094 18.070312 23.027344 17.84375 22.921875 Z M 17.84375 22.921875 "
  }), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface143",
    mask: "url(#mask46)"
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface146",
    mask: "url(#mask47)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(44.705882%,43.921569%,43.921569%)",
      fillOpacity: 1
    },
    d: "M 12.835938 23.199219 C 12.972656 23.269531 13.113281 23.339844 13.253906 23.410156 C 13.054688 23.441406 12.917969 23.371094 12.835938 23.199219 Z M 12.835938 23.199219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(51.372549%,50.588235%,50.588235%)",
      fillOpacity: 1
    },
    d: "M 13.460938 23.410156 C 13.699219 23.410156 13.9375 23.457031 14.15625 23.546875 C 14.074219 23.613281 13.980469 23.636719 13.878906 23.617188 C 13.75 23.527344 13.609375 23.457031 13.460938 23.410156 Z M 13.460938 23.410156 "
  }), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface149",
    mask: "url(#mask48)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(66.666667%,66.27451%,66.666667%)",
      fillOpacity: 1
    },
    d: "M 17.078125 23.6875 L 16.453125 23.824219 C 16.335938 23.835938 16.21875 23.824219 16.105469 23.792969 L 16.175781 23.722656 C 16.472656 23.6875 16.777344 23.675781 17.078125 23.6875 Z M 17.078125 23.6875 "
  }), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface152",
    mask: "url(#mask49)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(49.411765%,36.862745%,27.843137%)",
      fillOpacity: 1
    },
    d: "M 8.589844 21.253906 L 8.660156 21.253906 C 8.648438 21.460938 8.660156 21.671875 8.695312 21.878906 C 8.773438 22.078125 8.820312 22.289062 8.835938 22.503906 C 9.007812 22.75 9.089844 23.027344 9.078125 23.339844 C 9.199219 23.980469 9.371094 24.609375 9.601562 25.21875 L 9.667969 25.007812 C 9.703125 25.121094 9.714844 25.238281 9.703125 25.355469 C 9.652344 25.410156 9.617188 25.480469 9.601562 25.566406 C 9.570312 25.367188 9.5 25.175781 9.390625 25.007812 C 9.363281 25.039062 9.328125 25.0625 9.285156 25.078125 C 9.234375 24.847656 9.1875 24.613281 9.148438 24.382812 C 9.160156 24.34375 9.1875 24.308594 9.21875 24.277344 C 9.050781 23.976562 8.910156 23.664062 8.800781 23.339844 C 8.6875 22.949219 8.59375 22.554688 8.523438 22.15625 C 8.476562 22.132812 8.429688 22.109375 8.382812 22.085938 C 8.378906 21.941406 8.425781 21.816406 8.523438 21.703125 C 8.378906 21.671875 8.242188 21.683594 8.105469 21.738281 C 8.058594 21.738281 8.035156 21.714844 8.035156 21.667969 C 8.214844 21.617188 8.402344 21.59375 8.589844 21.601562 Z M 8.589844 21.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(36.078431%,29.803922%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 21.878906 23.617188 L 22.226562 23.617188 C 22.128906 23.878906 22.011719 24.136719 21.878906 24.382812 C 21.886719 24.332031 21.875 24.28125 21.84375 24.242188 C 21.757812 24.449219 21.652344 24.632812 21.53125 24.800781 C 21.488281 24.488281 21.605469 24.277344 21.878906 24.175781 C 21.875 24.027344 21.921875 23.898438 22.015625 23.792969 C 21.980469 23.722656 21.933594 23.664062 21.878906 23.617188 Z M 21.878906 23.617188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(87.45098%,67.45098%,54.509804%)",
      fillOpacity: 1
    },
    d: "M 12.207031 22.992188 C 12.804688 23.542969 13.5 23.914062 14.296875 24.105469 C 14.28125 24.1875 14.304688 24.253906 14.363281 24.3125 C 14.929688 24.511719 15.507812 24.570312 16.105469 24.488281 C 16.296875 24.449219 16.460938 24.371094 16.589844 24.242188 C 16.992188 24.101562 17.386719 23.9375 17.773438 23.757812 C 17.179688 24.292969 16.507812 24.722656 15.757812 25.042969 C 15.332031 25.101562 14.914062 25.082031 14.503906 24.972656 C 13.941406 24.652344 13.425781 24.253906 12.972656 23.792969 C 12.910156 23.757812 12.835938 23.746094 12.765625 23.757812 C 12.777344 23.664062 12.753906 23.582031 12.695312 23.511719 C 12.375 23.484375 12.214844 23.308594 12.207031 22.992188 Z M 12.207031 22.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(64.705882%,49.019608%,38.431373%)",
      fillOpacity: 1
    },
    d: "M 14.296875 24.105469 C 15.046875 24.328125 15.8125 24.375 16.589844 24.242188 C 16.460938 24.371094 16.296875 24.449219 16.105469 24.488281 C 15.507812 24.570312 14.929688 24.511719 14.363281 24.3125 C 14.304688 24.253906 14.28125 24.1875 14.296875 24.105469 Z M 14.296875 24.105469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(50.980392%,49.803922%,49.803922%)",
      fillOpacity: 1
    },
    d: "M 14.433594 23.894531 C 14.984375 24.015625 15.542969 24.0625 16.105469 24.035156 C 15.699219 24.113281 15.28125 24.125 14.851562 24.070312 C 14.679688 24.066406 14.539062 24.007812 14.433594 23.894531 Z M 14.433594 23.894531 "
  }), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface155",
    mask: "url(#mask50)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(86.666667%,69.019608%,57.647059%)",
      fillOpacity: 1
    },
    d: "M 13.460938 25.21875 C 13.09375 25.167969 13.09375 25.226562 13.460938 25.390625 C 13.515625 25.46875 13.5625 25.546875 13.601562 25.636719 C 13.5 25.617188 13.429688 25.558594 13.390625 25.460938 C 12.976562 25.402344 12.742188 25.183594 12.695312 24.800781 C 12.960938 24.921875 13.214844 25.058594 13.460938 25.21875 Z M 13.460938 25.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(69.803922%,53.333333%,42.745098%)",
      fillOpacity: 1
    },
    d: "M 9.078125 23.339844 C 9.152344 23.347656 9.199219 23.394531 9.21875 23.476562 L 9.320312 23.894531 C 9.367188 23.988281 9.414062 23.988281 9.460938 23.894531 L 9.53125 24.453125 L 9.601562 24.175781 C 9.6875 24.371094 9.789062 24.554688 9.914062 24.730469 C 9.953125 24.894531 10 25.058594 10.050781 25.21875 C 10.28125 25.378906 10.429688 25.589844 10.503906 25.84375 L 10.714844 25.773438 C 10.753906 25.886719 10.789062 26.003906 10.816406 26.121094 C 10.773438 26.359375 10.691406 26.589844 10.574219 26.816406 C 10.515625 26.628906 10.445312 26.441406 10.363281 26.261719 L 10.296875 26.398438 C 9.988281 26.042969 9.824219 25.628906 9.808594 25.148438 C 9.792969 25.257812 9.757812 25.347656 9.703125 25.425781 L 9.703125 25.355469 C 9.714844 25.238281 9.703125 25.121094 9.667969 25.007812 L 9.601562 25.21875 C 9.371094 24.609375 9.199219 23.980469 9.078125 23.339844 Z M 9.078125 23.339844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(61.960784%,48.627451%,39.607843%)",
      fillOpacity: 1
    },
    d: "M 13.460938 25.21875 C 13.621094 25.25 13.761719 25.320312 13.878906 25.425781 C 13.828125 25.417969 13.777344 25.429688 13.738281 25.460938 C 13.84375 25.832031 14.074219 26.074219 14.433594 26.191406 L 14.015625 26.191406 C 13.855469 26.074219 13.785156 25.914062 13.808594 25.703125 C 13.71875 25.722656 13.648438 25.699219 13.601562 25.636719 C 13.5625 25.546875 13.515625 25.46875 13.460938 25.390625 C 13.09375 25.226562 13.09375 25.167969 13.460938 25.21875 Z M 13.460938 25.21875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(60.784314%,45.882353%,36.078431%)",
      fillOpacity: 1
    },
    d: "M 21.601562 23.964844 C 21.46875 24.273438 21.386719 24.597656 21.355469 24.9375 C 21.167969 25.105469 21.054688 25.3125 21.007812 25.566406 L 20.9375 25.636719 L 20.871094 25.425781 C 20.652344 25.746094 20.398438 26.09375 20.105469 26.46875 L 20.035156 26.398438 C 20.015625 26.464844 19.980469 26.511719 19.929688 26.539062 C 19.917969 26.398438 19.929688 26.257812 19.964844 26.121094 C 20.035156 26.0625 20.117188 26.039062 20.207031 26.050781 L 20.207031 25.84375 C 20.417969 25.632812 20.605469 25.398438 20.765625 25.148438 C 20.914062 24.929688 21.074219 24.71875 21.253906 24.523438 C 21.269531 24.269531 21.382812 24.082031 21.601562 23.964844 Z M 21.601562 23.964844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(38.823529%,30.980392%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 8.3125 22.085938 L 8.382812 22.085938 C 8.429688 22.109375 8.472656 22.132812 8.523438 22.15625 C 8.59375 22.554688 8.6875 22.949219 8.800781 23.339844 C 8.910156 23.664062 9.050781 23.976562 9.21875 24.277344 C 9.1875 24.308594 9.160156 24.34375 9.148438 24.382812 C 9.1875 24.613281 9.234375 24.847656 9.285156 25.078125 C 9.328125 25.0625 9.363281 25.039062 9.390625 25.007812 C 9.5 25.175781 9.570312 25.367188 9.601562 25.566406 C 9.617188 25.480469 9.652344 25.410156 9.703125 25.355469 L 9.703125 25.425781 C 9.691406 25.566406 9.703125 25.707031 9.738281 25.84375 C 9.917969 26.042969 10.050781 26.28125 10.121094 26.539062 C 10.007812 26.449219 9.890625 26.355469 9.773438 26.261719 C 9.558594 25.898438 9.359375 25.527344 9.183594 25.148438 C 8.890625 24.125 8.601562 23.105469 8.3125 22.085938 Z M 8.3125 22.085938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(23.529412%,15.294118%,9.803922%)",
      fillOpacity: 1
    },
    d: "M 14.015625 25.496094 L 14.296875 25.496094 C 14.347656 25.550781 14.417969 25.582031 14.503906 25.601562 C 15.011719 25.644531 15.527344 25.644531 16.035156 25.601562 C 16.121094 25.582031 16.191406 25.550781 16.242188 25.496094 L 16.3125 25.496094 C 16.375 25.488281 16.421875 25.507812 16.453125 25.566406 C 16.339844 25.628906 16.222656 25.6875 16.105469 25.738281 C 16.046875 25.808594 16.023438 25.890625 16.035156 25.984375 L 15.894531 25.984375 C 15.449219 25.867188 14.984375 25.789062 14.503906 25.738281 C 14.316406 25.6875 14.15625 25.605469 14.015625 25.496094 Z M 14.015625 25.496094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(68.235294%,60%,54.509804%)",
      fillOpacity: 1
    },
    d: "M 14.296875 25.496094 C 14.941406 25.582031 15.597656 25.582031 16.242188 25.496094 C 16.191406 25.550781 16.121094 25.582031 16.035156 25.601562 C 15.527344 25.644531 15.011719 25.644531 14.503906 25.601562 C 14.417969 25.582031 14.347656 25.550781 14.296875 25.496094 Z M 14.296875 25.496094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(77.647059%,63.137255%,53.333333%)",
      fillOpacity: 1
    },
    d: "M 16.035156 25.984375 C 16.023438 25.890625 16.046875 25.808594 16.105469 25.738281 C 16.222656 25.6875 16.339844 25.628906 16.453125 25.566406 C 16.421875 25.507812 16.375 25.488281 16.3125 25.496094 C 16.382812 25.4375 16.449219 25.378906 16.523438 25.320312 C 16.773438 25.25 17.027344 25.203125 17.285156 25.183594 C 16.890625 25.480469 16.472656 25.746094 16.035156 25.984375 Z M 16.035156 25.984375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(40%,31.372549%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 13.878906 25.425781 C 13.949219 25.414062 13.992188 25.4375 14.015625 25.496094 C 14.15625 25.605469 14.316406 25.6875 14.503906 25.738281 C 14.984375 25.789062 15.449219 25.867188 15.894531 25.984375 L 15.894531 26.121094 C 15.722656 26.195312 15.558594 26.289062 15.410156 26.398438 C 15.203125 26.335938 14.992188 26.335938 14.78125 26.398438 L 14.433594 26.398438 L 14.433594 26.191406 C 14.074219 26.074219 13.84375 25.832031 13.738281 25.460938 C 13.777344 25.429688 13.828125 25.417969 13.878906 25.425781 Z M 13.878906 25.425781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(46.666667%,34.901961%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 10.816406 26.121094 C 10.832031 26.230469 10.878906 26.324219 10.957031 26.398438 C 10.902344 26.476562 10.867188 26.570312 10.851562 26.679688 L 10.78125 26.609375 L 10.714844 26.957031 C 10.621094 26.925781 10.519531 26.925781 10.398438 26.957031 C 10.273438 26.84375 10.179688 26.703125 10.121094 26.539062 C 10.050781 26.28125 9.917969 26.042969 9.738281 25.84375 C 9.703125 25.707031 9.691406 25.566406 9.703125 25.425781 C 9.757812 25.347656 9.792969 25.257812 9.808594 25.148438 C 9.824219 25.628906 9.988281 26.042969 10.296875 26.398438 L 10.363281 26.261719 C 10.445312 26.441406 10.515625 26.628906 10.574219 26.816406 C 10.691406 26.589844 10.773438 26.359375 10.816406 26.121094 Z M 10.816406 26.121094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(44.313725%,34.509804%,27.45098%)",
      fillOpacity: 1
    },
    d: "M 21.878906 22.992188 L 21.878906 23.617188 C 21.933594 23.664062 21.980469 23.722656 22.015625 23.792969 C 21.921875 23.898438 21.875 24.027344 21.878906 24.175781 C 21.605469 24.277344 21.488281 24.488281 21.53125 24.800781 C 21.542969 24.871094 21.527344 24.945312 21.496094 25.007812 C 21.023438 25.621094 20.605469 26.273438 20.242188 26.957031 C 19.953125 27.328125 19.59375 27.605469 19.164062 27.792969 C 19.226562 27.65625 19.320312 27.542969 19.445312 27.445312 C 19.5 27.335938 19.523438 27.214844 19.511719 27.09375 C 19.601562 26.890625 19.742188 26.726562 19.929688 26.609375 L 19.929688 26.539062 C 19.980469 26.511719 20.015625 26.464844 20.035156 26.398438 L 20.105469 26.46875 C 20.398438 26.09375 20.652344 25.746094 20.871094 25.425781 L 20.9375 25.636719 L 21.007812 25.566406 C 21.054688 25.3125 21.167969 25.105469 21.355469 24.9375 C 21.386719 24.597656 21.46875 24.273438 21.601562 23.964844 C 21.738281 23.648438 21.828125 23.324219 21.878906 22.992188 Z M 21.878906 22.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(63.137255%,52.941176%,45.882353%)",
      fillOpacity: 1
    },
    d: "M 15.894531 26.121094 C 15.8125 26.292969 15.695312 26.429688 15.546875 26.539062 L 15.199219 26.539062 C 14.949219 27.027344 14.808594 26.980469 14.78125 26.398438 C 14.992188 26.335938 15.203125 26.335938 15.410156 26.398438 C 15.558594 26.289062 15.722656 26.195312 15.894531 26.121094 Z M 15.894531 26.121094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(78.039216%,66.666667%,58.823529%)",
      fillOpacity: 1
    },
    d: "M 14.015625 26.191406 L 14.433594 26.191406 L 14.433594 26.398438 L 14.78125 26.398438 C 14.808594 26.980469 14.949219 27.027344 15.199219 26.539062 L 15.546875 26.539062 L 15.546875 26.957031 C 15.113281 26.996094 14.695312 26.9375 14.296875 26.78125 C 14.136719 26.617188 14.042969 26.417969 14.015625 26.191406 Z M 14.015625 26.191406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(63.921569%,51.372549%,42.352941%)",
      fillOpacity: 1
    },
    d: "M 19.929688 26.609375 C 19.742188 26.726562 19.601562 26.890625 19.511719 27.09375 L 19.234375 27.234375 C 19.324219 26.964844 19.476562 26.734375 19.6875 26.539062 C 19.734375 26.726562 19.78125 26.726562 19.824219 26.539062 C 19.851562 26.578125 19.886719 26.601562 19.929688 26.609375 Z M 19.929688 26.609375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(80.392157%,68.627451%,60.392157%)",
      fillOpacity: 1
    },
    d: "M 20.207031 25.84375 L 20.207031 26.050781 C 20.117188 26.039062 20.035156 26.0625 19.964844 26.121094 C 19.929688 26.257812 19.917969 26.398438 19.929688 26.539062 L 19.929688 26.609375 C 19.886719 26.601562 19.851562 26.578125 19.824219 26.539062 C 19.78125 26.726562 19.734375 26.726562 19.6875 26.539062 C 19.476562 26.734375 19.324219 26.964844 19.234375 27.234375 C 19.167969 27.09375 19.074219 26.980469 18.957031 26.886719 C 19.082031 26.472656 19.175781 26.449219 19.234375 26.816406 C 19.382812 26.75 19.464844 26.632812 19.476562 26.46875 C 19.71875 26.257812 19.960938 26.046875 20.207031 25.84375 Z M 20.207031 25.84375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(35.294118%,27.45098%,21.568627%)",
      fillOpacity: 1
    },
    d: "M 10.957031 26.398438 C 11 26.460938 11.023438 26.53125 11.027344 26.609375 C 10.984375 26.625 10.960938 26.660156 10.957031 26.714844 C 11.074219 27.023438 11.152344 27.335938 11.199219 27.652344 C 10.878906 27.476562 10.613281 27.242188 10.398438 26.957031 C 10.519531 26.925781 10.621094 26.925781 10.714844 26.957031 L 10.78125 26.609375 L 10.851562 26.679688 C 10.867188 26.570312 10.902344 26.476562 10.957031 26.398438 Z M 10.957031 26.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(50.588235%,39.607843%,31.372549%)",
      fillOpacity: 1
    },
    d: "M 18.957031 26.886719 C 19.074219 26.980469 19.167969 27.09375 19.234375 27.234375 L 19.511719 27.09375 C 19.523438 27.214844 19.5 27.335938 19.445312 27.445312 C 19.320312 27.542969 19.226562 27.65625 19.164062 27.792969 L 19.09375 27.792969 C 19.03125 27.691406 19.007812 27.578125 19.027344 27.445312 C 18.910156 27.441406 18.820312 27.488281 18.746094 27.582031 C 18.671875 27.519531 18.671875 27.449219 18.746094 27.375 C 18.714844 27.320312 18.667969 27.296875 18.609375 27.304688 C 18.746094 27.179688 18.863281 27.039062 18.957031 26.886719 Z M 18.957031 26.886719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(34.509804%,27.843137%,23.529412%)",
      fillOpacity: 1
    },
    d: "M 18.609375 27.304688 C 18.667969 27.296875 18.714844 27.320312 18.746094 27.375 C 18.671875 27.449219 18.671875 27.519531 18.746094 27.582031 C 18.820312 27.488281 18.910156 27.441406 19.027344 27.445312 C 19.007812 27.578125 19.03125 27.691406 19.09375 27.792969 C 18.910156 28.011719 18.679688 28.1875 18.398438 28.3125 C 18.4375 28.34375 18.488281 28.359375 18.539062 28.347656 C 18.246094 28.527344 17.945312 28.691406 17.636719 28.835938 C 17.933594 28.40625 18.246094 27.988281 18.574219 27.582031 C 18.609375 27.492188 18.574219 27.445312 18.46875 27.445312 C 18.492188 27.375 18.539062 27.328125 18.609375 27.304688 Z M 18.609375 27.304688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(72.941176%,62.352941%,54.901961%)",
      fillOpacity: 1
    },
    d: "M 11.234375 26.746094 C 11.5 26.941406 11.757812 27.152344 12 27.375 C 13.246094 27.929688 14.566406 28.183594 15.964844 28.140625 L 15.964844 28.347656 C 15.851562 28.347656 15.757812 28.304688 15.6875 28.207031 C 15.640625 28.246094 15.601562 28.292969 15.582031 28.347656 C 15.535156 28.273438 15.464844 28.226562 15.375 28.207031 C 15.242188 28.238281 15.113281 28.285156 14.992188 28.347656 C 14.910156 28.324219 14.851562 28.28125 14.816406 28.207031 C 14.746094 28.289062 14.65625 28.335938 14.539062 28.347656 C 14.289062 28.292969 14.042969 28.269531 13.808594 28.277344 C 13.691406 28.378906 13.636719 28.519531 13.636719 28.695312 C 13.601562 28.535156 13.589844 28.371094 13.601562 28.207031 L 13.390625 28.207031 C 13.410156 28.332031 13.386719 28.449219 13.320312 28.554688 C 13.246094 28.289062 13.1875 28.289062 13.148438 28.554688 L 13.078125 28.140625 C 13.042969 28.371094 13.03125 28.601562 13.042969 28.835938 C 12.996094 28.835938 12.972656 28.8125 12.972656 28.765625 L 12.972656 28.070312 C 12.875 28.074219 12.777344 28.050781 12.695312 28 C 12.632812 28.082031 12.609375 28.175781 12.625 28.277344 C 12.484375 28.277344 12.34375 28.253906 12.207031 28.207031 C 11.796875 27.78125 11.472656 27.292969 11.234375 26.746094 Z M 11.234375 26.746094 "
  }), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface158",
    mask: "url(#mask51)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(67.058824%,56.470588%,49.411765%)",
      fillOpacity: 1
    },
    d: "M 15.964844 28.347656 L 16.175781 28.347656 C 16.183594 28.535156 16.171875 28.722656 16.140625 28.90625 L 16.070312 28.835938 C 15.945312 29.101562 15.851562 29.125 15.792969 28.90625 C 15.675781 29.035156 15.546875 29.058594 15.410156 28.972656 C 15.304688 28.988281 15.207031 29.035156 15.128906 29.113281 C 15.058594 28.941406 15 28.941406 14.957031 29.113281 C 14.929688 29.050781 14.894531 28.992188 14.851562 28.9375 C 14.742188 28.921875 14.636719 28.886719 14.539062 28.835938 L 14.46875 28.90625 C 14.273438 28.859375 14.078125 28.816406 13.878906 28.765625 C 13.816406 28.609375 13.792969 28.445312 13.808594 28.277344 C 14.042969 28.269531 14.289062 28.292969 14.539062 28.347656 C 14.65625 28.335938 14.746094 28.289062 14.816406 28.207031 C 14.851562 28.28125 14.910156 28.324219 14.992188 28.347656 C 15.113281 28.285156 15.242188 28.238281 15.375 28.207031 C 15.464844 28.226562 15.535156 28.273438 15.582031 28.347656 C 15.601562 28.292969 15.640625 28.246094 15.6875 28.207031 C 15.757812 28.304688 15.851562 28.347656 15.964844 28.347656 Z M 15.964844 28.347656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(62.745098%,53.333333%,46.666667%)",
      fillOpacity: 1
    },
    d: "M 18.46875 27.445312 L 18.363281 27.652344 C 17.859375 28.019531 17.410156 28.449219 17.007812 28.9375 C 16.945312 28.972656 16.871094 28.984375 16.800781 28.972656 C 16.652344 28.890625 16.488281 28.832031 16.3125 28.800781 C 16.273438 28.648438 16.226562 28.496094 16.175781 28.347656 C 16.578125 28.285156 16.949219 28.144531 17.285156 27.929688 C 17.675781 27.757812 18.070312 27.597656 18.46875 27.445312 Z M 18.46875 27.445312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(60.392157%,48.627451%,40.784314%)",
      fillOpacity: 1
    },
    d: "M 12.972656 28.765625 C 12.890625 28.714844 12.796875 28.691406 12.695312 28.695312 C 12.511719 28.554688 12.347656 28.394531 12.207031 28.207031 C 12.34375 28.253906 12.484375 28.277344 12.625 28.277344 C 12.609375 28.175781 12.632812 28.082031 12.695312 28 C 12.777344 28.050781 12.875 28.074219 12.972656 28.070312 Z M 12.972656 28.765625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(78.039216%,67.45098%,60%)",
      fillOpacity: 1
    },
    d: "M 17.285156 27.929688 C 16.949219 28.144531 16.578125 28.285156 16.175781 28.347656 L 16.035156 28.347656 L 16.035156 28.070312 C 16.449219 28.007812 16.867188 27.960938 17.285156 27.929688 Z M 17.285156 27.929688 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(36.470588%,28.235294%,23.137255%)",
      fillOpacity: 1
    },
    d: "M 12.695312 28.695312 C 12.796875 28.691406 12.890625 28.714844 12.972656 28.765625 C 12.972656 28.8125 12.996094 28.835938 13.042969 28.835938 C 13.265625 28.972656 13.496094 29.019531 13.738281 28.972656 C 13.878906 29.167969 14.054688 29.214844 14.261719 29.113281 C 14.683594 29.203125 15.117188 29.25 15.546875 29.253906 C 15.304688 29.296875 15.050781 29.320312 14.78125 29.320312 C 13.976562 29.40625 13.28125 29.199219 12.695312 28.695312 Z M 12.695312 28.695312 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(54.901961%,43.529412%,35.686275%)",
      fillOpacity: 1
    },
    d: "M 13.808594 28.277344 C 13.792969 28.445312 13.816406 28.609375 13.878906 28.765625 C 14.078125 28.816406 14.273438 28.859375 14.46875 28.90625 L 14.539062 28.835938 C 14.636719 28.886719 14.742188 28.921875 14.851562 28.9375 C 14.894531 28.992188 14.929688 29.050781 14.957031 29.113281 C 15 28.941406 15.058594 28.941406 15.128906 29.113281 C 15.207031 29.035156 15.304688 28.988281 15.410156 28.972656 C 15.546875 29.058594 15.675781 29.035156 15.792969 28.90625 C 15.851562 29.125 15.945312 29.101562 16.070312 28.835938 L 16.140625 28.90625 C 16.171875 28.71875 16.183594 28.535156 16.175781 28.347656 C 16.226562 28.496094 16.273438 28.648438 16.3125 28.800781 C 16.488281 28.832031 16.652344 28.890625 16.800781 28.972656 C 16.546875 29.0625 16.292969 29.140625 16.035156 29.21875 C 15.875 29.253906 15.710938 29.261719 15.546875 29.253906 C 15.117188 29.25 14.683594 29.203125 14.261719 29.113281 C 14.054688 29.214844 13.878906 29.167969 13.738281 28.972656 C 13.496094 29.019531 13.265625 28.972656 13.042969 28.835938 C 13.03125 28.601562 13.042969 28.371094 13.078125 28.140625 L 13.148438 28.554688 C 13.1875 28.289062 13.246094 28.289062 13.320312 28.554688 C 13.386719 28.449219 13.410156 28.332031 13.390625 28.207031 L 13.601562 28.207031 C 13.589844 28.371094 13.601562 28.535156 13.636719 28.695312 C 13.636719 28.519531 13.691406 28.378906 13.808594 28.277344 Z M 13.808594 28.277344 "
  }), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface161",
    mask: "url(#mask52)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosheRemovebgPreviewMin32);
export default __webpack_public_path__ + "static/media/moshe-removebg-preview-min-32.304ebb138872c57d7b433fc74d31866a.svg";
export { ForwardRef as ReactComponent };